(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals"], factory);
	else if(typeof exports === 'object')
		exports["GigCards"] = factory(require("@fiverr/globals"));
	else
		root["GigCards"] = factory(root["@fiverr/globals"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/gig_card/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fEuR");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0wUK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3IRH":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "5WN7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__("ar93");

var ReactElement = __webpack_require__("W2D2");

var invariant = __webpack_require__("cxPT");

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),

/***/ "8iJM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),

/***/ "9QEA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9SWq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("ar93");

var invariant = __webpack_require__("cxPT");

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),

/***/ "BEQ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "C4SN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CO2B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__("YyeZ");

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),

/***/ "CqLJ":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

(function(global) {
  'use strict';

  var dateFormat = (function() {
      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
      var timezoneClip = /[^-+\dA-Z]/g;
  
      // Regexes and supporting functions are cached through closure
      return function (date, mask, utc, gmt) {
  
        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
          mask = date;
          date = undefined;
        }
  
        date = date || new Date;
  
        if(!(date instanceof Date)) {
          date = new Date(date);
        }
  
        if (isNaN(date)) {
          throw TypeError('Invalid date');
        }
  
        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
  
        // Allow setting the utc/gmt argument via the mask
        var maskSlice = mask.slice(0, 4);
        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
          mask = mask.slice(4);
          utc = true;
          if (maskSlice === 'GMT:') {
            gmt = true;
          }
        }
  
        var _ = utc ? 'getUTC' : 'get';
        var d = date[_ + 'Date']();
        var D = date[_ + 'Day']();
        var m = date[_ + 'Month']();
        var y = date[_ + 'FullYear']();
        var H = date[_ + 'Hours']();
        var M = date[_ + 'Minutes']();
        var s = date[_ + 'Seconds']();
        var L = date[_ + 'Milliseconds']();
        var o = utc ? 0 : date.getTimezoneOffset();
        var W = getWeek(date);
        var N = getDayOfWeek(date);
        var flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dateFormat.i18n.dayNames[D],
          dddd: dateFormat.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dateFormat.i18n.monthNames[m],
          mmmm: dateFormat.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(Math.round(L / 10)),
          t:    H < 12 ? 'a'  : 'p',
          tt:   H < 12 ? 'am' : 'pm',
          T:    H < 12 ? 'A'  : 'P',
          TT:   H < 12 ? 'AM' : 'PM',
          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
          W:    W,
          N:    N
        };
  
        return mask.replace(token, function (match) {
          if (match in flags) {
            return flags[match];
          }
          return match.slice(1, match.length - 1);
        });
      };
    })();

  dateFormat.masks = {
    'default':               'ddd mmm dd yyyy HH:MM:ss',
    'shortDate':             'm/d/yy',
    'mediumDate':            'mmm d, yyyy',
    'longDate':              'mmmm d, yyyy',
    'fullDate':              'dddd, mmmm d, yyyy',
    'shortTime':             'h:MM TT',
    'mediumTime':            'h:MM:ss TT',
    'longTime':              'h:MM:ss TT Z',
    'isoDate':               'yyyy-mm-dd',
    'isoTime':               'HH:MM:ss',
    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
    ],
    monthNames: [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ]
  };

function pad(val, len) {
  val = String(val);
  len = len || 2;
  while (val.length < len) {
    val = '0' + val;
  }
  return val;
}

/**
 * Get the ISO 8601 week number
 * Based on comments from
 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
 *
 * @param  {Object} `date`
 * @return {Number}
 */
function getWeek(date) {
  // Remove time components of date
  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  // Change date to Thursday same week
  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);

  // Take January 4th as it is always in week 1 (see ISO 8601)
  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);

  // Change date to Thursday same week
  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);

  // Check if daylight-saving-time-switch occurred and correct for it
  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
  targetThursday.setHours(targetThursday.getHours() - ds);

  // Number of weeks between target Thursday and first Thursday
  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
  return 1 + Math.floor(weekDiff);
}

/**
 * Get ISO-8601 numeric representation of the day of the week
 * 1 (for Monday) through 7 (for Sunday)
 * 
 * @param  {Object} `date`
 * @return {Number}
 */
function getDayOfWeek(date) {
  var dow = date.getDay();
  if(dow === 0) {
    dow = 7;
  }
  return dow;
}

/**
 * kind-of shortcut
 * @param  {*} val
 * @return {String}
 */
function kindOf(val) {
  if (val === null) {
    return 'null';
  }

  if (val === undefined) {
    return 'undefined';
  }

  if (typeof val !== 'object') {
    return typeof val;
  }

  if (Array.isArray(val)) {
    return 'array';
  }

  return {}.toString.call(val)
    .slice(8, -1).toLowerCase();
};



  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return dateFormat;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = dateFormat;
  } else {
    global.dateFormat = dateFormat;
  }
})(this);


/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "E4I8":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_E4I8__;

/***/ }),

/***/ "G1ow":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("BEQ0");

var ReactBaseClasses = __webpack_require__("O6dE");
var ReactChildren = __webpack_require__("LTDs");
var ReactDOMFactories = __webpack_require__("vUzd");
var ReactElement = __webpack_require__("W2D2");
var ReactPropTypes = __webpack_require__("S+kE");
var ReactVersion = __webpack_require__("GjCS");

var createReactClass = __webpack_require__("JYGa");
var onlyChild = __webpack_require__("5WN7");

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),

/***/ "GjCS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),

/***/ "HK0U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HW6M":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "Hhlq":
/***/ (function(module, exports) {

module.exports=function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=0)}([function(t,e,r){"use strict";var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=r(1),u=Object.seal(["string","number"]);t.exports=function(){for(var t=arguments.length,e=Array(t),r=0;r<t;r++)e[r]=arguments[r];return function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",r=arguments[1];if("string"!=typeof t)throw new TypeError("paraphrase expects first argument to be a string, got a "+(void 0===t?"undefined":n(t)));if(!r)return t;if(u.includes(void 0===r?"undefined":n(r))){for(var i=arguments.length,f=Array(i>2?i-2:0),c=2;c<i;c++)f[c-2]=arguments[c];r=[r].concat(f)}function l(t,e){var i=o(r,e.trim());return u.includes(void 0===i?"undefined":n(i))?i:t}return e.reduce(function(t,e){return t.replace(e,l)},t)}}},function(t,e,r){"use strict";var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};t.exports=function(t){return(arguments.length>1&&void 0!==arguments[1]?arguments[1]:"").split(".").reduce(function(t,e){return"object"===(void 0===t?"undefined":n(t))?t[e]:t},t)}}]);

/***/ }),

/***/ "Ie6m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          )

        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),

/***/ "JYGa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__("O6dE"),
    Component = _require.Component;

var _require2 = __webpack_require__("W2D2"),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__("CO2B");
var factory = __webpack_require__("wqO5");

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),

/***/ "JtmH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var assign = __webpack_require__("BEQ0");

var ReactPropTypesSecret = __webpack_require__("gt/O");
var checkPropTypes = __webpack_require__("Ie6m");

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "KKHy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),

/***/ "KSGD":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("Q4WQ")();
}


/***/ }),

/***/ "KhmI":
/***/ (function(module, exports) {

/**
 * Return a clone for JSON complaint objects, an empty object otherwise
 * @param  {Object} object
 * @return {Object}
 */
module.exports = function jsonclone(object) {
    try {
        return JSON.parse(JSON.stringify(object));
    } catch (e) {
        return {};
    }
};

/***/ }),

/***/ "LTDs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__("9SWq");
var ReactElement = __webpack_require__("W2D2");

var emptyFunction = __webpack_require__("e6+Q");
var traverseAllChildren = __webpack_require__("MryT");

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),

/***/ "LlhT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MryT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("ar93");

var ReactCurrentOwner = __webpack_require__("kvXm");
var REACT_ELEMENT_TYPE = __webpack_require__("KKHy");

var getIteratorFn = __webpack_require__("8iJM");
var invariant = __webpack_require__("cxPT");
var KeyEscapeUtils = __webpack_require__("pV5o");
var warning = __webpack_require__("YyeZ");

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),

/***/ "NYAQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O6dE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("ar93"),
    _assign = __webpack_require__("BEQ0");

var ReactNoopUpdateQueue = __webpack_require__("CO2B");

var canDefineProperty = __webpack_require__("RFlT");
var emptyObject = __webpack_require__("TJez");
var invariant = __webpack_require__("cxPT");
var lowPriorityWarning = __webpack_require__("bVsJ");

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),

/***/ "Q4WQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("gt/O");

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "RFlT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),

/***/ "Repj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S+kE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__("W2D2"),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__("fQuc");

module.exports = factory(isValidElement);

/***/ }),

/***/ "TJez":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),

/***/ "TxmA":
/***/ (function(module, exports) {

module.exports = function deepFreeze (o) {
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o.hasOwnProperty(prop)
    && o[prop] !== null
    && (typeof o[prop] === "object" || typeof o[prop] === "function")
    && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  
  return o;
};


/***/ }),

/***/ "U7vG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("G1ow");


/***/ }),

/***/ "UCFI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W2D2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("BEQ0");

var ReactCurrentOwner = __webpack_require__("kvXm");

var warning = __webpack_require__("YyeZ");
var canDefineProperty = __webpack_require__("RFlT");
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__("KKHy");

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),

/***/ "W2uZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WOeT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YyeZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__("e6+Q");

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "ZpHc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ar93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),

/***/ "bQni":
/***/ (function(module, exports, __webpack_require__) {

/*
  WeakMap where key (object) is mapped to an array.
  Removing last item from an array removes the key from the map.
 */


/*jshint -W079 */
var WeakMap = __webpack_require__("lP53");

var ArrayWeakMap = function() {

  this._weakMap = new WeakMap();

  this.has = function(mapKey) {
    return this._weakMap.has(mapKey);
  };

  this.addArrayItem = function(mapKey, item) {
    if (this._weakMap.has(mapKey)) {
      this._weakMap.get(mapKey).push(item);
    }
    else {
      this._weakMap.set(mapKey, [item]);
    }
  };

  this.removeArrayItem = function(mapKey, item) {
    if (!this._weakMap.has(mapKey)) {
      return;
    }
    var array = this._weakMap.get(mapKey);
    var idx = array.indexOf(item);

    if (idx >= 0) {
      if (array.length == 1) {
        this._weakMap.delete(mapKey);
      }
      else {
        array.splice(idx, 1);
      }
    }
  };

};

module.exports = ArrayWeakMap;

/***/ }),

/***/ "bVsJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),

/***/ "bv8i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cxPT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "dZ1e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e6+Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"general":{"ok":"Ok","by":"by","from":"From","day":"Day","plural_ending":"s"},"seller_levels":{"level_one_seller":"Level 1 Seller","level_one_seller_tooltip":"Completed at least 10 orders on time with a minimum 4.8 rating","level_two_seller":"Level 2 Seller","level_two_seller_tooltip":"Completed at least 50 orders on time with a minimum 4.8 rating","top_rated_seller":"Top Rated Seller","top_rated_seller_tooltip":"Vetted by Fiverr and completed at least 100 orders on time with a minimum 4.8 rating","new_pro":"New Pro Seller","new_seller":"New Arrival","pro_spotlight_seller":"Pro Spotlight Seller","pro_spotlight_seller_tooltip":"Leaders and experts in their fields, these sellers are featured on Fiverr for a limited time."},"badges":{"featured":{"caption":"featured","tooltip":"Curated by Fiverr's own editors, these sellers are talented, trustworthy, and reliable"},"available_now":{"caption":"Available Now","tooltip":"The seller is online and available to start working on your project now!"},"fiverrs_choice":{"caption":"Fiverr's Choice"},"pro":{"caption":"","tooltip":"This top talent has gone through a thorough application and verification process (only 1% make it), so you can feel confident going Pro."},"limited_edition":{"caption":"Limited Edition","tooltip":"These Pro Spotlight Gigs are only available for a short time. Don't miss out!"},"rising_talent":{"caption":"Rising Talent","tooltip":"Rising talent with a high potential, recommended by Fiverr's editors."},"very_reliable":{"caption":"Very Reliable","tooltip":"This seller has an extremely high fulfillment rate"},"ppc":{"caption":"Ad"},"buy_it_again":{"caption":"Buy It Again"},"hire_again":{"caption":"Hire Again"}},"rating":{"be_the_first_to_rate":"Be the First to Rate","be_the_first_to_rate_pro":"Buy & Review","reviews":"reviews","last_60_days_score":"Last 60 days","lifetime_score":"Lifetime","reviews_by_period":"Reviews by period"},"countdown":{"expired":"Sold Out"},"price":{"on_average":"On Average","most_successful":"Most successful at","starting_at":"Starting At","from":"From","only":"Only"},"delivery_time":{"tomorrow":"Tomorrow","get_it_by":"Get it by","average_delivery":"Average Delivery:"},"list_view_info":{"platform":"Platform:","expertise":"Expertise:"},"collections":{"add_to_favorites":"Add to Favorites","save_in":"Save in...","add_collection":"Add Collection","collection_name":"Collection Name","errors":{"went_wrong":"We're sorry, something went wrong","length_error":"Name must be 5 to 52 characters","name_new_coll":"Name your new collection"}}}

/***/ }),

/***/ "eLcb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fEuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__("U7vG");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: external "@fiverr/globals"
var globals_ = __webpack_require__("E4I8");
var globals__default = /*#__PURE__*/__webpack_require__.n(globals_);

// EXTERNAL MODULE: ./node_modules/react-store/Store.js
var Store = __webpack_require__("lCso");
var Store_default = /*#__PURE__*/__webpack_require__.n(Store);

// CONCATENATED MODULE: ./src/store/collection/index.js



var _pendingRequests = {},
    collUrl = '/collection_items',
    collHashUrl = '/collections/hash',
    CollectionStore = Store_default.a.extend({
    serializeJson: function serializeJson(ary) {
        return Object.keys(ary).map(function (key) {
            if (Array.isArray(ary[key])) {
                var arrayParts = [];
                for (var i = 0; i < ary[key].length; i++) {
                    arrayParts.push(encodeURIComponent(key + '[]') + '=' + encodeURIComponent(ary[key][i]));
                }
                return arrayParts.join('&');
            }
            return encodeURIComponent(key) + '=' + encodeURIComponent(ary[key]);
        }).join('&');
    },
    getCollections: function getCollections(hearts) {
        if (hearts.length < 1) {
            return {};
        }

        _pendingRequests[collHashUrl] = true;

        return gofor(collHashUrl + '?' + this.serializeJson({ gigs: hearts }), {
            method: 'GET',
            headers: {
                'Accept': 'text/javascript'
            }
        }).then(function (response) {
            return response.ok && response.json();
        }).then(function (data) {
            delete _pendingRequests[collHashUrl];
            return data;
        });
    },
    toggleFavorite: function toggleFavorite(type, gigId, collection) {
        if (!gigId || !collection) {
            return;
        }

        var params = { gig_id: gigId, collection: collection },
            formData = Object.keys(params).map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&');

        _pendingRequests[collUrl] = true;

        return gofor(collUrl, {
            method: type,
            headers: {
                'Accept': 'text/javascript',
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formData
        }).then(function () {
            delete _pendingRequests[collUrl];
            return 'success';
        }).catch(function (error) {
            throw error;
        });
    },
    newCollection: function newCollection(gigId, collection) {
        if (!gigId || !collection) {
            return;
        }

        var params = { gig_id: gigId, collection: collection },
            formData = Object.keys(params).map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&');

        _pendingRequests[collUrl] = true;

        return gofor(collUrl, {
            method: 'POST',
            headers: {
                'Accept': 'text/javascript',
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formData
        }).then(function () {
            delete _pendingRequests[collUrl];
            return 'success';
        }).catch(function (response) {
            var error = response.error();

            delete _pendingRequests[collUrl];
            return error && error.responseText ? JSON.parse(error.responseText).error : 'We\'re sorry, something went wrong';
        });
    }
});

/* harmony default export */ var collection = (CollectionStore);
// EXTERNAL MODULE: ./src/translations.en.json
var translations_en = __webpack_require__("eIBB");
var translations_en_default = /*#__PURE__*/__webpack_require__.n(translations_en);

// EXTERNAL MODULE: ./node_modules/@fiverr/fit/dist/index.js
var dist = __webpack_require__("tBbN");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./src/shared/badge/style.scss
var style = __webpack_require__("0wUK");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/shared/badge/index.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var BADGE_CASES = {
    FEATURED: 'featured',
    CHOICE: 'choice',
    PRO: 'pro',
    LIMITED: 'limited',
    HIGH_COMPLETION: 'high_completion',
    TALENT: 'talent',
    NOW: 'now',
    HIRE_AGAIN: 'hire_again',
    BUY_IT_AGAIN: 'buy_it_again'
};

var badge_Badge = function Badge(_ref) {
    var _BADGE_CASES$FEATURED;

    var type = _ref.type,
        className = _ref.className,
        tooltipPositionClass = _ref.tooltipPositionClass;

    var leftAlign = [BADGE_CASES.LIMITED, BADGE_CASES.TALENT].includes(type),
        badgeClasses = classnames_default()({
        'featured': type === BADGE_CASES.FEATURED,
        'available-now': type === BADGE_CASES.NOW,
        'pro-badge': type === BADGE_CASES.PRO,
        'limited-edition': type === BADGE_CASES.LIMITED,
        'high-completion-rate': type === BADGE_CASES.HIGH_COMPLETION,
        'rising-talent': type === BADGE_CASES.TALENT,
        'card-badge': type === BADGE_CASES.PRO,
        'outline': type === BADGE_CASES.PRO
    }, 'badge-hint', 'js-badge-hint', tooltipPositionClass);
    var ExclusiveBadge = (_BADGE_CASES$FEATURED = {}, _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.FEATURED, function () {
        return react_default.a.createElement(
            dist["Status"],
            { classes: badgeClasses,
                'data-hint': i18n.t('badges.featured.tooltip') },
            i18n.t('badges.featured.caption')
        );
    }), _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.CHOICE, function () {
        return react_default.a.createElement(
            dist["Status"],
            { classes: 'quality-choice' },
            i18n.t('badges.fiverrs_choice.caption')
        );
    }), _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.NOW, function () {
        return react_default.a.createElement(
            dist["Status"],
            { classes: badgeClasses,
                'data-hint': i18n.t('badges.available_now.tooltip') },
            react_default.a.createElement('i', null),
            ' ',
            i18n.t('badges.available_now.caption')
        );
    }), _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.PRO, function () {
        return react_default.a.createElement('span', { className: badgeClasses, 'data-hint': i18n.t('badges.pro.tooltip') });
    }), _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.LIMITED, function () {
        return react_default.a.createElement(
            dist["Status"],
            { classes: badgeClasses,
                'data-hint': i18n.t('badges.limited_edition.tooltip') },
            i18n.t('badges.limited_edition.caption')
        );
    }), _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.HIGH_COMPLETION, function () {
        return react_default.a.createElement(
            dist["Status"],
            { classes: badgeClasses,
                'data-hint': i18n.t('badges.very_reliable.tooltip') },
            react_default.a.createElement('i', null),
            ' ',
            i18n.t('badges.very_reliable.caption')
        );
    }), _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.TALENT, function () {
        return react_default.a.createElement(
            dist["Status"],
            { classes: badgeClasses,
                'data-hint': i18n.t('badges.rising_talent.tooltip') },
            i18n.t('badges.rising_talent.caption')
        );
    }), _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.HIRE_AGAIN, function () {
        return react_default.a.createElement(
            dist["Status"],
            { classes: 'hire-again' },
            i18n.t('badges.hire_again.caption')
        );
    }), _defineProperty(_BADGE_CASES$FEATURED, BADGE_CASES.BUY_IT_AGAIN, function () {
        return react_default.a.createElement(
            dist["Status"],
            { classes: 'buy-it-again' },
            i18n.t('badges.buy_it_again.caption')
        );
    }), _BADGE_CASES$FEATURED)[type] || null;

    var classes = ['gig-badge'];
    className && classes.push(className);
    leftAlign && classes.push('left');
    type === BADGE_CASES.TALENT && classes.push('rising-talent');

    return react_default.a.createElement(
        'span',
        { className: classes.join(' ') },
        react_default.a.createElement(ExclusiveBadge, null)
    );
};

badge_Badge.propTypes = {
    type: prop_types_default.a.string.isRequired,
    className: prop_types_default.a.string,
    tooltipPositionClass: prop_types_default.a.string
};

/* harmony default export */ var shared_badge = (badge_Badge);
// CONCATENATED MODULE: ./src/context/createEmitter.js


/* harmony default export */ var createEmitter = (function (value) {
    var subscribers = [];

    var getValue = function getValue() {
        return value;
    },
        publish = function publish(nextValue) {
        value = nextValue;

        subscribers.forEach(function (cb) {
            return cb(_.cloneDeep(value));
        });
    },
        subscribe = function subscribe(callback) {
        subscribers.push(callback);

        return function () {
            return subscribers = subscribers.filter(function (cb) {
                return cb !== callback;
            });
        };
    };

    return { getValue: getValue, publish: publish, subscribe: subscribe };
});
// CONCATENATED MODULE: ./src/context/index.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function context__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






function createContext(initialValue) {
    var contextProp = _.uniqueId('_react_context_');

    var ContextProvider = function (_PureComponent) {
        _inherits(ContextProvider, _PureComponent);

        function ContextProvider(props) {
            _classCallCheck(this, ContextProvider);

            var _this = _possibleConstructorReturn(this, (ContextProvider.__proto__ || Object.getPrototypeOf(ContextProvider)).call(this, props));

            _this.emitter = createEmitter(_this.props.value);
            return _this;
        }

        _createClass(ContextProvider, [{
            key: 'getChildContext',
            value: function getChildContext() {
                return context__defineProperty({}, contextProp, this.emitter);
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                var value = this.props.value;


                this.emitter.publish(value);
            }
        }, {
            key: 'render',
            value: function render() {
                var children = this.props.children;

                return children ? children : null;
            }
        }]);

        return ContextProvider;
    }(react["PureComponent"]);

    ContextProvider.childContextTypes = context__defineProperty({}, contextProp, prop_types_default.a.object);

    ContextProvider.defaultProps = {
        value: initialValue
    };

    ContextProvider.propTypes = {
        children: prop_types_default.a.element,
        value: prop_types_default.a.any
    };

    var ContextConsumer = function (_PureComponent2) {
        _inherits(ContextConsumer, _PureComponent2);

        function ContextConsumer(props, context) {
            _classCallCheck(this, ContextConsumer);

            var _this2 = _possibleConstructorReturn(this, (ContextConsumer.__proto__ || Object.getPrototypeOf(ContextConsumer)).call(this, props, context));

            _this2.state = { value: _this2.getValue() };
            return _this2;
        }

        _createClass(ContextConsumer, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this3 = this;

                if (this.context[contextProp]) {
                    this.unsubscribe = this.context[contextProp].subscribe(function (value) {
                        return _this3.setState({ value: value });
                    });
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.unsubscribe) {
                    this.unsubscribe();
                }
            }
        }, {
            key: 'getValue',
            value: function getValue() {
                return this.context[contextProp] ? this.context[contextProp].getValue() : initialValue;
            }
        }, {
            key: 'render',
            value: function render() {
                var children = this.props.children;

                return typeof children === 'function' ? children(this.state.value) : null;
            }
        }]);

        return ContextConsumer;
    }(react["PureComponent"]);

    ContextConsumer.contextTypes = context__defineProperty({}, contextProp, prop_types_default.a.object);

    ContextConsumer.propTypes = {
        children: prop_types_default.a.func
    };

    return { ContextProvider: ContextProvider, ContextConsumer: ContextConsumer };
}
// CONCATENATED MODULE: ./src/shared/gig_card_context/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _createContext = createContext({ cardType: 'card' }),
    gig_card_context_ContextProvider = _createContext.ContextProvider,
    gig_card_context_ContextConsumer = _createContext.ContextConsumer;

var gig_card_context_GigCardContextProvider = function GigCardContextProvider(_ref) {
    var value = _ref.value,
        children = _ref.children;
    return react_default.a.createElement(
        gig_card_context_ContextProvider,
        { value: value },
        children
    );
};

var gig_card_context_withGigCardContext = function withGigCardContext(selector) {
    return function (Wrapped) {
        return function (props) {
            return react_default.a.createElement(
                gig_card_context_ContextConsumer,
                null,
                function (context) {
                    return react_default.a.createElement(Wrapped, _extends({}, selector(context), props));
                }
            );
        };
    };
};
// EXTERNAL MODULE: ./node_modules/@fiverr/i18n/singleton.js
var singleton = __webpack_require__("ykZ/");
var singleton_default = /*#__PURE__*/__webpack_require__.n(singleton);

// EXTERNAL MODULE: ./src/shared/countdown/style.scss
var countdown_style = __webpack_require__("WOeT");
var countdown_style_default = /*#__PURE__*/__webpack_require__.n(countdown_style);

// CONCATENATED MODULE: ./src/shared/countdown/index.js






var countdown_Countdown = function Countdown(_ref) {
    var deadline = _ref.deadline,
        className = _ref.className;

    var now = new Date(),
        deadlineArr = deadline.split(/[- : T]/).map(function (datePiece) {
        return parseInt(datePiece, 10);
    }),
        endDate = new Date(deadlineArr[0], deadlineArr[1] - 1, deadlineArr[2], deadlineArr[3], deadlineArr[4], deadlineArr[5]).getTime(),
        t = endDate - now,
        expired = t <= 0,
        hoursLeft = Math.floor(t / (1000 * 60 * 60) % 24),
        daysLeft = Math.floor(t / (1000 * 60 * 60 * 24)),
        countdownContent = expired ? i18n.t('countdown.expired') : [react_default.a.createElement('i', { key: Math.random() * 100, className: 'fa fa-clock-o' }), ' ' + daysLeft + 'd ' + hoursLeft + 'h'];

    return react_default.a.createElement(
        'span',
        { className: classnames_default()('countdown', className) },
        countdownContent
    );
};

countdown_Countdown.propTypes = {
    deadline: prop_types_default.a.string
};

/* harmony default export */ var countdown = (countdown_Countdown);
// CONCATENATED MODULE: ./src/utils/gigTypes/constants.js
var LIQUID_ENGINE = 'liquid_engine';
var PPC_BADGE_TEST = 'ad_test';
var BUY_IT_AGAIN = 'buy_it_again';
var HIRE_AGAIN = 'hire_again';
// CONCATENATED MODULE: ./src/utils/gigTypes/index.js


/**
 * Whether or not a gig is considered a "rising talent".
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
var gigTypes_isRisingTalent = function isRisingTalent() {
  var gigType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return gigType === LIQUID_ENGINE;
};

/**
 * Whether or not a gig is in the ppc ad badge test.
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
var gigTypes_inPpcAdBadgeTest = function inPpcAdBadgeTest() {
  var gigType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return gigType === PPC_BADGE_TEST;
};

/**
 * Whether or not a gig is considered a buy again option.
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
var gigTypes_isBuyItAgain = function isBuyItAgain() {
  var gigType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return gigType === BUY_IT_AGAIN;
};

/**
 * Whether or not a gig is considered a hire again option.
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
var gigTypes_isHireAgain = function isHireAgain() {
  var gigType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return gigType === HIRE_AGAIN;
};
// CONCATENATED MODULE: ./src/shared/gig_badges/index.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









var gig_badges_GigBadges = function GigBadges(_ref) {
    var cardType = _ref.cardType,
        type = _ref.type,
        gigId = _ref.gigId,
        limitedEdition = _ref.limitedEdition,
        reliable = _ref.reliable,
        featured = _ref.featured,
        qualityChoice = _ref.qualityChoice,
        sellerName = _ref.sellerName,
        availableNow = _ref.availableNow,
        limitedEditionDeadline = _ref.limitedEditionDeadline,
        pro = _ref.pro,
        tooltipPositionClass = _ref.tooltipPositionClass,
        isProExperience = _ref.isProExperience;

    var risingTalent = gigTypes_isRisingTalent(type);
    var hireAgain = gigTypes_isHireAgain(type);
    var buyItAgain = gigTypes_isBuyItAgain(type);

    var badges = [],
        badgeMatrix = [[react_default.a.createElement(shared_badge, { key: gigId + '_hire_again', tooltipPositionClass: tooltipPositionClass, type: 'hire_again' }), hireAgain], [react_default.a.createElement(shared_badge, { key: gigId + '_buy_it_again', tooltipPositionClass: tooltipPositionClass, type: 'buy_it_again' }), buyItAgain], [react_default.a.createElement(shared_badge, { key: gigId + '_badge_limited', tooltipPositionClass: tooltipPositionClass, type: 'limited' }), limitedEdition && !isProExperience], [react_default.a.createElement(shared_badge, { key: gigId + '_badge_talent', tooltipPositionClass: tooltipPositionClass, type: 'talent' }), risingTalent], [react_default.a.createElement(shared_badge, { key: gigId + '_badge_high_completion', tooltipPositionClass: tooltipPositionClass, className: 'high-completion', type: 'high_completion' }), reliable], [react_default.a.createElement(shared_badge, { key: gigId + '_badge_featured', tooltipPositionClass: tooltipPositionClass, type: 'featured' }), featured], [react_default.a.createElement(shared_badge, { key: gigId + '_badge_choice', tooltipPositionClass: tooltipPositionClass, type: 'choice' }), qualityChoice], [react_default.a.createElement(shared_badge, { key: gigId + '_badge_now', tooltipPositionClass: tooltipPositionClass, type: 'now', seller: sellerName }), availableNow]],
        badge = badgeMatrix.find(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            badgeComponent = _ref3[0],
            condition = _ref3[1];

        return condition;
    }); // eslint-disable-line no-unused-vars

    badge && badges.push(badge[0]);
    limitedEdition && badges.push(react_default.a.createElement(countdown, { key: gigId + '_countdown', className: classnames_default()({ 'left-align': isProExperience && cardType !== 'list' }), deadline: limitedEditionDeadline }));
    pro && badges.push(react_default.a.createElement(shared_badge, { key: gigId + '_badge_pro', tooltipPositionClass: tooltipPositionClass, type: 'pro', className: classnames_default()({ 'pro': isProExperience, 'limited-edition': limitedEdition }) }));

    return badges.length ? react_default.a.createElement(
        'span',
        { className: 'gig-badge-container' },
        badges
    ) : null;
};

gig_badges_GigBadges.propTypes = {
    featured: prop_types_default.a.bool,
    limitedEdition: prop_types_default.a.bool,
    limitedEditionDeadline: prop_types_default.a.string,
    qualityChoice: prop_types_default.a.bool,
    reliable: prop_types_default.a.bool,
    availableNow: prop_types_default.a.bool,
    type: prop_types_default.a.string,
    sellerName: prop_types_default.a.string,
    pro: prop_types_default.a.bool,
    gigId: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    tooltipPositionClass: prop_types_default.a.string,
    isProExperience: prop_types_default.a.bool
};

var contextSelector = function contextSelector(_ref4) {
    var cardType = _ref4.cardType;
    return { cardType: cardType };
};

/* harmony default export */ var gig_badges = (gig_card_context_withGigCardContext(contextSelector)(gig_badges_GigBadges));

// CONCATENATED MODULE: ./src/utils/tracking.js
var EVENTS = {
    CLICK: 'click'
},
    CARD_TYPES = {
    CARD: 'card',
    LIST: 'list'
},
    CARD_SIZES = {
    MEDIUM: 'medium',
    LARGE: 'large'
},
    PLATFORMS = {
    MIXPANEL: 'mixpanel',
    GRAPHITE: 'graphite',
    BIGQUERY: 'bigquery'
};

function reportToGraphite(evt) {
    var cardType = evt.cardType === 'card' ? evt.cardSize + '_' + evt.cardType : evt.cardType;
    var data = {
        label: 'fe_events.react_' + cardType + '.' + evt.name,
        percentage: evt.percentage || 100
    };

    if (evt.timing) {
        data.timing = evt.timing;
    }

    if (typeof Fiverr !== 'undefined' && Fiverr._logEventToGraphite) {
        Fiverr._logEventToGraphite(data);
    } else {
        console && console.log('Sandbox Graphite logging', data); // eslint-disable-line
    }
}

function reportToMixpanel(evt, dontIgnore) {
    if (dontIgnore) {
        // temporary
        if (typeof MixpanelWrapper !== 'undefined') {
            MixpanelWrapper.trackEvent(MixpanelWrapper.Events.GigCardEvents.CLICKED_CARD, evt.payload);
        } else {
            console && console.log('Sandbox Mixpanel logging', evt.payload); // eslint-disable-line
        }
    }
}

function reportToBigquery(evt) {
    var currentPage = document && document.pageScope && document.pageScope.main || '';
    var data = {
        type: evt.name,
        current_page_type: currentPage
    };

    data = Object.assign(evt.payload, data);

    if (typeof Fiverr.sendClientEvents === 'undefined') {
        console && console.log('Sandbox BigQuery logging', data); // eslint-disable-line
        return;
    }

    Fiverr.sendClientEvents(data);
}

function prepareEventData(eventName, cardType, cardSize, eventType, payload, platform) {
    var evt = {
        name: eventName,
        type: eventType || EVENTS.CLICK,
        cardType: cardType,
        payload: payload || {},
        platform: platform || null
    };

    evt.payload.Subcategory = Fiverr && Fiverr.models && Fiverr.models.ps.subCatName || 'search';
    evt.payload['Click Location'] = evt.name;
    evt.payload['Card Type'] = cardType;
    evt.payload['Card Size'] = cardSize;

    return evt;
}

function trackTime(eventName, startTime) {
    var cardType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CARD_TYPES.CARD;

    var evt = {
        name: eventName,
        cardType: cardType,
        timing: Date.now() - startTime,
        percentage: 20
    };

    if (evt.timing) {
        reportToGraphite(evt);
    }
}

function trackEvent(eventName) {
    var cardType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CARD_TYPES.CARD;
    var cardSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CARD_SIZES.MEDIUM;
    var eventType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EVENTS.CLICK;
    var payload = arguments[4];
    var platform = arguments[5];

    var evt = prepareEventData(eventName, cardType, cardSize, eventType, payload, platform);

    if (!evt.name) {
        return;
    }

    switch (platform) {
        case PLATFORMS.GRAPHITE:
            reportToGraphite(evt);
            break;
        case PLATFORMS.MIXPANEL:
            reportToMixpanel(evt);
            break;
        case PLATFORMS.BIGQUERY:
            reportToBigquery(evt);
            break;
        default:
            reportToMixpanel(evt);
            reportToGraphite(evt);
            break;
    }
}
// EXTERNAL MODULE: ./src/shared/collect_gig/collection_popup/style.scss
var collection_popup_style = __webpack_require__("HK0U");
var collection_popup_style_default = /*#__PURE__*/__webpack_require__.n(collection_popup_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/collection_popup/index.js
var collection_popup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function collection_popup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collection_popup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collection_popup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var collection_popup_CollectionPopup = function (_PureComponent) {
    collection_popup__inherits(CollectionPopup, _PureComponent);

    function CollectionPopup(props) {
        collection_popup__classCallCheck(this, CollectionPopup);

        var _this = collection_popup__possibleConstructorReturn(this, (CollectionPopup.__proto__ || Object.getPrototypeOf(CollectionPopup)).call(this, props));

        _this.state = {
            collectionValue: '',
            withError: false,
            errorMsg: i18n.t('general.went_wrong')
        };

        _this.collectionChange = _this.collectionChange.bind(_this);
        _this.collectionSubmit = _this.collectionSubmit.bind(_this);
        return _this;
    }

    collection_popup__createClass(CollectionPopup, [{
        key: 'collectionChange',
        value: function collectionChange(e) {
            this.setState({
                collectionValue: e.target.value
            });
        }
    }, {
        key: 'collectionSubmit',
        value: function collectionSubmit(e) {
            var _this2 = this;

            e.preventDefault();

            var newCollection = this.state.collectionValue,
                _props = this.props,
                gigId = _props.gigId,
                popupCallback = _props.popupCallback,
                sellerId = _props.sellerId,
                user = _props.user,
                collectionLimits = {
                min: 5,
                max: 52
            };


            if (newCollection.length >= collectionLimits.min && newCollection.length <= collectionLimits.max) {
                this.setState({
                    withError: false
                });

                this.props.saveCollection(gigId, newCollection).then(function () {
                    popupCallback(e);

                    var payload = {
                        collection: {
                            type: 'gig',
                            source: 'gig_card',
                            name: newCollection
                        },
                        user: {
                            id: user.userId
                        },
                        seller: {
                            id: sellerId
                        },
                        gig: {
                            id: gigId
                        }
                    };

                    trackEvent('collections_list-created', _this2.props.cardType, _this2.props.cardSize);
                    trackEvent('collections.create', _this2.props.cardType, _this2.props.cardSize, 'click', payload, 'bigquery');
                }).catch(function (ajaxResp) {
                    _this2.setState({
                        withError: true,
                        errorMsg: ajaxResp || i18n.t('collections.errors.went_wrong')
                    });
                });
            } else {
                this.setState({
                    withError: true,
                    errorMsg: i18n.t('collections.errors.length_error')
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var popupCallback = this.props.popupCallback,
                _state = this.state,
                collectionValue = _state.collectionValue,
                withError = _state.withError,
                errorMsg = _state.errorMsg;


            return react_default.a.createElement(
                'div',
                { className: 'gig-fav-popup' },
                react_default.a.createElement('div', { className: 'behind', onClick: function onClick(e) {
                        return popupCallback(e);
                    } }),
                react_default.a.createElement(
                    'aside',
                    { className: 'modal popup-base' },
                    react_default.a.createElement(
                        'header',
                        null,
                        react_default.a.createElement(
                            'a',
                            { href: '#',
                                className: 'btn-close',
                                rel: 'noindex, nofollow',
                                onClick: function onClick(e) {
                                    return popupCallback(e);
                                } },
                            '\xD7'
                        ),
                        react_default.a.createElement(
                            'h2',
                            { className: 'cap' },
                            i18n.t('collections.errors.name_new_coll')
                        )
                    ),
                    react_default.a.createElement(
                        'form',
                        { className: 'new-coll-form general-form-field-wrap', onSubmit: this.collectionSubmit },
                        react_default.a.createElement(
                            'div',
                            { className: 'popup-content' },
                            react_default.a.createElement('input', { type: 'text',
                                name: 'collection',
                                id: 'collection',
                                placeholder: i18n.t('collections.collection_name'),
                                onChange: this.collectionChange,
                                value: collectionValue,
                                className: withError ? 'with-error' : '' }),
                            withError && react_default.a.createElement(
                                'div',
                                { className: 'error-container' },
                                react_default.a.createElement(
                                    'p',
                                    { className: 'msg-error' },
                                    errorMsg
                                )
                            )
                        ),
                        react_default.a.createElement(
                            'footer',
                            null,
                            react_default.a.createElement('input', { type: 'submit',
                                className: 'btn-standard btn-green-grad',
                                value: i18n.t('general.ok') })
                        )
                    )
                )
            );
        }
    }]);

    return CollectionPopup;
}(react["PureComponent"]);

collection_popup_CollectionPopup.propTypes = {
    gigId: prop_types_default.a.string,
    popupCallback: prop_types_default.a.func,
    saveCollection: prop_types_default.a.func
};

var collection_popup_contextSelector = function contextSelector(_ref) {
    var user = _ref.user;
    return { user: user };
};



/* harmony default export */ var collection_popup = (gig_card_context_withGigCardContext(collection_popup_contextSelector)(collection_popup_CollectionPopup));
// EXTERNAL MODULE: ./src/shared/collect_gig/collection_menu/style.scss
var collection_menu_style = __webpack_require__("UCFI");
var collection_menu_style_default = /*#__PURE__*/__webpack_require__.n(collection_menu_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/collection_menu/index.js
var collection_menu__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function collection_menu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collection_menu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collection_menu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var collection_menu_CollectionMenu = function (_PureComponent) {
    collection_menu__inherits(CollectionMenu, _PureComponent);

    function CollectionMenu(props) {
        collection_menu__classCallCheck(this, CollectionMenu);

        var _this = collection_menu__possibleConstructorReturn(this, (CollectionMenu.__proto__ || Object.getPrototypeOf(CollectionMenu)).call(this, props));

        _this.state = {
            showPopup: false
        };

        _this.togglePopup = _this.togglePopup.bind(_this);
        _this.onCollectionClicked = _this.onCollectionClicked.bind(_this);
        _this.startTime = Date.now();
        return _this;
    }

    collection_menu__createClass(CollectionMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            trackTime('collection-menu-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            trackTime('collect-menu-component-will-unmount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'togglePopup',
        value: function togglePopup(e) {
            e.preventDefault();

            this.setState({
                showPopup: !this.state.showPopup
            });

            this.state.showPopup && trackEvent('collections_list-open', this.props.cardType, this.props.cardSize);
        }
    }, {
        key: 'onCollectionClicked',
        value: function onCollectionClicked(e, coll, isCollected) {
            var payload = {
                collection: {
                    type: 'gig',
                    source: 'gig_card',
                    name: coll
                },
                user: {
                    id: this.props.user.id
                },
                seller: {
                    id: this.props.sellerId
                },
                gig: {
                    id: this.props.gigId
                }

            };

            trackEvent('collections_list-' + (!isCollected ? 'collected' : 'uncollected'), this.props.cardType, this.props.cardSize);
            trackEvent('collections_list.' + (!isCollected ? 'create' : 'destroy'), this.props.cardType, this.props.cardSize, 'click', payload, 'bigquery');

            this.props.toggleCollection(e, coll, isCollected);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                gigId = _props.gigId,
                cardType = _props.cardType,
                cardSize = _props.cardSize,
                saveCollection = _props.saveCollection,
                collections = _props.collections,
                sellerId = _props.sellerId,
                showPopup = this.state.showPopup,
                collectionsList = collections.collections || {},
                collKeys = Object.keys(collectionsList);


            return react_default.a.createElement(
                'div',
                { className: 'gig-fav-menu' },
                react_default.a.createElement(
                    'div',
                    { className: 'collection-dd coll-dd-4gig open', 'data-gig-id': gigId },
                    react_default.a.createElement(
                        'div',
                        { className: 'antiscroll-wrap' },
                        react_default.a.createElement(
                            'ul',
                            { className: 'antiscroll-inner coll-dd-list' },
                            collKeys.length && collKeys.map(function (coll) {
                                var isCollected = collectionsList[coll].gigs.includes(gigId);
                                return react_default.a.createElement(
                                    'li',
                                    { className: 'coll-dd-item', key: coll },
                                    react_default.a.createElement(
                                        'a',
                                        { href: '#',
                                            className: 'heart' + (isCollected ? ' collected' : ''),
                                            onClick: function onClick(e) {
                                                return _this2.onCollectionClicked(e, coll, isCollected);
                                            } },
                                        coll
                                    )
                                );
                            })
                        )
                    ),
                    react_default.a.createElement(
                        'ul',
                        null,
                        react_default.a.createElement('li', { className: 'divider' }),
                        react_default.a.createElement(
                            'li',
                            null,
                            react_default.a.createElement(
                                'a',
                                { href: '#!',
                                    className: 'add-coll',
                                    onClick: function onClick(e) {
                                        return _this2.togglePopup(e);
                                    } },
                                i18n.t('collections.add_collection')
                            )
                        )
                    )
                ),
                showPopup && react_default.a.createElement(collection_popup, { gigId: gigId, sellerId: sellerId, saveCollection: saveCollection, popupCallback: this.togglePopup, cardType: cardType, cardSize: cardSize })
            );
        }
    }]);

    return CollectionMenu;
}(react["PureComponent"]);

collection_menu_CollectionMenu.propTypes = {
    gigId: prop_types_default.a.string,
    collections: prop_types_default.a.oneOfType([prop_types_default.a.object, prop_types_default.a.bool]),
    cardType: prop_types_default.a.string,
    saveCollection: prop_types_default.a.func,
    toggleCollection: prop_types_default.a.func
};

var collection_menu_contextSelector = function contextSelector(_ref) {
    var user = _ref.user;
    return { user: user };
};



/* harmony default export */ var collection_menu = (gig_card_context_withGigCardContext(collection_menu_contextSelector)(collection_menu_CollectionMenu));
// EXTERNAL MODULE: ./src/shared/collect_gig/collection/style.scss
var collection_style = __webpack_require__("rD3X");
var collection_style_default = /*#__PURE__*/__webpack_require__.n(collection_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/collection/index.js
var collection__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function collection__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collection__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collection__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var collection_Collection = function (_PureComponent) {
    collection__inherits(Collection, _PureComponent);

    function Collection(props) {
        collection__classCallCheck(this, Collection);

        var _this = collection__possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props));

        _this.state = {
            showCollections: false,
            clickCameFromComponent: false
        };

        _this.toggleCollections = _this.toggleCollections.bind(_this);
        _this.turnOffCollectionsMenu = _this.turnOffCollectionsMenu.bind(_this);
        _this.startTime = Date.now();
        return _this;
    }

    collection__createClass(Collection, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.addEventListener('mousedown', this.turnOffCollectionsMenu);
            trackTime('collection-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeEventListener('mousedown', this.turnOffCollectionsMenu);
            trackTime('collection-component-will-unmount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'turnOffCollectionsMenu',
        value: function turnOffCollectionsMenu() {
            if (!this.state.showCollections || !(this.collRef && !this.collRef.contains(event.target))) {
                return false;
            }

            this.setState({
                showCollections: false
            });
        }
    }, {
        key: 'toggleCollections',
        value: function toggleCollections(e) {
            e.preventDefault();

            this.setState({
                showCollections: !this.state.showCollections
            });

            trackEvent('collections_list', this.props.cardType, this.props.cardSize);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                gigId = _props.gigId,
                cardType = _props.cardType,
                icon = _props.icon,
                hintClass = cardType === 'list' ? 'hint--bottom-right' : 'hint--top',
                showCollections = this.state.showCollections;


            return react_default.a.createElement(
                'span',
                { className: 'coll-group', ref: function ref(_ref) {
                        _this2.collRef = _ref;
                    } },
                react_default.a.createElement(
                    'a',
                    { className: 'icn-heart-toggle ' + hintClass,
                        href: '#!',
                        'data-hint': i18n.t('collections.save_in'),
                        'data-coll-gig': 'coll-gig-' + gigId,
                        'data-gtm-action': 'hp-clicked-list',
                        'data-gtm-event': 'collections',
                        onClick: function onClick(e) {
                            return _this2.toggleCollections(e);
                        } },
                    react_default.a.createElement('i', { className: icon })
                ),
                showCollections && react_default.a.createElement(collection_menu, this.props)
            );
        }
    }]);

    return Collection;
}(react["PureComponent"]);

collection_Collection.propTypes = {
    gigId: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
    collections: prop_types_default.a.oneOfType([prop_types_default.a.object, prop_types_default.a.bool]),
    cardType: prop_types_default.a.string,
    icon: prop_types_default.a.string,
    saveCollection: prop_types_default.a.func,
    toggleCollection: prop_types_default.a.func
};

/* harmony default export */ var collect_gig_collection = (collection_Collection);
// EXTERNAL MODULE: ./src/shared/collect_gig/favorite/style.scss
var favorite_style = __webpack_require__("ijbM");
var favorite_style_default = /*#__PURE__*/__webpack_require__.n(favorite_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/favorite/index.js
var favorite__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var favorite__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function favorite__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function favorite__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function favorite__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var favorite_Favorite = function (_PureComponent) {
    favorite__inherits(Favorite, _PureComponent);

    function Favorite(props) {
        favorite__classCallCheck(this, Favorite);

        var _this = favorite__possibleConstructorReturn(this, (Favorite.__proto__ || Object.getPrototypeOf(Favorite)).call(this, props));

        _this.state = {
            animation: false
        };

        _this.heartIcon = null;

        _this.onClick = _this.onClick.bind(_this);
        _this.playAnimation = _this.playAnimation.bind(_this);
        return _this;
    }

    favorite__createClass(Favorite, [{
        key: 'onClick',
        value: function onClick(e) {
            var _props = this.props,
                isFavorited = _props.isFavorited,
                user = _props.user,
                toggleCollection = _props.toggleCollection,
                cardType = _props.cardType,
                cardSize = _props.cardSize,
                gigId = _props.gigId,
                sellerId = _props.sellerId,
                payload = {
                collection: {
                    type: 'gig',
                    source: 'gig_card',
                    name: 'Gigs I Love'
                },
                user: {
                    id: user.userId
                },
                seller: {
                    id: sellerId
                },
                gig: {
                    id: gigId
                }
            };


            trackEvent('heart-' + (!isFavorited ? 'collect' : 'uncollect'), cardType, cardSize);
            trackEvent('collection_items.' + (!isFavorited ? 'create' : 'destroy'), cardType, cardSize, 'click', payload, 'bigquery');

            toggleCollection(e, 'Gigs I Love', isFavorited, this.playAnimation);
        }
    }, {
        key: 'playAnimation',
        value: function playAnimation() {
            var _this2 = this;

            var turnOffAnimation = function turnOffAnimation() {
                _this2.setState({ animation: false }, function () {
                    _this2.heartIcon.removeEventListener('animationend', turnOffAnimation);
                });
            };

            this.setState({ animation: true }, function () {
                _this2.heartIcon.addEventListener('animationend', turnOffAnimation);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                isFavorited = _props2.isFavorited,
                user = _props2.user,
                cardType = _props2.cardType,
                animation = this.state.animation,
                heartColor = isFavorited ? ' red' : '',
                hintClassTrue = cardType === 'list' ? 'hint--bottom-right ' : 'hint--top ',
                hintClass = !isFavorited ? hintClassTrue : '',
                hintText = !isFavorited ? i18n.t('collections.add_to_favorites') : null,
                setHeartIconRef = function setHeartIconRef(element) {
                _this3.heartIcon = element;
            };

            return react_default.a.createElement(
                'a',
                favorite__extends({ className: '' + hintClass + (animation ? 'is-animated ' : '') + 'icn-heart' + (user ? '' : ' js-open-popup-join'),
                    href: '#!'
                }, hintText && { 'data-hint': hintText }, {
                    'data-gtm-action': 'hp-clicked-heart',
                    'data-gtm-event': 'collections',
                    onClick: this.onClick }),
                react_default.a.createElement('i', { className: 'ficon ficon-favorite' + heartColor, ref: setHeartIconRef })
            );
        }
    }]);

    return Favorite;
}(react["PureComponent"]);

favorite_Favorite.propTypes = {
    isFavorited: prop_types_default.a.bool,
    cardType: prop_types_default.a.string,
    user: prop_types_default.a.object,
    toggleCollection: prop_types_default.a.func
};

/* harmony default export */ var favorite = (favorite_Favorite);
// EXTERNAL MODULE: ./src/shared/collect_gig/style.scss
var collect_gig_style = __webpack_require__("ZpHc");
var collect_gig_style_default = /*#__PURE__*/__webpack_require__.n(collect_gig_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/index.js
var collect_gig__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function collect_gig__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collect_gig__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collect_gig__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function collect_gig__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










// constants
var gigsIloveKey = 'Gigs I Love',
    collectionDefault = { gigs: [], active: true },
    collectionsListDefault = collect_gig__defineProperty({}, gigsIloveKey, collectionDefault);

var collect_gig_CollectGig = function (_Component) {
    collect_gig__inherits(CollectGig, _Component);

    function CollectGig(props) {
        collect_gig__classCallCheck(this, CollectGig);

        var _this = collect_gig__possibleConstructorReturn(this, (CollectGig.__proto__ || Object.getPrototypeOf(CollectGig)).call(this, props));

        _this.saveCollection = _this.saveCollection.bind(_this);
        _this.toggleCollection = _this.toggleCollection.bind(_this);

        _this.startTime = Date.now();
        return _this;
    }

    collect_gig__createClass(CollectGig, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            trackTime('collect-gig-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            trackTime('collect-gig-component-will-unmount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'toggleCollection',
        value: function toggleCollection(e, coll, isCollected, callback) {
            var _this2 = this;

            e.preventDefault();

            var newValue = !isCollected,
                ajaxType = newValue ? 'POST' : 'DELETE',
                _props = this.props,
                collections = _props.collections,
                gigId = _props.gigId,
                collectionsList = collections ? collections.collections : collectionsListDefault;


            return collection.toggleFavorite(ajaxType, gigId, coll).then(function (resp) {
                if (resp === 'success') {
                    var collection = collectionsList[coll] || collectionDefault;

                    if (newValue) {
                        collection.gigs.push(gigId);
                    } else {
                        collection.gigs = collection.gigs.filter(function (id) {
                            return id !== gigId;
                        });
                    }

                    var nextCollections = Object.assign({}, collectionsList, collect_gig__defineProperty({}, coll, collection));

                    _this2.props.updateCollections({ collections: nextCollections }, callback);
                }
            });
        }
    }, {
        key: 'saveCollection',
        value: function saveCollection(gigId, collectionKey) {
            var _this3 = this;

            return collection.newCollection(gigId, collectionKey).then(function (ajaxResp) {
                if (ajaxResp === 'success') {
                    var newCollection = collect_gig__defineProperty({}, collectionKey, {
                        gigs: [gigId],
                        active: true
                    }),
                        collections = _this3.props.collections.collections;

                    _this3.props.updateCollections({ collections: Object.assign({}, collections, newCollection) });
                }
            });
        }
    }, {
        key: 'checkIsFavorited',
        value: function checkIsFavorited(gigId, collectionsList) {
            if (!this.props.user || !collectionsList) {
                return false;
            }

            var collections = collectionsList.collections;

            return Object.keys(collections).length ? collections[gigsIloveKey].gigs.includes(gigId) : false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                gigId = _props2.gigId,
                user = _props2.user,
                showCollMenu = _props2.showCollMenu,
                cardType = _props2.cardType,
                cardSize = _props2.cardSize,
                icon = _props2.icon,
                collections = _props2.collections,
                sellerId = _props2.sellerId,
                isFavorited = this.checkIsFavorited(gigId, collections),
                shouldShowCollMenu = !!(user && showCollMenu);


            return react_default.a.createElement(
                'div',
                { className: 'gig-fav' },
                shouldShowCollMenu && react_default.a.createElement(collect_gig_collection, { gigId: gigId, sellerId: sellerId, collections: collections, saveCollection: this.saveCollection, toggleCollection: this.toggleCollection, icon: icon, cardType: cardType, cardSize: cardSize }),
                react_default.a.createElement(favorite, { isFavorited: isFavorited, gigId: gigId, sellerId: sellerId, collections: collections, user: user, toggleCollection: this.toggleCollection, cardType: cardType, cardSize: cardSize })
            );
        }
    }]);

    return CollectGig;
}(react["Component"]);

collect_gig_CollectGig.propTypes = {
    collections: prop_types_default.a.oneOfType([prop_types_default.a.object, prop_types_default.a.bool]),
    gigId: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
    user: prop_types_default.a.object,
    showCollMenu: prop_types_default.a.bool,
    cardType: prop_types_default.a.string,
    icon: prop_types_default.a.string,
    updateCollections: prop_types_default.a.func
};

var collect_gig_contextSelector = function contextSelector(_ref) {
    var cardType = _ref.cardType,
        cardSize = _ref.cardSize,
        collections = _ref.collections;
    return { cardType: cardType, cardSize: cardSize, collections: collections };
};

/* harmony default export */ var collect_gig = (gig_card_context_withGigCardContext(collect_gig_contextSelector)(collect_gig_CollectGig));
// EXTERNAL MODULE: ./src/shared/card_shell/style.scss
var card_shell_style = __webpack_require__("NYAQ");
var card_shell_style_default = /*#__PURE__*/__webpack_require__.n(card_shell_style);

// CONCATENATED MODULE: ./src/shared/card_shell/index.js





var card_shell_GigCardShell = function GigCardShell(_ref) {
    var type = _ref.type,
        gigId = _ref.gigId,
        wrapperCls = _ref.wrapperCls,
        children = _ref.children,
        isProExperience = _ref.isProExperience,
        isLimitedEdition = _ref.isLimitedEdition;

    var classes = classnames_default()(wrapperCls, 'gig-card-base', 'slide', type, 'js-gig-card', 'js-slide', { 'pro-experience': isProExperience, 'limited-edition-card': isLimitedEdition });

    return react_default.a.createElement(
        'div',
        { 'data-gig-id': gigId, className: classes },
        children
    );
};

card_shell_GigCardShell.propTypes = {
    wrapperCls: prop_types_default.a.string,
    gigId: prop_types_default.a.number,
    type: prop_types_default.a.string,
    children: prop_types_default.a.any,
    isProExperience: prop_types_default.a.bool
};

/* harmony default export */ var card_shell = (card_shell_GigCardShell);
// CONCATENATED MODULE: ./src/shared/seller_delivery_time/index.js




var seller_delivery_time_SellerDeliveryTime = function SellerDeliveryTime(_ref) {
    var deliveryTime = _ref.deliveryTime;
    return react_default.a.createElement(
        'p',
        { className: 'seller-delivery-time' },
        react_default.a.createElement(
            'span',
            null,
            i18n.t('delivery_time.average_delivery')
        ),
        ' ',
        deliveryTime,
        ' ',
        i18n.t('general.day'),
        deliveryTime !== 1 && i18n.t('general.plural_ending')
    );
};

seller_delivery_time_SellerDeliveryTime.propTypes = {
    deliveryTime: prop_types_default.a.number
};

/* harmony default export */ var seller_delivery_time = (seller_delivery_time_SellerDeliveryTime);
// EXTERNAL MODULE: ./src/shared/list_view_info/style.scss
var list_view_info_style = __webpack_require__("xZmo");
var list_view_info_style_default = /*#__PURE__*/__webpack_require__.n(list_view_info_style);

// CONCATENATED MODULE: ./src/shared/list_view_info/index.js
var list_view_info__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function list_view_info__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function list_view_info__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function list_view_info__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var list_view_info_ListViewInfo = function (_PureComponent) {
    list_view_info__inherits(ListViewInfo, _PureComponent);

    function ListViewInfo(props) {
        list_view_info__classCallCheck(this, ListViewInfo);

        var _this = list_view_info__possibleConstructorReturn(this, (ListViewInfo.__proto__ || Object.getPrototypeOf(ListViewInfo)).call(this, props));

        _this.state = {
            platforms: null,
            skills: null
        };

        _this.startTime = Date.now();
        return _this;
    }

    list_view_info__createClass(ListViewInfo, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var platforms = this.props.platforms && this.props.platforms.length ? this.props.platforms.join(', ') : null,
                skills = this.props.skills && this.props.skills.length ? this.props.skills.slice(0, 4).join(', ') : null;

            if (!platforms && !skills) {
                return;
            }

            this.setState({ platforms: platforms, skills: skills });
            trackTime('list-view-info-component-will-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            trackTime('list-view-info-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                platforms = _state.platforms,
                skills = _state.skills,
                avgDeliveryTime = this.props.avgDeliveryTime;


            return react_default.a.createElement(
                'div',
                { className: 'list-view-info' },
                platforms && platforms.length ? react_default.a.createElement(
                    'p',
                    null,
                    react_default.a.createElement(
                        'span',
                        null,
                        i18n.t('list_view_info.platform')
                    ),
                    ' ',
                    platforms
                ) : null,
                skills && skills.length ? react_default.a.createElement(
                    'p',
                    null,
                    react_default.a.createElement(
                        'span',
                        null,
                        i18n.t('list_view_info.expertise')
                    ),
                    ' ',
                    skills
                ) : null,
                avgDeliveryTime ? react_default.a.createElement(seller_delivery_time, { deliveryTime: avgDeliveryTime }) : null
            );
        }
    }]);

    return ListViewInfo;
}(react["PureComponent"]);

list_view_info_ListViewInfo.propTypes = {
    cardType: prop_types_default.a.string,
    platforms: prop_types_default.a.array,
    skills: prop_types_default.a.array,
    avgDeliveryTime: prop_types_default.a.number
};

/* harmony default export */ var list_view_info = (list_view_info_ListViewInfo);
// EXTERNAL MODULE: ./src/shared/media/thumbnail/style.scss
var thumbnail_style = __webpack_require__("svXm");
var thumbnail_style_default = /*#__PURE__*/__webpack_require__.n(thumbnail_style);

// CONCATENATED MODULE: ./src/shared/media/thumbnail/index.js





var thumbnail_Thumbnail = function Thumbnail(_ref) {
    var src = _ref.src,
        srcSet = _ref.srcSet,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize;
    return react_default.a.createElement('img', { src: src, srcSet: srcSet, className: 'gig-thumbnail', onClick: function onClick() {
            return trackEvent('thumbnail', cardType, cardSize);
        } });
};

thumbnail_Thumbnail.propTypes = {
    src: prop_types_default.a.string,
    cardType: prop_types_default.a.string
};

/* harmony default export */ var thumbnail = (thumbnail_Thumbnail);
// EXTERNAL MODULE: ./src/shared/media/slider/style.scss
var slider_style = __webpack_require__("eLcb");
var slider_style_default = /*#__PURE__*/__webpack_require__.n(slider_style);

// EXTERNAL MODULE: ./src/shared/media/slider/arrow/style.scss
var arrow_style = __webpack_require__("z2GC");
var arrow_style_default = /*#__PURE__*/__webpack_require__.n(arrow_style);

// CONCATENATED MODULE: ./src/shared/media/slider/arrow/index.js




var arrow_Arrow = function Arrow(_ref) {
    var direction = _ref.direction,
        onClick = _ref.onClick;
    return react_default.a.createElement(
        'div',
        { className: 'slider-arrow-wrapper ' + direction + ' active', rel: 'nofollow', onClick: onClick },
        react_default.a.createElement('span', { className: 'arrow' })
    );
};

arrow_Arrow.propTypes = {
    direction: prop_types_default.a.string
};

/* harmony default export */ var arrow = (arrow_Arrow);
// CONCATENATED MODULE: ./src/utils/eventBus.js
var events = {};

function subscribe(evt, callback) {
    if (!events[evt]) {
        events[evt] = {
            listeners: []
        };
    }

    if (typeof callback === 'function') {
        events[evt].listeners.push(callback);
    }
}

function unsubscribe(evt, callback) {
    var foundIndex = -1;

    if (events[evt] && events[evt].listeners) {
        for (var i = 0; i < events[evt].listeners.length; i++) {
            if (events[evt].listeners[i] === callback) {
                foundIndex = i;
            }
        }

        if (foundIndex > -1) {
            events[evt].listeners.splice(foundIndex, 1);
        }
    }
}

function publish(evt, payload) {
    if (events[evt] && events[evt].listeners) {
        for (var i = 0; i < events[evt].listeners.length; i++) {
            events[evt].listeners[i](payload);
        }
    }
}
// CONCATENATED MODULE: ./src/shared/media/slider/index.js
var slider__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function slider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function slider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function slider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var slider_Slider = function (_Component) {
    slider__inherits(Slider, _Component);

    function Slider(props) {
        slider__classCallCheck(this, Slider);

        var _this = slider__possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

        _this.state = {
            slides: [],
            page: 0
        };

        _this.changeSlide = _this.changeSlide.bind(_this);
        return _this;
    }

    slider__createClass(Slider, [{
        key: 'changeSlide',
        value: function changeSlide(e, direction) {
            e.preventDefault();
            e.stopPropagation();

            var step = direction === 'next' ? 1 : -1,
                totalPages = this.state.slides.length;

            var currentPage = this.state.page;

            switch (currentPage + step) {
                case -1:
                    currentPage = totalPages - 1;
                    break;
                case totalPages:
                    currentPage = 0;
                    break;
                default:
                    currentPage = currentPage + step;
                    break;
            }

            publish('pauseInternalPlayers', { gigId: this.props.gigId });

            this.setState({
                page: currentPage
            });

            trackEvent('carousel_arrow_' + direction, this.props.cardType, this.props.cardSize);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var slideWidth = this.props.slideWidth || 230;
            this.state.slides = this.props.children; // eslint-disable-line

            var hasSlides = this.state.slides.length > 1;

            return react_default.a.createElement(
                'div',
                { className: 'media-slider' },
                hasSlides && react_default.a.createElement(arrow, { direction: 'next', onClick: function onClick(e) {
                        return _this2.changeSlide(e, 'next');
                    } }),
                react_default.a.createElement(
                    'div',
                    { className: 'slides', style: { width: this.state.slides.length * slideWidth, transform: 'translateX(-' + slideWidth * this.state.page + 'px)' } },
                    this.props.children
                ),
                hasSlides && react_default.a.createElement(arrow, { direction: 'prev', onClick: function onClick(e) {
                        return _this2.changeSlide(e, 'prev');
                    } })
            );
        }
    }]);

    return Slider;
}(react["Component"]);

slider_Slider.propTypes = {
    gigId: prop_types_default.a.number,
    children: prop_types_default.a.any
};

/* harmony default export */ var slider = (slider_Slider);
// CONCATENATED MODULE: ./src/shared/media/helpers.js
function getImgByCardSize(imageData, cardSize) {
    return cardSize === 'large' ? imageData.cloud_img_lrg : imageData.cloud_img_med_alt;
}

function getImgThumbUrl(img) {
    return img.match(/(src=")([^"]*)(")/g)[0].replace('src=', '').replace(/"/g, '');
}

function getImgSrcSet(img) {
    return img.match(/(srcset=")([^"]*)(")/g)[0].replace('srcset=', '').replace(/"/g, '');
}

function getMediaId(url) {
    return url.match(/\d+/g)[0];
}
// EXTERNAL MODULE: ./src/shared/media/player/style.scss
var player_style = __webpack_require__("ysQM");
var player_style_default = /*#__PURE__*/__webpack_require__.n(player_style);

// CONCATENATED MODULE: ./src/shared/media/player/index.js
var player__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function player__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function player__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function player__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var player_Player = function (_PureComponent) {
    player__inherits(Player, _PureComponent);

    function Player(props) {
        player__classCallCheck(this, Player);

        var _this = player__possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));

        _this.state = {
            isPlaying: false,
            showThumbnail: true,
            isMuted: false,
            progress: '100 100',
            currentPlayer: null,
            remainingPlaytime: null
        };

        _this.togglePlaying = _this.togglePlaying.bind(_this);
        _this.play = _this.play.bind(_this);
        _this.pause = _this.pause.bind(_this);
        _this.pauseInternalPlayers = _this.pauseInternalPlayers.bind(_this);
        _this.playerEnded = _this.playerEnded.bind(_this);
        _this.updateVideoProgress = _this.updateVideoProgress.bind(_this);
        _this.startTime = Date.now();
        _this.getRemainingPlaytime = _this.getRemainingPlaytime.bind(_this);
        return _this;
    }

    player__createClass(Player, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            subscribe('pauseAllPlayers', this.pause);
            subscribe('pauseInternalPlayers', this.pauseInternalPlayers);
            this.player.addEventListener('ended', this.playerEnded, false);
            this.player.addEventListener('timeupdate', this.updateVideoProgress, false);
            trackTime('player-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            unsubscribe('pauseAllPlayers', this.pause);
            unsubscribe('pauseInternalPlayers', this.pauseInternalPlayers);
            this.player.removeEventListener('ended', this.playerEnded, false);
            this.player.removeEventListener('timeupdate', this.updateVideoProgress, false);
            trackTime('player-component-did-unmount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'pauseInternalPlayers',
        value: function pauseInternalPlayers(payload) {
            if (payload.gigId === this.props.gigId) {
                this.pause();
            }
        }
    }, {
        key: 'playerEnded',
        value: function playerEnded() {
            this.setState({ isPlaying: false });
        }
    }, {
        key: 'updateVideoProgress',
        value: function updateVideoProgress() {
            var totalPercentage = 2 * 3.14 * 14,
                percentage = this.player.currentTime * totalPercentage / this.player.duration;

            this.setState({
                progress: percentage + ' 100',
                remainingPlaytime: this.getRemainingPlaytime(this.player.currentTime, this.player.duration)
            });
        }
    }, {
        key: 'play',
        value: function play() {
            publish('pauseAllPlayers', { gigId: this.props.gigId });

            if (this.props.media.asset_type === 'video') {
                this.setState({ showThumbnail: false });
            }

            this.setState({ isPlaying: true });
            this.player.play();
        }
    }, {
        key: 'pause',
        value: function pause() {
            this.setState({ isPlaying: false });
            this.player.pause();
        }
    }, {
        key: 'togglePlaying',
        value: function togglePlaying(e) {
            e.preventDefault();

            if (this.player.paused) {
                this.play();
                trackEvent('player_play', this.props.cardType, this.props.cardSize);

                // Magisto Video AB Test - BI Report
                this.reportForMagistoTest(this.props.gigId, this.props.userId, this.props.media.seller_id, this.props.cardType, this.props.cardSize);
            } else {
                this.pause();
                trackEvent('player_pause', this.props.cardType, this.props.cardSize);
            }
        }
    }, {
        key: 'reportForMagistoTest',
        value: function reportForMagistoTest(gigId, userId, sellerId, cardType, cardSize) {
            var magistoTestGigList = [97708643, 82072996, 44978164, 44098059, 41298300, 35947280, 31326435, 21001527, 13042844, 3663294],
                payload = { gigId: gigId, userId: userId, sellerId: sellerId, group: 'other',
                user: [{ id: userId, side: 'general' }, { id: sellerId, side: 'seller' }],
                gig: { id: gigId }
            };

            if (magistoTestGigList.indexOf(gigId) === -1) {
                return;
            }
            trackEvent('gig_video.click_play', cardType, cardSize, null, payload, 'bigquery');
        }
    }, {
        key: 'getRemainingPlaytime',
        value: function getRemainingPlaytime(currentTime, totalTime) {
            // Adding an extra second to prevent playback timer from showing "0:00"
            var remainingTime = totalTime - currentTime + 1,
                minutes = Math.floor(remainingTime / 60),
                seconds = Math.floor(remainingTime - minutes * 60);

            return minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                cardSize = _props.cardSize,
                media = _props.media,
                _state = this.state,
                showThumbnail = _state.showThumbnail,
                remainingPlaytime = _state.remainingPlaytime,
                progress = _state.progress,
                isPlaying = _state.isPlaying,
                videoThumb = cardSize === 'large' ? media.video_thumb_lrg : media.video_thumb,
                mediaId = getMediaId(media.video_stream_url),
                showRemainingPlaytime = this.state.remainingPlaytime && media.asset_type === 'audio';


            var remainingTimeClasses = classnames_default()('remaining-time', { 'is-visible': this.state.isPlaying }),
                mediaPlayerClasses = classnames_default()('media-player', cardSize, { 'backdrop': !showThumbnail }),
                gigVideoButtonClasses = classnames_default()('gig-video-button', { 'pause': isPlaying, 'play': !isPlaying }, 'js-gig-video-button');

            return react_default.a.createElement(
                'div',
                { className: mediaPlayerClasses },
                showThumbnail && react_default.a.createElement(thumbnail, { src: getImgThumbUrl(videoThumb) }),
                showRemainingPlaytime && react_default.a.createElement(
                    'span',
                    { className: remainingTimeClasses },
                    remainingPlaytime
                ),
                react_default.a.createElement(
                    'span',
                    { className: 'gig-video-button-wrapper' },
                    react_default.a.createElement('span', { onClick: this.togglePlaying, className: gigVideoButtonClasses, 'data-aux-data': 'new-video-button-was-clicked', 'data-graphite': '{"label": "gig_listing.video.click"}' }),
                    react_default.a.createElement(
                        'svg',
                        { className: 'video-player-progress-wrapper js-video-player-progress-wrapper', viewBox: '-2 -4 40 40' },
                        react_default.a.createElement('circle', { className: 'circle-progress-bar-background', r: '14', cx: '18', cy: '14' }),
                        react_default.a.createElement('circle', { style: { strokeDasharray: progress }, className: 'circle-progress-bar', r: '14', cx: '18', cy: '14' })
                    )
                ),
                media.asset_type === 'video' && react_default.a.createElement(
                    'video',
                    { key: 'player_' + mediaId, id: 'player_' + mediaId, ref: function ref(_ref) {
                            _this2.player = _ref;
                        } },
                    !showThumbnail && react_default.a.createElement('source', { src: media.video_stream_url, type: 'video/mp4' })
                ),
                media.asset_type === 'audio' && react_default.a.createElement(
                    'audio',
                    { key: 'player_' + mediaId, id: 'player_' + mediaId, ref: function ref(_ref2) {
                            _this2.player = _ref2;
                        } },
                    react_default.a.createElement('source', { src: media.video_stream_url, type: 'audio/mp4' })
                )
            );
        }
    }]);

    return Player;
}(react["PureComponent"]);

player_Player.propTypes = {
    gigId: prop_types_default.a.number,
    cardType: prop_types_default.a.string
};

/* harmony default export */ var player = (player_Player);
// EXTERNAL MODULE: ./src/shared/media/style.scss
var media_style = __webpack_require__("Repj");
var media_style_default = /*#__PURE__*/__webpack_require__.n(media_style);

// CONCATENATED MODULE: ./src/shared/media/index.js
var media__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function media__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function media__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function media__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var media_Media = function (_PureComponent) {
    media__inherits(Media, _PureComponent);

    function Media(props) {
        media__classCallCheck(this, Media);

        var _this = media__possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).call(this, props));

        _this.state = {
            assets: null,
            loadedAssets: false,
            slideWidth: 230
        };

        _this.loadAssets = _this.loadAssets.bind(_this);
        _this.getGigItemWidth = _.debounce(_this.getGigItemWidth, 250).bind(_this);
        _this.startTime = Date.now();
        return _this;
    }

    media__createClass(Media, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var assets = this.props.assets;

            this.setState({
                assets: assets
            });

            trackTime('media-component-will-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.getGigItemWidth);
            this.getGigItemWidth();

            trackTime('media-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(next) {
            if (next.assets && this.state.assets.length < next.assets.length) {
                var assets = next.assets;

                this.setState({
                    assets: assets
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.getGigItemWidth);
        }
    }, {
        key: 'getGigItemWidth',
        value: function getGigItemWidth() {
            var _this2 = this;

            var running = false;

            if (!running) {
                running = true;
                window.requestAnimationFrame(function () {
                    return _this2.setSlideWidth(function () {
                        return running = false;
                    });
                });
            }
        }
    }, {
        key: 'setSlideWidth',
        value: function setSlideWidth(callback) {
            var _this3 = this;

            this.setState(function (state) {
                var containerWidth = _this3.mediaContainer.offsetWidth;
                var nextState = state;

                if (containerWidth && state.slideWidth !== containerWidth) {
                    nextState = Object.assign({}, state, { slideWidth: containerWidth });
                }

                return nextState;
            }, callback);
        }
    }, {
        key: 'loadAssets',
        value: function loadAssets() {
            if (this.state.loadedAssets) {
                return;
            }

            var assets = this.state.assets.map(function (asset) {
                return Object.assign({}, asset, { visible: true });
            });

            this.setState({
                assets: assets,
                loadedAssets: true
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                assets = _state.assets,
                slideWidth = _state.slideWidth,
                _props = this.props,
                userId = _props.userId,
                gigId = _props.gigId,
                cardType = _props.cardType,
                cardSize = _props.cardSize;


            if (!assets) {
                return null;
            }

            return react_default.a.createElement(
                'div',
                { className: 'media-container', ref: function ref(el) {
                        return _this4.mediaContainer = el;
                    }, onMouseEnter: this.loadAssets },
                react_default.a.createElement(
                    slider,
                    { slideWidth: slideWidth, gigId: gigId, cardType: cardType, cardSize: cardSize },
                    assets.map(function (asset, index) {
                        return (index === 0 || asset.visible) && asset.asset_type === 'image' && react_default.a.createElement(
                            'div',
                            { key: 'wrapper-' + index + '-' + gigId, style: { 'width': slideWidth + 'px' } },
                            react_default.a.createElement(thumbnail, { key: 'thumb-' + index + '-' + gigId, src: getImgThumbUrl(getImgByCardSize(asset.image_data, cardSize)), srcSet: getImgSrcSet(getImgByCardSize(asset.image_data, cardSize)), cardType: cardType, cardSize: cardSize })
                        ) || ((index === 0 || asset.visible) && asset.asset_type === 'video' || asset.asset_type === 'audio') && react_default.a.createElement(
                            'div',
                            { key: 'wrapper-' + index + '-' + gigId, style: { 'width': slideWidth + 'px' } },
                            react_default.a.createElement(player, { key: 'player-' + index + '-' + gigId, media: asset, gigId: gigId, cardType: cardType, cardSize: cardSize, userId: userId })
                        );
                    })
                )
            );
        }
    }]);

    return Media;
}(react["PureComponent"]);

media_Media.propTypes = {
    assets: prop_types_default.a.array,
    gigId: prop_types_default.a.number,
    cardType: prop_types_default.a.string
};

var media_contextSelector = function contextSelector(_ref) {
    var cardType = _ref.cardType,
        cardSize = _ref.cardSize;
    return { cardType: cardType, cardSize: cardSize };
};

/* harmony default export */ var shared_media = (gig_card_context_withGigCardContext(media_contextSelector)(media_Media));

// EXTERNAL MODULE: ./src/shared/price/style.scss
var price_style = __webpack_require__("fRv3");
var price_style_default = /*#__PURE__*/__webpack_require__.n(price_style);

// CONCATENATED MODULE: ./src/shared/price/index.js







var price_Price = function Price(_ref) {
    var gigUrl = _ref.gigUrl,
        price = _ref.price,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize,
        abTests = _ref.abTests,
        averagePrice = _ref.averagePrice,
        medianPrice = _ref.medianPrice,
        showStartingAt = _ref.showStartingAt,
        isLimitedEdition = _ref.isLimitedEdition,
        isPlusPrice = _ref.isPlusPrice,
        onLinkClick = _ref.onLinkClick;

    var classes = ['gig-price'],
        avgMedPriceEnum = {
        2: averagePrice ? i18n.t('price.on_average') + ' ' + averagePrice : null,
        3: medianPrice ? i18n.t('price.most_successful') + ' ' + medianPrice : null
    },
        inAvgMedVariation = avgMedPriceEnum.hasOwnProperty(abTests.AVG_MEDIAN_PRICE_2),
        subPrice = avgMedPriceEnum[abTests.AVG_MEDIAN_PRICE_2];

    var onClick = function onClick(e) {
        trackEvent('price', cardType, cardSize);
        onLinkClick(e);
    };

    if (isPlusPrice) {
        showStartingAt = false;
        if (price) {
            price = price + '+';
        }
    }

    var prefix = showStartingAt ? i18n.t('price.starting_at') : '';

    if (isLimitedEdition) {
        prefix = i18n.t('price.only');
    }

    inAvgMedVariation && classes.push('med-avg-price');

    return react_default.a.createElement(
        'div',
        { className: classes.join(' ') },
        react_default.a.createElement(
            'a',
            { className: 'js-gig-card-imp-data', href: gigUrl, onClick: onClick },
            prefix && react_default.a.createElement(
                'small',
                null,
                prefix
            ),
            price,
            subPrice && react_default.a.createElement(
                'div',
                { className: 'gig-sub-price' },
                subPrice
            )
        )
    );
};

price_Price.propTypes = {
    gigUrl: prop_types_default.a.string.isRequired,
    price: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    cardType: prop_types_default.a.string,
    showStartingAt: prop_types_default.a.bool,
    averagePrice: prop_types_default.a.string,
    medianPrice: prop_types_default.a.string,
    onLinkClick: prop_types_default.a.func
};

price_Price.defaultProps = {
    abTests: {},
    onLinkClick: function onLinkClick() {
        return null;
    }
};

var price_contextSelector = function contextSelector(_ref2) {
    var cardType = _ref2.cardType,
        cardSize = _ref2.cardSize,
        abTests = _ref2.abTests;
    return { cardType: cardType, cardSize: cardSize, abTests: abTests };
};

/* harmony default export */ var shared_price = (gig_card_context_withGigCardContext(price_contextSelector)(price_Price));
// CONCATENATED MODULE: ./src/utils/getCurrency/index.js
/**
 * [description]
 * @param  {String|Number} price
 * @return {String}        converted currency (if converter available)
 */
var formatPrice = function formatPrice(price) {
  return '$' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var getCurrency = function getCurrency(price) {
  var getCurrencyString = typeof ft !== 'undefined' ? ft.utl.getCurrencyString : formatPrice; // eslint-disable-line no-undef

  return typeof price === 'number' || typeof price === 'string' ? getCurrencyString(price, true, true, true) : '';
};
// CONCATENATED MODULE: ./src/utils/adaptGigData/index.js
/**
 * Mutates the Gig data object
 * @param  {Object} gigData           Gig data object
 * @param  {Object} [options]
 * @param  {Object} [options.context] Context object
 * @return {Object} gigData           Mutated object
 */
var adaptGigData = function adaptGigData(gigData) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        context = _ref.context;

    if (!context) {
        return gigData;
    }

    return ['gig_url', 'seller_url'].reduce(function (gigData, item) {
        gigData[item] = addRefCtxId(gigData[item], context);

        return gigData;
    }, gigData);
};

/**
 * Add ref_ctx_id to URL where applicable
 * @param {String} url
 * @param {Object} [context={}]
 * @param {String} [context.refCtxId]
 * @param {String} [context.pageCtxId]
 */
var addRefCtxId = function addRefCtxId(url) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var ref_ctx_id = context.refCtxId || context.pageCtxId;

    if (!ref_ctx_id) {
        return url;
    }

    return new Fiverr.URI(url).addParams({ ref_ctx_id: ref_ctx_id }).href;
};
// CONCATENATED MODULE: ./src/utils/getGigAssets/index.js
function getGigAssets(gig) {
    var gigsAsyncAssets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var gigAssets = gig.assets && gig.assets.length > 0 ? gig.assets : [];
    var mainAsset = {
        img_medium: gig.img_medium,
        image_data: gig.image_data,
        asset_type: 'image'
    };

    if (gig.video_url) {
        mainAsset.asset_type = 'video';
        mainAsset.video_stream_url = gig.video_stream_url;
        mainAsset.video_thumb = gig.video_thumb;
        mainAsset.video_thumb_lrg = gig.video_thumb_lrg;
        mainAsset.video_url = gig.video_url;
        mainAsset.seller_id = gig.seller_id;
    }

    gigAssets.shift();
    gigAssets.unshift(mainAsset);

    // We still don't have slide assets.
    // maybe we got them from a separate ajax call
    if (gigAssets.length <= 1 && gigsAsyncAssets[gig.gig_id]) {
        gigAssets = gigAssets.concat(gigsAsyncAssets[gig.gig_id].slice(1));
    }

    return gigAssets;
}
// CONCATENATED MODULE: ./src/utils/gigCardExperiments/index.js
/**
 * Whether or not a user is in a certain experiments variation.
 * @param  {Object} [experiments={}] The hash of the users current experiments
 * @param  {String} [experimentKey=''] Key for the experiment to check
 * @param  {Number} [variation=2] value to check the against
 * @return {Boolean}
*/

var gigCardExperiments = function gigCardExperiments() {
  var experiments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var experimentKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var variation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return experiments[experimentKey] === variation;
  };
};
// EXTERNAL MODULE: ./node_modules/dateformat/lib/dateformat.js
var dateformat = __webpack_require__("CqLJ");
var dateformat_default = /*#__PURE__*/__webpack_require__.n(dateformat);

// CONCATENATED MODULE: ./src/utils/getItByDate/index.js



/**
 * Calculate the earliest date the gig can be delivered
 * @param  {Integer} {fastestDeliveryTime} The gig's fastest delivery time (number of days)
 * @return {String} The earliest date the gig can be delivered
 */

function getItByDate(fastestDeliveryTime) {
    var today = new Date(),
        deliveryDate = new Date(),
        isTomorrow = fastestDeliveryTime === 1;

    deliveryDate.setDate(today.getDate() + fastestDeliveryTime);

    var day = deliveryDate.getDate(),
        month = deliveryDate.getMonth(),
        dayOfWeekIndex = deliveryDate.getDay(),
        dayOfWeek = dateformat_default.a.i18n.dayNames[dayOfWeekIndex + 7],
        prefix = isTomorrow ? i18n.t('delivery_time.tomorrow') : dayOfWeek,
        monthName = dateformat_default.a.i18n.monthNames[month];

    return prefix + ', ' + monthName + ' ' + day;
}
// CONCATENATED MODULE: ./src/utils/getScoreText/index.js
function getScoreText(score) {

    return (score / 2).toFixed(1);
}
// CONCATENATED MODULE: ./src/utils/getRatingsCount/index.js
var COUNT_THRESHOLD = 1000;

/**
 * Makes sure rating count doesn't exceed the maximum count threshold
 * @param  {Integer} {count} Number of ratings a gig has recieved
 * @return {String || Integer} the rating count or 1k+ if it exceeds the threshold
 */

var getRatingsCount = function getRatingsCount(count) {
    if (count >= COUNT_THRESHOLD) {
        return '1k+';
    }

    return count;
};
// CONCATENATED MODULE: ./src/utils/index.js








// EXTERNAL MODULE: ./src/shared/tooltip/style.scss
var tooltip_style = __webpack_require__("z6RE");
var tooltip_style_default = /*#__PURE__*/__webpack_require__.n(tooltip_style);

// CONCATENATED MODULE: ./src/shared/tooltip/index.js




var tooltip_Tooltip = function Tooltip(_ref) {
    var children = _ref.children,
        className = _ref.className;
    return react_default.a.createElement(
        'div',
        { className: classnames_default()('gig-tooltip', className) },
        children
    );
};

/* harmony default export */ var tooltip = (tooltip_Tooltip);
// EXTERNAL MODULE: ./src/shared/rating/rating_tooltip/style.scss
var rating_tooltip_style = __webpack_require__("9QEA");
var rating_tooltip_style_default = /*#__PURE__*/__webpack_require__.n(rating_tooltip_style);

// CONCATENATED MODULE: ./src/shared/rating/rating_tooltip/index.js







var rating_tooltip_RatingTooltip = function RatingTooltip(_ref) {
    var score = _ref.score,
        ratingsCount = _ref.ratingsCount,
        recentScore = _ref.recentScore,
        recentRatingsCount = _ref.recentRatingsCount;
    return react_default.a.createElement(
        tooltip,
        { className: 'rating-tooltip' },
        react_default.a.createElement(
            'p',
            null,
            i18n.t('rating.reviews_by_period')
        ),
        react_default.a.createElement(
            'ul',
            null,
            react_default.a.createElement(
                'li',
                null,
                i18n.t('rating.last_60_days_score'),
                react_default.a.createElement(
                    'span',
                    null,
                    react_default.a.createElement(dist["SvgIcon"], { icon: 'full_star', color: 'yellow', width: 12, height: 12 }),
                    react_default.a.createElement(
                        'strong',
                        null,
                        getScoreText(recentScore)
                    ),
                    ' (',
                    getRatingsCount(recentRatingsCount),
                    ')'
                )
            ),
            react_default.a.createElement(
                'li',
                null,
                i18n.t('rating.lifetime_score'),
                react_default.a.createElement(
                    'span',
                    null,
                    react_default.a.createElement(dist["SvgIcon"], { icon: 'full_star', color: 'yellow', width: 12, height: 12 }),
                    react_default.a.createElement(
                        'strong',
                        null,
                        getScoreText(score)
                    ),
                    ' (',
                    getRatingsCount(ratingsCount),
                    ')'
                )
            )
        )
    );
};

rating_tooltip_RatingTooltip.propTypes = {
    score: prop_types_default.a.number,
    ratingsCount: prop_types_default.a.number,
    recentScore: prop_types_default.a.number,
    recentRatingsCount: prop_types_default.a.number
};

/* harmony default export */ var rating_tooltip = (rating_tooltip_RatingTooltip);
// EXTERNAL MODULE: ./src/shared/rating/style.scss
var rating_style = __webpack_require__("mFR0");
var rating_style_default = /*#__PURE__*/__webpack_require__.n(rating_style);

// CONCATENATED MODULE: ./src/shared/rating/index.js








var FULL_STAR = 'full_star';
var EMPTY_STAR = 'o_star';
var HALF_STAR = 'o_half_star';

var rating_Rating = function Rating(_ref) {
    var score = _ref.score,
        recentScore = _ref.recentScore,
        gigId = _ref.gigId,
        votes = _ref.votes,
        recentRatingsCount = _ref.recentRatingsCount,
        starSize = _ref.starSize,
        starCount = _ref.starCount,
        isPro = _ref.isPro,
        recentRatingsExp = _ref.recentRatingsExp,
        isProExperience = _ref.isProExperience;

    var scoreText = recentRatingsExp ? getScoreText(recentScore) : getScoreText(score),
        showArrow = false,
        // Will be implemented in a later experiment
    arrowDirection = score < recentScore ? 'fa-arrow-up' : 'fa-arrow-down',
        starsScoreNum = Math.round(parseFloat(scoreText) * 2) / 2,
        starAttrs = {
        icon: FULL_STAR,
        color: isProExperience ? 'pro' : 'yellow',
        width: starSize,
        height: starSize
    },
        stars = [],
        isNonRatedProSeller = score <= 0 && isPro,
        showScore = score > 0,
        showRatingTooltip = recentRatingsExp && !isProExperience;

    var votesText = '(' + getRatingsCount(votes) + ')';

    if (recentRatingsExp) {
        votesText = recentRatingsCount ? '(' + getRatingsCount(recentRatingsCount) + ')' : null;
    }

    for (var star = 1; star <= starCount; star++) {
        if (starCount > 1) {
            if (star <= starsScoreNum) {
                starAttrs.icon = FULL_STAR;
            } else if (star > Math.round(starsScoreNum)) {
                starAttrs.icon = EMPTY_STAR;
            } else {
                starAttrs.icon = HALF_STAR;
            }
        }

        starAttrs.key = 'gig-rating-' + gigId;

        stars.push(react_default.a.createElement(dist["SvgIcon"], starAttrs));
    }

    return react_default.a.createElement(
        'span',
        { className: classnames_default()('gig-rating', { 'with-arrow': showArrow }) },
        stars,
        isNonRatedProSeller && react_default.a.createElement(
            'strong',
            null,
            isProExperience ? i18n.t('rating.be_the_first_to_rate_pro') : i18n.t('rating.be_the_first_to_rate')
        ),
        showScore && react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(
                'strong',
                null,
                scoreText
            ),
            showArrow ? react_default.a.createElement('i', { className: classnames_default()('fa', arrowDirection) }) : ' ',
            votesText
        ),
        showRatingTooltip && react_default.a.createElement(rating_tooltip, { score: score, ratingsCount: votes, recentScore: recentScore, recentRatingsCount: recentRatingsCount })
    );
};

rating_Rating.propTypes = {
    score: prop_types_default.a.number,
    votes: prop_types_default.a.number,
    recentScore: prop_types_default.a.number,
    gigId: prop_types_default.a.number,
    starSize: prop_types_default.a.number,
    starCount: prop_types_default.a.number,
    isPro: prop_types_default.a.bool,
    recentRatingsExp: prop_types_default.a.bool,
    isProExperience: prop_types_default.a.bool
};

/* harmony default export */ var rating = (rating_Rating);
// CONCATENATED MODULE: ./src/shared/seller_country/index.js




var seller_country_SellerCountry = function SellerCountry(_ref) {
    var country = _ref.country,
        comma = _ref.comma;
    return react_default.a.createElement(
        'span',
        { className: 'seller-country' },
        comma ? ', ' : '',
        i18n.t('general.from'),
        ' ',
        country
    );
};

seller_country_SellerCountry.propTypes = {
    country: prop_types_default.a.string,
    comma: prop_types_default.a.bool
};

/* harmony default export */ var seller_country = (seller_country_SellerCountry);
// EXTERNAL MODULE: ./src/shared/seller_info/style.scss
var seller_info_style = __webpack_require__("LlhT");
var seller_info_style_default = /*#__PURE__*/__webpack_require__.n(seller_info_style);

// CONCATENATED MODULE: ./src/shared/seller_info/index.js




var seller_info_SellerInfo = function SellerInfo(_ref) {
    var children = _ref.children;
    return react_default.a.createElement(
        'div',
        { className: 'gig-seller-info' },
        children
    );
};

seller_info_SellerInfo.propTypes = {
    children: prop_types_default.a.oneOfType([prop_types_default.a.arrayOf(prop_types_default.a.oneOfType([prop_types_default.a.bool, prop_types_default.a.element])), prop_types_default.a.element])
};

/* harmony default export */ var seller_info = (seller_info_SellerInfo);
// EXTERNAL MODULE: ./src/shared/seller_level/style.scss
var seller_level_style = __webpack_require__("W2uZ");
var seller_level_style_default = /*#__PURE__*/__webpack_require__.n(seller_level_style);

// CONCATENATED MODULE: ./src/shared/seller_level/index.js




var seller_level_SellerLevel = function SellerLevel(_ref) {
    var level = _ref.level,
        isPro = _ref.isPro,
        isLimitedEdition = _ref.isLimitedEdition,
        isNewSeller = _ref.isNewSeller,
        tooltipPositionClass = _ref.tooltipPositionClass;

    var sellerLevelProps = {
        className: 'gig-seller-tooltip'
    };

    var levelText = '';

    if (isLimitedEdition) {
        level = 'pro_spotlight_seller';
    }

    switch (level) {
        case 'level_one_seller':
        case 'level_two_seller':
        case 'pro_spotlight_seller':
            levelText = i18n.t('seller_levels.' + level);
            break;
        case 'top_rated_seller':
            levelText = i18n.t('seller_levels.' + level);
            levelText = react_default.a.createElement(
                'em',
                null,
                levelText
            );
            break;
        default:
            if (isPro) {
                levelText = i18n.t('seller_levels.new_pro');
            } else if (isNewSeller) {
                levelText = i18n.t('seller_levels.new_seller');
            }

            break;
    }

    if (level) {
        sellerLevelProps.className += ' badge-hint js-badge-hint ' + tooltipPositionClass;
        sellerLevelProps['data-hint'] = i18n.t('seller_levels.' + level + '_tooltip');
    }

    return levelText ? react_default.a.createElement(
        'div',
        sellerLevelProps,
        react_default.a.createElement(
            'span',
            { className: 'seller-level' },
            levelText
        )
    ) : null;
};

seller_level_SellerLevel.propTypes = {
    level: prop_types_default.a.string,
    isPro: prop_types_default.a.bool,
    isLimitedEdition: prop_types_default.a.bool,
    isNewSeller: prop_types_default.a.bool,
    tooltipPositionClass: prop_types_default.a.string
};

/* harmony default export */ var seller_level = (seller_level_SellerLevel);
// CONCATENATED MODULE: ./src/shared/seller_response_time/index.js



var seller_response_time_SellerResponseTime = function SellerResponseTime(_ref) {
    var responseTime = _ref.responseTime,
        comma = _ref.comma;
    return react_default.a.createElement(
        'span',
        { className: 'seller-response-time' },
        comma ? ', ' : '',
        responseTime,
        ' Avg Response Time'
    );
};

seller_response_time_SellerResponseTime.propTypes = {
    comma: prop_types_default.a.bool,
    responseTime: prop_types_default.a.string
};

/* harmony default export */ var seller_response_time = (seller_response_time_SellerResponseTime);
// EXTERNAL MODULE: ./src/shared/delivery_time/style.scss
var delivery_time_style = __webpack_require__("dZ1e");
var delivery_time_style_default = /*#__PURE__*/__webpack_require__.n(delivery_time_style);

// CONCATENATED MODULE: ./src/shared/delivery_time/index.js







var MAX_DELIVERY_TIME = 7;

var delivery_time_DeliveryTime = function DeliveryTime(_ref) {
    var gigUrl = _ref.gigUrl,
        deliveryTime = _ref.deliveryTime,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize;

    var shouldDisplayDeliveryTime = deliveryTime > 0 && deliveryTime < MAX_DELIVERY_TIME;

    return react_default.a.createElement(
        'div',
        { className: 'get-it-by' },
        shouldDisplayDeliveryTime && react_default.a.createElement(
            'a',
            { href: gigUrl,
                onClick: function onClick() {
                    return trackEvent('delivery_time', cardType, cardSize);
                } },
            react_default.a.createElement(
                'span',
                null,
                ' ',
                i18n.t('delivery_time.get_it_by'),
                ' ',
                react_default.a.createElement(
                    'strong',
                    null,
                    getItByDate(deliveryTime)
                )
            )
        )
    );
};

delivery_time_DeliveryTime.propTypes = {
    gigUrl: prop_types_default.a.string,
    deliveryTime: prop_types_default.a.number,
    cardType: prop_types_default.a.string
};

var delivery_time_contextSelector = function contextSelector(_ref2) {
    var cardType = _ref2.cardType,
        cardSize = _ref2.cardSize;
    return { cardType: cardType, cardSize: cardSize };
};

/* harmony default export */ var delivery_time = (gig_card_context_withGigCardContext(delivery_time_contextSelector)(delivery_time_DeliveryTime));
// EXTERNAL MODULE: ./src/shared/title/style.scss
var title_style = __webpack_require__("bv8i");
var title_style_default = /*#__PURE__*/__webpack_require__.n(title_style);

// CONCATENATED MODULE: ./src/shared/title/index.js






var title_Title = function Title(_ref) {
    var gigUrl = _ref.gigUrl,
        caption = _ref.caption,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize,
        onLinkClick = _ref.onLinkClick;

    var onClick = function onClick(e) {
        trackEvent('title', cardType, cardSize);
        onLinkClick(e);
    };

    return react_default.a.createElement(
        'a',
        { href: gigUrl,
            onClick: onClick,
            className: 'gig-link-main js-gig-card-imp-data',
            rel: 'nofollow',
            title: caption },
        react_default.a.createElement(
            'h3',
            null,
            caption
        )
    );
};

title_Title.propTypes = {
    gigUrl: prop_types_default.a.string,
    caption: prop_types_default.a.string,
    cardType: prop_types_default.a.string,
    onLinkClick: prop_types_default.a.func
};

title_Title.defaultProps = {
    onLinkClick: function onLinkClick() {
        return null;
    }
};

var title_contextSelector = function contextSelector(_ref2) {
    var cardType = _ref2.cardType,
        cardSize = _ref2.cardSize;
    return { cardType: cardType, cardSize: cardSize };
};

/* harmony default export */ var title = (gig_card_context_withGigCardContext(title_contextSelector)(title_Title));
// CONCATENATED MODULE: ./src/shared/username/index.js





var username_Username = function Username(_ref) {
    var name = _ref.name,
        url = _ref.url,
        prefix = _ref.prefix,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize;
    return react_default.a.createElement(
        'a',
        { href: url, rel: 'nofollow', className: 'seller-name', onClick: function onClick() {
                return trackEvent('username', cardType, cardSize);
            } },
        prefix ? prefix + ' ' : '',
        name
    );
};

username_Username.propTypes = {
    name: prop_types_default.a.string,
    url: prop_types_default.a.string,
    prefix: prop_types_default.a.string,
    cardType: prop_types_default.a.string
};

var username_contextSelector = function contextSelector(_ref2) {
    var cardType = _ref2.cardType,
        cardSize = _ref2.cardSize;
    return { cardType: cardType, cardSize: cardSize };
};

/* harmony default export */ var username = (gig_card_context_withGigCardContext(username_contextSelector)(username_Username));
// CONCATENATED MODULE: ./src/shared/index.js
























// CONCATENATED MODULE: ./src/mp_gig_card/GigCard.js
var GigCard__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function GigCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GigCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GigCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// TODO: clean up isFooterReversed and make this a functional component

var GigCard_GigCard = function (_PureComponent) {
    GigCard__inherits(GigCard, _PureComponent);

    function GigCard(props) {
        GigCard__classCallCheck(this, GigCard);

        var _this = GigCard__possibleConstructorReturn(this, (GigCard.__proto__ || Object.getPrototypeOf(GigCard)).call(this, props));

        _this.state = {
            unmounting: false,
            gigsAssets: []
        };

        _this.onLinkClick = _this.onLinkClick.bind(_this);

        i18n.add(translations_en_default.a);
        return _this;
    }

    GigCard__createClass(GigCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Any data that requires the use of the window object
            // should be initialized here due to SSR restrictions.

            this.setState({ // eslint-disable-line
                gigPrice: getCurrency(this.props.gig.price_i, true),
                averagePrice: this.props.gig.average_price && getCurrency(this.props.gig.average_price, true),
                medianPrice: this.props.gig.median_price && getCurrency(this.props.gig.median_price, true)
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(next) {
            if (!this.state.gigsAssets.length && next.gigsAssets && next.gigsAssets.assets) {

                this.setState({
                    gigsAssets: next.gigsAssets.assets
                });
            }
        }
    }, {
        key: 'isFooterReversed',
        value: function isFooterReversed(abTests) {
            var avgMedVariations = [2, 3];

            return abTests && avgMedVariations.indexOf(abTests.AVG_MEDIAN_PRICE_2) > -1;
        }
    }, {
        key: 'getTooltipPositionClass',
        value: function getTooltipPositionClass() {
            var gigPosition = this.props.gigIndex + 1;
            var shouldBeRightAligned = false;

            switch (this.props.cardSize) {
                case 'large':
                    shouldBeRightAligned = !(gigPosition % 3);
                    break;
                case 'medium':
                    shouldBeRightAligned = !(gigPosition % 4) || !((gigPosition + 1) % 4);
                    break;
                default:
                    break;
            }

            return shouldBeRightAligned ? 'hint--bottom-right' : 'hint--bottom';
        }
    }, {
        key: 'onLinkClick',
        value: function onLinkClick(e) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'gig';
            var _props = this.props,
                gig = _props.gig,
                onLinkClick = _props.onLinkClick;


            onLinkClick(e, { type: type, gig: gig });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                user = _props2.user,
                updateCollections = _props2.updateCollections,
                gig = _props2.gig,
                context = _props2.context,
                gigsAssets = this.state.gigsAssets;


            var inExperiment = gigCardExperiments(context.abTests),
                userId = user && user.userId || null,
                risingTalent = gigTypes_isRisingTalent(gig.type),
                shouldRenderRating = (gig.rating > 0 || gig.is_pro) && !risingTalent,
                isLimitedEdition = gig.is_limited_edition,
                shouldRenderDeliveryTime = inExperiment('GET_IT_BY'),
                showHighCompletionRate = inExperiment('HIGH_COMPLETION_RATE_GIG_BADGE') && gig.high_completion_rate,
                showRecentRatings = inExperiment('LAST_60_DAYS_RATINGS') && !gig.is_pro && gig.last_60_days_rating_count > 0,
                isPlusPrice = inExperiment('PLUS_PRICE') || inExperiment('1532'),
                isProExperience = inExperiment('PRO_EXPERIENCE') && gig.is_pro,
                tooltipPositionClass = this.getTooltipPositionClass(),
                showSellerLevel = !risingTalent && !isProExperience;

            adaptGigData(gig, { context: context });

            return react_default.a.createElement(
                card_shell,
                { cardType: 'card', cacheKey: 'gig_card-' + gig.cacheKey, key: gig.gig_id, type: 'mp-gig-card', gigId: gig.gig_id, cachedSlug: gig.cached_slug, position: gig.pos, isProExperience: isProExperience, isLimitedEdition: isLimitedEdition },
                react_default.a.createElement(
                    'a',
                    { key: 'title-link-' + gig.gig_id, href: gig.gig_url, className: 'js-gig-card-imp-data', onClick: this.onLinkClick },
                    react_default.a.createElement(shared_media, { key: 'media-' + gig.gig_id, assets: getGigAssets(gig, gigsAssets), gigId: gig.gig_id, userId: userId })
                ),
                gigTypes_inPpcAdBadgeTest(gig.type) && react_default.a.createElement(
                    dist["Status"],
                    { classes: 'ppc-badge' },
                    i18n.t('badges.ppc.caption')
                ),
                react_default.a.createElement(
                    'div',
                    { className: 'gig-card-caption' },
                    react_default.a.createElement(
                        seller_info,
                        null,
                        gig.is_seller_online && react_default.a.createElement('span', { className: 'is-online' }),
                        react_default.a.createElement(dist["Avatar"], { src: gig.seller_img }),
                        react_default.a.createElement(
                            'div',
                            { className: 'seller-info-wrapper' },
                            react_default.a.createElement(username, { name: gig.seller_name, url: gig.seller_url }),
                            showSellerLevel && react_default.a.createElement(seller_level, { level: gig.seller_level, isPro: gig.is_pro, isLimitedEdition: isLimitedEdition, isNewSeller: gig.is_new_seller, tooltipPositionClass: tooltipPositionClass })
                        )
                    ),
                    react_default.a.createElement(title, { gigUrl: gig.gig_url,
                        caption: gig.iwill_title,
                        onLinkClick: this.onLinkClick }),
                    react_default.a.createElement(
                        'div',
                        { className: 'rating-badges-container' },
                        shouldRenderRating && !isLimitedEdition && react_default.a.createElement(rating, { score: gig.rating, recentScore: gig.last_60_days_rating_avg, gigId: gig.gig_id, votes: gig.rating_count, recentRatingsCount: gig.last_60_days_rating_count, starSize: 15, starCount: 1, isPro: gig.is_pro, recentRatingsExp: showRecentRatings, isProExperience: isProExperience }),
                        react_default.a.createElement(gig_badges, { featured: gig.is_featured,
                            limitedEdition: gig.is_limited_edition,
                            limitedEditionDeadline: gig.limited_edition_expires_at,
                            qualityChoice: gig.quality_choice,
                            reliable: showHighCompletionRate,
                            availableNow: gig.is_available_now,
                            type: gig.type,
                            sellerName: gig.seller_name,
                            pro: gig.is_pro,
                            gigId: gig.gig_id,
                            tooltipPositionClass: tooltipPositionClass,
                            isProExperience: isProExperience })
                    )
                ),
                shouldRenderDeliveryTime && react_default.a.createElement(delivery_time, { deliveryTime: gig.fastest_delivery_time, gigUrl: gig.gig_url }),
                react_default.a.createElement(
                    'footer',
                    { className: 'gig-card-footer' + (this.isFooterReversed(context.abTests) ? ' reversed' : '') },
                    react_default.a.createElement(collect_gig, { gigId: gig.gig_id, sellerId: gig.seller_id, updateCollections: updateCollections, user: user, showCollMenu: true, icon: 'ficon ficon-bars' }),
                    react_default.a.createElement(shared_price, { gigUrl: gig.gig_url,
                        price: this.state.gigPrice,
                        showStartingAt: gig.show_starting_at,
                        isLimitedEdition: isLimitedEdition,
                        averagePrice: this.state.averagePrice,
                        isPlusPrice: isPlusPrice,
                        medianPrice: this.state.medianPrice,
                        onLinkClick: this.onLinkClick })
                )
            );
        }
    }]);

    return GigCard;
}(react["PureComponent"]);

GigCard_GigCard.propTypes = {
    user: prop_types_default.a.object,
    gig: prop_types_default.a.object,
    gigIndex: prop_types_default.a.number,
    cardSize: prop_types_default.a.string,
    context: prop_types_default.a.shape({
        pageCtxId: prop_types_default.a.string,
        refCtxId: prop_types_default.a.string,
        abTests: prop_types_default.a.object
    }),
    onLinkClick: prop_types_default.a.func
};

GigCard_GigCard.defaultProps = {
    context: {},
    onLinkClick: function onLinkClick() {
        return null;
    }
};

/* harmony default export */ var mp_gig_card_GigCard = (GigCard_GigCard);
// EXTERNAL MODULE: ./src/shared/gig_cards_repeater/style.scss
var gig_cards_repeater_style = __webpack_require__("yhus");
var gig_cards_repeater_style_default = /*#__PURE__*/__webpack_require__.n(gig_cards_repeater_style);

// CONCATENATED MODULE: ./src/shared/gig_cards_repeater/index.js





var gig_cards_repeater_GigCardsRepeater = function GigCardsRepeater(_ref) {
    var context = _ref.context,
        children = _ref.children,
        responsiveGrid = _ref.responsiveGrid;

    var classes = ['react-gig-cards-slider', 'slider-hider'];

    responsiveGrid ? classes.push('row') : classes.push('cf');

    return react_default.a.createElement(
        gig_card_context_GigCardContextProvider,
        { value: context },
        react_default.a.createElement(
            'div',
            { className: classes.join(' ') },
            children.map(function (child, i) {
                return react_default.a.createElement(
                    'div',
                    { key: 'gig_item_' + i, className: 'gig-item ' + context.cardSize },
                    child
                );
            })
        )
    );
};

gig_cards_repeater_GigCardsRepeater.propTypes = {
    context: prop_types_default.a.object,
    children: prop_types_default.a.array,
    responsiveGrid: prop_types_default.a.bool
};

/* harmony default export */ var gig_cards_repeater = (gig_cards_repeater_GigCardsRepeater);
// CONCATENATED MODULE: ./src/utils/enrichGigsData/index.js


var serializeJson = function serializeJson(ary) {
    return Object.keys(ary).map(function (key) {
        if (Array.isArray(ary[key])) {
            var arrayParts = [];
            for (var i = 0; i < ary[key].length; i++) {
                arrayParts.push(encodeURIComponent(key + '[]') + '=' + encodeURIComponent(ary[key][i]));
            }
            return arrayParts.join('&');
        }
        return encodeURIComponent(key) + '=' + encodeURIComponent(ary[key]);
    }).join('&');
};

/**
 * Mutates the Gig data object
 * @param  {Object} gigData           Gig data object
 * @param  {Object} [options]
 * @param  {Object} [options.context] Context object
 * @return {Object} gigData           Mutated object
 */
var enrichGigsData = function enrichGigsData(gigs) {
    if (gigs && gigs.length) {

        var gigIds = gigs.map(function (gig) {
            return gig.gig_id;
        });

        return gofor('/cards/assets?' + serializeJson({ gig_ids: gigIds }), {
            method: 'GET',
            dataType: 'json',
            headers: {
                'Accept': 'text/javascript'
            }
        }).then(function (response) {
            return response.ok && response.json();
        }).then(function (data) {
            return data;
        });
    }
};

/* harmony default export */ var utils_enrichGigsData = (enrichGigsData);
// EXTERNAL MODULE: ./src/mp_gig_card/style.scss
var mp_gig_card_style = __webpack_require__("C4SN");
var mp_gig_card_style_default = /*#__PURE__*/__webpack_require__.n(mp_gig_card_style);

// CONCATENATED MODULE: ./src/mp_gig_card/index.js
var mp_gig_card__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var mp_gig_card__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function mp_gig_card__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mp_gig_card__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mp_gig_card__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var mp_gig_card_GigCards = function (_PureComponent) {
    mp_gig_card__inherits(GigCards, _PureComponent);

    function GigCards(props) {
        mp_gig_card__classCallCheck(this, GigCards);

        var _this = mp_gig_card__possibleConstructorReturn(this, (GigCards.__proto__ || Object.getPrototypeOf(GigCards)).call(this, props));

        _this.state = {
            unmounting: false,
            collections: false,
            gigsAssets: []
        };

        i18n.add(translations_en_default.a);

        _this.getCollections = _this.getCollections.bind(_this);
        _this.updateCollections = _this.updateCollections.bind(_this);
        return _this;
    }

    mp_gig_card__createClass(GigCards, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.user) {
                this.getCollections().then(function (json) {
                    _this2.setState({ collections: json });
                });
            }

            if (this.props.shouldEnrichData) {
                utils_enrichGigsData(this.props.gigs).then(function (assets) {
                    _this2.setState({ gigsAssets: assets });
                });
            }
        }
    }, {
        key: 'updateCollections',
        value: function updateCollections(collections, callback) {
            this.setState({ collections: collections }, typeof callback === 'function' && callback);
        }
    }, {
        key: 'getCollections',
        value: function getCollections() {
            var _this3 = this;

            var _props = this.props,
                gigs = _props.gigs,
                user = _props.user,
                hearts = gigs.map(function (gig) {
                return gig.gig_id;
            });


            if (!user) {
                return;
            }

            return collection.getCollections(hearts).then(function (json) {
                _this3.setState({ collections: json });return json;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                gigs = _props2.gigs,
                user = _props2.user,
                cardSize = _props2.cardSize,
                responsiveGrid = _props2.responsiveGrid,
                context = _props2.context,
                onLinkClick = _props2.onLinkClick,
                _state = this.state,
                collections = _state.collections,
                gigsAssets = _state.gigsAssets;


            return react_default.a.createElement(
                gig_cards_repeater,
                { context: mp_gig_card__extends({ cardType: 'card', cardSize: cardSize, collections: collections, user: user }, context), responsiveGrid: responsiveGrid },
                gigs.map(function (gig, i) {
                    return react_default.a.createElement(mp_gig_card_GigCard, { key: gig.gig_id, gig: gig, updateCollections: _this4.updateCollections, user: user, gigsAssets: gigsAssets, context: context, gigIndex: i, cardSize: cardSize, onLinkClick: onLinkClick });
                })
            );
        }
    }]);

    return GigCards;
}(react["PureComponent"]);

mp_gig_card_GigCards.propTypes = {
    responsiveGrid: prop_types_default.a.bool,
    user: prop_types_default.a.object,
    gigs: prop_types_default.a.array,
    cardSize: prop_types_default.a.string,
    context: prop_types_default.a.shape({
        pageCtxId: prop_types_default.a.string,
        refCtxId: prop_types_default.a.string
    }),
    onLinkClick: prop_types_default.a.func
};

mp_gig_card_GigCards.defaultProps = {
    cardSize: 'medium',
    context: {},
    responsiveGrid: false,
    onLinkClick: function onLinkClick() {
        return null;
    }
};

/* harmony default export */ var mp_gig_card = (mp_gig_card_GigCards);
// EXTERNAL MODULE: ./src/list_view_card/style.scss
var list_view_card_style = __webpack_require__("odPn");
var list_view_card_style_default = /*#__PURE__*/__webpack_require__.n(list_view_card_style);

// CONCATENATED MODULE: ./src/list_view_card/ListView.js








var ListView_ListViewItem = function ListViewItem(_ref) {
    var gig = _ref.gig,
        user = _ref.user,
        updateCollections = _ref.updateCollections,
        context = _ref.context,
        onLinkClick = _ref.onLinkClick;

    var inExperiment = gigCardExperiments(context.abTests),
        userId = user && user.userId || null,
        risingTalent = gigTypes_isRisingTalent(gig.type),
        showHighCompletionRate = inExperiment('HIGH_COMPLETION_RATE_GIG_BADGE') && gig.high_completion_rate,
        showRecentRatings = inExperiment('LAST_60_DAYS_RATINGS') && !gig.is_pro && gig.last_60_days_rating_count > 0,
        isLimitedEdition = gig.is_limited_edition,
        shouldRenderRating = (gig.rating > 0 || gig.is_pro) && !risingTalent && !isLimitedEdition,
        isProExperience = inExperiment('PRO_EXPERIENCE') && gig.is_pro,
        tooltipPositionClass = 'hint--bottom-right',
        showSellerLevel = !risingTalent && !isProExperience,
        sellerCountryComma = (!!gig.seller_level || gig.is_pro) && !isProExperience;

    var onLinkClickWrapper = function onLinkClickWrapper(e) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'gig';

        onLinkClick(e, { type: type, gig: gig });
    };

    adaptGigData(gig, { context: context });

    return react_default.a.createElement(
        card_shell,
        { key: gig.gig_id, type: 'list-view-card', gigId: gig.gig_id, isProExperience: isProExperience, isLimitedEdition: isLimitedEdition },
        react_default.a.createElement(
            'div',
            { className: 'flex-row' },
            react_default.a.createElement(
                'div',
                { className: 'col-media' },
                react_default.a.createElement(
                    'a',
                    { href: gig.gig_url, className: 'js-gig-card-imp-data', onClick: onLinkClickWrapper },
                    react_default.a.createElement(shared_media, { assets: getGigAssets(gig), gigId: gig.gig_id, userId: userId })
                )
            ),
            react_default.a.createElement(
                'div',
                { className: 'col-gig-info' },
                react_default.a.createElement(title, { gigUrl: gig.gig_url, caption: gig.iwill_title, onLinkClick: onLinkClickWrapper }),
                react_default.a.createElement(
                    'div',
                    { className: 'desktop' },
                    react_default.a.createElement(
                        seller_info,
                        null,
                        gig.is_seller_online && react_default.a.createElement('span', { className: 'is-online' }),
                        react_default.a.createElement(dist["Avatar"], { src: gig.seller_img }),
                        react_default.a.createElement(username, { name: gig.seller_name, url: gig.seller_url, prefix: i18n.t('general.by'), context: context }),
                        showSellerLevel && react_default.a.createElement(seller_level, { level: gig.seller_level, isPro: gig.is_pro, isNewSeller: gig.is_new_seller, tooltipPositionClass: tooltipPositionClass }),
                        gig.seller_country_name && react_default.a.createElement(seller_country, { country: gig.seller_country_name, comma: sellerCountryComma }),
                        gig.seller_avg_response && react_default.a.createElement(seller_response_time, { responseTime: gig.seller_avg_response, comma: true })
                    ),
                    react_default.a.createElement(shared_price, { gigUrl: gig.gig_url,
                        price: getCurrency(gig.price_i, true),
                        showStartingAt: gig.show_starting_at,
                        averagePrice: getCurrency(gig.average_price),
                        medianPrice: getCurrency(gig.median_price),
                        onLinkClick: onLinkClickWrapper })
                ),
                react_default.a.createElement(
                    'div',
                    { className: 'rating-badges-container' },
                    shouldRenderRating && react_default.a.createElement(rating, { score: gig.rating, recentScore: gig.last_60_days_rating_avg, gigId: gig.gig_id, votes: gig.rating_count, recentRatingsCount: gig.last_60_days_rating_count, starSize: 16, starCount: 1, isPro: gig.is_pro, recentRatingsExp: showRecentRatings, isProExperience: isProExperience }),
                    react_default.a.createElement(gig_badges, { featured: gig.is_featured,
                        limitedEdition: gig.is_limited_edition,
                        limitedEditionDeadline: gig.limited_edition_expires_at,
                        qualityChoice: gig.quality_choice,
                        reliable: showHighCompletionRate,
                        availableNow: gig.is_available_now,
                        type: gig.type,
                        sellerName: gig.seller_name,
                        pro: gig.is_pro,
                        gigId: gig.gig_id,
                        tooltipPositionClass: tooltipPositionClass,
                        isProExperience: isProExperience })
                ),
                react_default.a.createElement(list_view_info, { platforms: gig.metadata && gig.metadata.platform ? gig.metadata.platform : null,
                    skills: gig.skills,
                    avgDeliveryTime: gig.avg_delivery_time }),
                react_default.a.createElement(collect_gig, { gigId: gig.gig_id, sellerId: gig.seller_id, updateCollections: updateCollections, user: user, showCollMenu: true, icon: 'fa fa-ellipsis-v' })
            )
        ),
        react_default.a.createElement(
            'div',
            { className: 'flex-row space-between mobile' },
            react_default.a.createElement(
                seller_info,
                null,
                gig.is_seller_online && react_default.a.createElement('span', { className: 'is-online' }),
                react_default.a.createElement(dist["Avatar"], { src: gig.seller_img }),
                react_default.a.createElement(
                    'div',
                    { className: 'seller-info-wrapper' },
                    react_default.a.createElement(username, { name: gig.seller_name, url: gig.seller_url, prefix: i18n.t('general.by'), context: context }),
                    showSellerLevel && react_default.a.createElement(seller_level, { level: gig.seller_level, isPro: gig.is_pro, isLimitedEdition: isLimitedEdition, isNewSeller: gig.is_new_seller, tooltipPositionClass: tooltipPositionClass })
                )
            ),
            react_default.a.createElement(shared_price, { gigUrl: gig.gig_url,
                price: getCurrency(gig.price_i, true),
                showStartingAt: gig.show_starting_at,
                isLimitedEdition: isLimitedEdition,
                averagePrice: getCurrency(gig.average_price),
                medianPrice: getCurrency(gig.median_price),
                onLinkClick: onLinkClickWrapper })
        )
    );
};

ListView_ListViewItem.propTypes = {
    gig: prop_types_default.a.object,
    updateCollections: prop_types_default.a.func,
    context: prop_types_default.a.object,
    onLinkClick: prop_types_default.a.func
};

ListView_ListViewItem.defaultProps = {
    context: {},
    onLinkClick: function onLinkClick() {
        return null;
    }
};

/* harmony default export */ var list_view_card_ListView = (ListView_ListViewItem);
// CONCATENATED MODULE: ./src/utils/mediaListener.js
function addMediaListener(mediaQuery, callBack) {
    var mq = window && window.matchMedia(mediaQuery),
        handler = function handler() {
        return callBack(mq);
    };

    mq.addListener(handler);

    callBack(mq);

    return function () {
        return mq.removeListener(handler);
    };
}
// CONCATENATED MODULE: ./src/list_view_card/index.js
var list_view_card__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var list_view_card__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function list_view_card__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function list_view_card__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function list_view_card__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var src_list_view_card_ListView = function (_PureComponent) {
    list_view_card__inherits(ListView, _PureComponent);

    function ListView(props) {
        list_view_card__classCallCheck(this, ListView);

        var _this = list_view_card__possibleConstructorReturn(this, (ListView.__proto__ || Object.getPrototypeOf(ListView)).call(this, props));

        _this.state = {
            unmounting: false,
            collections: false,
            isMobile: _this.props.isMobile
        };

        _this.updateCollections = _this.updateCollections.bind(_this);

        i18n.add(translations_en_default.a);
        return _this;
    }

    list_view_card__createClass(ListView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.user) {
                this.getCollections().then(function (json) {
                    _this2.setState({ collections: json });
                });
            }

            this.removeMediaListener = addMediaListener('(min-width: 600px)', function (mq) {
                return _this2.setState({ isMobile: !mq.matches });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeMediaListener && this.removeMediaListener();
        }
    }, {
        key: 'updateCollections',
        value: function updateCollections(collections, callback) {
            this.setState({ collections: collections }, typeof callback === 'function' && callback);
        }
    }, {
        key: 'getCollections',
        value: function getCollections() {
            var _this3 = this;

            var _props = this.props,
                gigs = _props.gigs,
                user = _props.user,
                hearts = gigs.map(function (gig) {
                return gig.gig_id;
            });


            if (!user) {
                return;
            }

            return collection.getCollections(hearts).then(function (json) {
                _this3.setState({ collections: json });return json;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                gigs = _props2.gigs,
                user = _props2.user,
                responsiveGrid = _props2.responsiveGrid,
                _props2$context = _props2.context,
                context = _props2$context === undefined ? {} : _props2$context,
                _state = this.state,
                collections = _state.collections,
                isMobile = _state.isMobile,
                cardTypeVal = 'list';


            return react_default.a.createElement(
                gig_card_context_GigCardContextProvider,
                { value: list_view_card__extends({ cardType: cardTypeVal, collections: collections, user: user }, context) },
                react_default.a.createElement(
                    'div',
                    { className: 'react-gig-cards-slider list-view-slider slider-hider cf' },
                    gigs.map(function (gig, i) {
                        return react_default.a.createElement(list_view_card_ListView, { key: 'list-view-' + i,
                            isMobile: isMobile,
                            gig: gig,
                            user: user,
                            responsiveGrid: responsiveGrid,
                            context: context,
                            updateCollections: _this4.updateCollections });
                    })
                )
            );
        }
    }]);

    return ListView;
}(react["PureComponent"]);

src_list_view_card_ListView.propTypes = {
    user: prop_types_default.a.object,
    gigs: prop_types_default.a.array,
    responsiveGrid: prop_types_default.a.bool,
    isMobile: prop_types_default.a.bool,
    context: prop_types_default.a.shape({
        pageCtxId: prop_types_default.a.string,
        refCtxId: prop_types_default.a.string
    })
};

src_list_view_card_ListView.defaultProps = {
    responsiveGrid: false
};

/* harmony default export */ var list_view_card = (src_list_view_card_ListView);
// CONCATENATED MODULE: ./src/port.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GigCards", function() { return mp_gig_card; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GigCard", function() { return mp_gig_card_GigCard; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListView", function() { return list_view_card; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListViewItem", function() { return list_view_card_ListView; });





if (typeof document !== 'undefined') {
    window.ListViewCard = list_view_card;
    window.BuyerGigCard = mp_gig_card;
}



/***/ }),

/***/ "fQuc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__("JtmH");
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),

/***/ "fRv3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gt/O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "ijbM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kvXm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),

/***/ "lCso":
/***/ (function(module, exports, __webpack_require__) {

var extend = __webpack_require__("ouFg");
var ArrayWeakMap = __webpack_require__("bQni");

var defaultRootComponent;
var defaultRootKey = {};
var componentPromises = new ArrayWeakMap();

var updateRootComponent = function(rootComponent) {
  var componentKey = rootComponent || defaultRootKey;

  if (!componentPromises.has(componentKey)) {
    var componentToUpdate = rootComponent || defaultRootComponent;

    if (componentToUpdate) {
      this.setTimeout(function() {
        if (componentToUpdate.isMounted()) {
          componentToUpdate.forceUpdate();
        }
      }, 0);
    }
  }
};

module.exports = {

  extend: function() {

    var Store = function() {
      this.updateRootComponent = function(promise) {
        if (promise) {
          var componentKey = this.rootComponent || defaultRootKey;
          componentPromises.addArrayItem(componentKey, promise);
          var _this = this;

          var onResolveOrReject = function() {
            componentPromises.removeArrayItem(componentKey, promise);
            updateRootComponent(_this.rootComponent);
          };

          promise.then(onResolveOrReject, onResolveOrReject);
        }
        else {
          updateRootComponent(this.rootComponent);
        }
      };
    };

    // prepend Store to arguments
    Array.prototype.unshift.call(arguments, Store.prototype);
    extend.apply(null, arguments);

    var store = new Store();

    return store;
  },

  init: function(options) {
    defaultRootComponent = options.rootComponent;
  }

};

/***/ }),

/***/ "lP53":
/***/ (function(module, exports) {

// Copyright (C) 2011 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview Install a leaky WeakMap emulation on platforms that
 * don't provide a built-in one.
 *
 * <p>Assumes that an ES5 platform where, if {@code WeakMap} is
 * already present, then it conforms to the anticipated ES6
 * specification. To run this file on an ES5 or almost ES5
 * implementation where the {@code WeakMap} specification does not
 * quite conform, run <code>repairES5.js</code> first.
 *
 * <p>Even though WeakMapModule is not global, the linter thinks it
 * is, which is why it is in the overrides list below.
 *
 * <p>NOTE: Before using this WeakMap emulation in a non-SES
 * environment, see the note below about hiddenRecord.
 *
 * @author Mark S. Miller
 * @requires crypto, ArrayBuffer, Uint8Array, navigator, console
 * @overrides WeakMap, ses, Proxy
 * @overrides WeakMapModule
 */

/**
 * This {@code WeakMap} emulation is observably equivalent to the
 * ES-Harmony WeakMap, but with leakier garbage collection properties.
 *
 * <p>As with true WeakMaps, in this emulation, a key does not
 * retain maps indexed by that key and (crucially) a map does not
 * retain the keys it indexes. A map by itself also does not retain
 * the values associated with that map.
 *
 * <p>However, the values associated with a key in some map are
 * retained so long as that key is retained and those associations are
 * not overridden. For example, when used to support membranes, all
 * values exported from a given membrane will live for the lifetime
 * they would have had in the absence of an interposed membrane. Even
 * when the membrane is revoked, all objects that would have been
 * reachable in the absence of revocation will still be reachable, as
 * far as the GC can tell, even though they will no longer be relevant
 * to ongoing computation.
 *
 * <p>The API implemented here is approximately the API as implemented
 * in FF6.0a1 and agreed to by MarkM, Andreas Gal, and Dave Herman,
 * rather than the offially approved proposal page. TODO(erights):
 * upgrade the ecmascript WeakMap proposal page to explain this API
 * change and present to EcmaScript committee for their approval.
 *
 * <p>The first difference between the emulation here and that in
 * FF6.0a1 is the presence of non enumerable {@code get___, has___,
 * set___, and delete___} methods on WeakMap instances to represent
 * what would be the hidden internal properties of a primitive
 * implementation. Whereas the FF6.0a1 WeakMap.prototype methods
 * require their {@code this} to be a genuine WeakMap instance (i.e.,
 * an object of {@code [[Class]]} "WeakMap}), since there is nothing
 * unforgeable about the pseudo-internal method names used here,
 * nothing prevents these emulated prototype methods from being
 * applied to non-WeakMaps with pseudo-internal methods of the same
 * names.
 *
 * <p>Another difference is that our emulated {@code
 * WeakMap.prototype} is not itself a WeakMap. A problem with the
 * current FF6.0a1 API is that WeakMap.prototype is itself a WeakMap
 * providing ambient mutability and an ambient communications
 * channel. Thus, if a WeakMap is already present and has this
 * problem, repairES5.js wraps it in a safe wrappper in order to
 * prevent access to this channel. (See
 * PATCH_MUTABLE_FROZEN_WEAKMAP_PROTO in repairES5.js).
 */

/**
 * If this is a full <a href=
 * "http://code.google.com/p/es-lab/wiki/SecureableES5"
 * >secureable ES5</a> platform and the ES-Harmony {@code WeakMap} is
 * absent, install an approximate emulation.
 *
 * <p>If WeakMap is present but cannot store some objects, use our approximate
 * emulation as a wrapper.
 *
 * <p>If this is almost a secureable ES5 platform, then WeakMap.js
 * should be run after repairES5.js.
 *
 * <p>See {@code WeakMap} for documentation of the garbage collection
 * properties of this WeakMap emulation.
 */
(function WeakMapModule() {
  "use strict";

  if (typeof ses !== 'undefined' && ses.ok && !ses.ok()) {
    // already too broken, so give up
    return;
  }

  /**
   * In some cases (current Firefox), we must make a choice betweeen a
   * WeakMap which is capable of using all varieties of host objects as
   * keys and one which is capable of safely using proxies as keys. See
   * comments below about HostWeakMap and DoubleWeakMap for details.
   *
   * This function (which is a global, not exposed to guests) marks a
   * WeakMap as permitted to do what is necessary to index all host
   * objects, at the cost of making it unsafe for proxies.
   *
   * Do not apply this function to anything which is not a genuine
   * fresh WeakMap.
   */
  function weakMapPermitHostObjects(map) {
    // identity of function used as a secret -- good enough and cheap
    if (map.permitHostObjects___) {
      map.permitHostObjects___(weakMapPermitHostObjects);
    }
  }
  if (typeof ses !== 'undefined') {
    ses.weakMapPermitHostObjects = weakMapPermitHostObjects;
  }

  // IE 11 has no Proxy but has a broken WeakMap such that we need to patch
  // it using DoubleWeakMap; this flag tells DoubleWeakMap so.
  var doubleWeakMapCheckSilentFailure = false;

  // Check if there is already a good-enough WeakMap implementation, and if so
  // exit without replacing it.
  if (typeof WeakMap === 'function') {
    var HostWeakMap = WeakMap;
    // There is a WeakMap -- is it good enough?
    if (typeof navigator !== 'undefined' &&
        /Firefox/.test(navigator.userAgent)) {
      // We're now *assuming not*, because as of this writing (2013-05-06)
      // Firefox's WeakMaps have a miscellany of objects they won't accept, and
      // we don't want to make an exhaustive list, and testing for just one
      // will be a problem if that one is fixed alone (as they did for Event).

      // If there is a platform that we *can* reliably test on, here's how to
      // do it:
      //  var problematic = ... ;
      //  var testHostMap = new HostWeakMap();
      //  try {
      //    testHostMap.set(problematic, 1);  // Firefox 20 will throw here
      //    if (testHostMap.get(problematic) === 1) {
      //      return;
      //    }
      //  } catch (e) {}

    } else {
      // IE 11 bug: WeakMaps silently fail to store frozen objects.
      var testMap = new HostWeakMap();
      var testObject = Object.freeze({});
      testMap.set(testObject, 1);
      if (testMap.get(testObject) !== 1) {
        doubleWeakMapCheckSilentFailure = true;
        // Fall through to installing our WeakMap.
      } else {
        module.exports = WeakMap;
        return;
      }
    }
  }

  var hop = Object.prototype.hasOwnProperty;
  var gopn = Object.getOwnPropertyNames;
  var defProp = Object.defineProperty;
  var isExtensible = Object.isExtensible;

  /**
   * Security depends on HIDDEN_NAME being both <i>unguessable</i> and
   * <i>undiscoverable</i> by untrusted code.
   *
   * <p>Given the known weaknesses of Math.random() on existing
   * browsers, it does not generate unguessability we can be confident
   * of.
   *
   * <p>It is the monkey patching logic in this file that is intended
   * to ensure undiscoverability. The basic idea is that there are
   * three fundamental means of discovering properties of an object:
   * The for/in loop, Object.keys(), and Object.getOwnPropertyNames(),
   * as well as some proposed ES6 extensions that appear on our
   * whitelist. The first two only discover enumerable properties, and
   * we only use HIDDEN_NAME to name a non-enumerable property, so the
   * only remaining threat should be getOwnPropertyNames and some
   * proposed ES6 extensions that appear on our whitelist. We monkey
   * patch them to remove HIDDEN_NAME from the list of properties they
   * returns.
   *
   * <p>TODO(erights): On a platform with built-in Proxies, proxies
   * could be used to trap and thereby discover the HIDDEN_NAME, so we
   * need to monkey patch Proxy.create, Proxy.createFunction, etc, in
   * order to wrap the provided handler with the real handler which
   * filters out all traps using HIDDEN_NAME.
   *
   * <p>TODO(erights): Revisit Mike Stay's suggestion that we use an
   * encapsulated function at a not-necessarily-secret name, which
   * uses the Stiegler shared-state rights amplification pattern to
   * reveal the associated value only to the WeakMap in which this key
   * is associated with that value. Since only the key retains the
   * function, the function can also remember the key without causing
   * leakage of the key, so this doesn't violate our general gc
   * goals. In addition, because the name need not be a guarded
   * secret, we could efficiently handle cross-frame frozen keys.
   */
  var HIDDEN_NAME_PREFIX = 'weakmap:';
  var HIDDEN_NAME = HIDDEN_NAME_PREFIX + 'ident:' + Math.random() + '___';

  if (typeof crypto !== 'undefined' &&
      typeof crypto.getRandomValues === 'function' &&
      typeof ArrayBuffer === 'function' &&
      typeof Uint8Array === 'function') {
    var ab = new ArrayBuffer(25);
    var u8s = new Uint8Array(ab);
    crypto.getRandomValues(u8s);
    HIDDEN_NAME = HIDDEN_NAME_PREFIX + 'rand:' +
      Array.prototype.map.call(u8s, function(u8) {
        return (u8 % 36).toString(36);
      }).join('') + '___';
  }

  function isNotHiddenName(name) {
    return !(
        name.substr(0, HIDDEN_NAME_PREFIX.length) == HIDDEN_NAME_PREFIX &&
        name.substr(name.length - 3) === '___');
  }

  /**
   * Monkey patch getOwnPropertyNames to avoid revealing the
   * HIDDEN_NAME.
   *
   * <p>The ES5.1 spec requires each name to appear only once, but as
   * of this writing, this requirement is controversial for ES6, so we
   * made this code robust against this case. If the resulting extra
   * search turns out to be expensive, we can probably relax this once
   * ES6 is adequately supported on all major browsers, iff no browser
   * versions we support at that time have relaxed this constraint
   * without providing built-in ES6 WeakMaps.
   */
  defProp(Object, 'getOwnPropertyNames', {
    value: function fakeGetOwnPropertyNames(obj) {
      return gopn(obj).filter(isNotHiddenName);
    }
  });

  /**
   * getPropertyNames is not in ES5 but it is proposed for ES6 and
   * does appear in our whitelist, so we need to clean it too.
   */
  if ('getPropertyNames' in Object) {
    var originalGetPropertyNames = Object.getPropertyNames;
    defProp(Object, 'getPropertyNames', {
      value: function fakeGetPropertyNames(obj) {
        return originalGetPropertyNames(obj).filter(isNotHiddenName);
      }
    });
  }

  /**
   * <p>To treat objects as identity-keys with reasonable efficiency
   * on ES5 by itself (i.e., without any object-keyed collections), we
   * need to add a hidden property to such key objects when we
   * can. This raises several issues:
   * <ul>
   * <li>Arranging to add this property to objects before we lose the
   *     chance, and
   * <li>Hiding the existence of this new property from most
   *     JavaScript code.
   * <li>Preventing <i>certification theft</i>, where one object is
   *     created falsely claiming to be the key of an association
   *     actually keyed by another object.
   * <li>Preventing <i>value theft</i>, where untrusted code with
   *     access to a key object but not a weak map nevertheless
   *     obtains access to the value associated with that key in that
   *     weak map.
   * </ul>
   * We do so by
   * <ul>
   * <li>Making the name of the hidden property unguessable, so "[]"
   *     indexing, which we cannot intercept, cannot be used to access
   *     a property without knowing the name.
   * <li>Making the hidden property non-enumerable, so we need not
   *     worry about for-in loops or {@code Object.keys},
   * <li>monkey patching those reflective methods that would
   *     prevent extensions, to add this hidden property first,
   * <li>monkey patching those methods that would reveal this
   *     hidden property.
   * </ul>
   * Unfortunately, because of same-origin iframes, we cannot reliably
   * add this hidden property before an object becomes
   * non-extensible. Instead, if we encounter a non-extensible object
   * without a hidden record that we can detect (whether or not it has
   * a hidden record stored under a name secret to us), then we just
   * use the key object itself to represent its identity in a brute
   * force leaky map stored in the weak map, losing all the advantages
   * of weakness for these.
   */
  function getHiddenRecord(key) {
    if (key !== Object(key)) {
      throw new TypeError('Not an object: ' + key);
    }
    var hiddenRecord = key[HIDDEN_NAME];
    if (hiddenRecord && hiddenRecord.key === key) { return hiddenRecord; }
    if (!isExtensible(key)) {
      // Weak map must brute force, as explained in doc-comment above.
      return void 0;
    }

    // The hiddenRecord and the key point directly at each other, via
    // the "key" and HIDDEN_NAME properties respectively. The key
    // field is for quickly verifying that this hidden record is an
    // own property, not a hidden record from up the prototype chain.
    //
    // NOTE: Because this WeakMap emulation is meant only for systems like
    // SES where Object.prototype is frozen without any numeric
    // properties, it is ok to use an object literal for the hiddenRecord.
    // This has two advantages:
    // * It is much faster in a performance critical place
    // * It avoids relying on Object.create(null), which had been
    //   problematic on Chrome 28.0.1480.0. See
    //   https://code.google.com/p/google-caja/issues/detail?id=1687
    hiddenRecord = { key: key };

    // When using this WeakMap emulation on platforms where
    // Object.prototype might not be frozen and Object.create(null) is
    // reliable, use the following two commented out lines instead.
    // hiddenRecord = Object.create(null);
    // hiddenRecord.key = key;

    // Please contact us if you need this to work on platforms where
    // Object.prototype might not be frozen and
    // Object.create(null) might not be reliable.

    try {
      defProp(key, HIDDEN_NAME, {
        value: hiddenRecord,
        writable: false,
        enumerable: false,
        configurable: false
      });
      return hiddenRecord;
    } catch (error) {
      // Under some circumstances, isExtensible seems to misreport whether
      // the HIDDEN_NAME can be defined.
      // The circumstances have not been isolated, but at least affect
      // Node.js v0.10.26 on TravisCI / Linux, but not the same version of
      // Node.js on OS X.
      return void 0;
    }
  }

  /**
   * Monkey patch operations that would make their argument
   * non-extensible.
   *
   * <p>The monkey patched versions throw a TypeError if their
   * argument is not an object, so it should only be done to functions
   * that should throw a TypeError anyway if their argument is not an
   * object.
   */
  (function(){
    var oldFreeze = Object.freeze;
    defProp(Object, 'freeze', {
      value: function identifyingFreeze(obj) {
        getHiddenRecord(obj);
        return oldFreeze(obj);
      }
    });
    var oldSeal = Object.seal;
    defProp(Object, 'seal', {
      value: function identifyingSeal(obj) {
        getHiddenRecord(obj);
        return oldSeal(obj);
      }
    });
    var oldPreventExtensions = Object.preventExtensions;
    defProp(Object, 'preventExtensions', {
      value: function identifyingPreventExtensions(obj) {
        getHiddenRecord(obj);
        return oldPreventExtensions(obj);
      }
    });
  })();

  function constFunc(func) {
    func.prototype = null;
    return Object.freeze(func);
  }

  var calledAsFunctionWarningDone = false;
  function calledAsFunctionWarning() {
    // Future ES6 WeakMap is currently (2013-09-10) expected to reject WeakMap()
    // but we used to permit it and do it ourselves, so warn only.
    if (!calledAsFunctionWarningDone && typeof console !== 'undefined') {
      calledAsFunctionWarningDone = true;
      console.warn('WeakMap should be invoked as new WeakMap(), not ' +
          'WeakMap(). This will be an error in the future.');
    }
  }

  var nextId = 0;

  var OurWeakMap = function() {
    if (!(this instanceof OurWeakMap)) {  // approximate test for new ...()
      calledAsFunctionWarning();
    }

    // We are currently (12/25/2012) never encountering any prematurely
    // non-extensible keys.
    var keys = []; // brute force for prematurely non-extensible keys.
    var values = []; // brute force for corresponding values.
    var id = nextId++;

    function get___(key, opt_default) {
      var index;
      var hiddenRecord = getHiddenRecord(key);
      if (hiddenRecord) {
        return id in hiddenRecord ? hiddenRecord[id] : opt_default;
      } else {
        index = keys.indexOf(key);
        return index >= 0 ? values[index] : opt_default;
      }
    }

    function has___(key) {
      var hiddenRecord = getHiddenRecord(key);
      if (hiddenRecord) {
        return id in hiddenRecord;
      } else {
        return keys.indexOf(key) >= 0;
      }
    }

    function set___(key, value) {
      var index;
      var hiddenRecord = getHiddenRecord(key);
      if (hiddenRecord) {
        hiddenRecord[id] = value;
      } else {
        index = keys.indexOf(key);
        if (index >= 0) {
          values[index] = value;
        } else {
          // Since some browsers preemptively terminate slow turns but
          // then continue computing with presumably corrupted heap
          // state, we here defensively get keys.length first and then
          // use it to update both the values and keys arrays, keeping
          // them in sync.
          index = keys.length;
          values[index] = value;
          // If we crash here, values will be one longer than keys.
          keys[index] = key;
        }
      }
      return this;
    }

    function delete___(key) {
      var hiddenRecord = getHiddenRecord(key);
      var index, lastIndex;
      if (hiddenRecord) {
        return id in hiddenRecord && delete hiddenRecord[id];
      } else {
        index = keys.indexOf(key);
        if (index < 0) {
          return false;
        }
        // Since some browsers preemptively terminate slow turns but
        // then continue computing with potentially corrupted heap
        // state, we here defensively get keys.length first and then use
        // it to update both the keys and the values array, keeping
        // them in sync. We update the two with an order of assignments,
        // such that any prefix of these assignments will preserve the
        // key/value correspondence, either before or after the delete.
        // Note that this needs to work correctly when index === lastIndex.
        lastIndex = keys.length - 1;
        keys[index] = void 0;
        // If we crash here, there's a void 0 in the keys array, but
        // no operation will cause a "keys.indexOf(void 0)", since
        // getHiddenRecord(void 0) will always throw an error first.
        values[index] = values[lastIndex];
        // If we crash here, values[index] cannot be found here,
        // because keys[index] is void 0.
        keys[index] = keys[lastIndex];
        // If index === lastIndex and we crash here, then keys[index]
        // is still void 0, since the aliasing killed the previous key.
        keys.length = lastIndex;
        // If we crash here, keys will be one shorter than values.
        values.length = lastIndex;
        return true;
      }
    }

    return Object.create(OurWeakMap.prototype, {
      get___:    { value: constFunc(get___) },
      has___:    { value: constFunc(has___) },
      set___:    { value: constFunc(set___) },
      delete___: { value: constFunc(delete___) }
    });
  };

  OurWeakMap.prototype = Object.create(Object.prototype, {
    get: {
      /**
       * Return the value most recently associated with key, or
       * opt_default if none.
       */
      value: function get(key, opt_default) {
        return this.get___(key, opt_default);
      },
      writable: true,
      configurable: true
    },

    has: {
      /**
       * Is there a value associated with key in this WeakMap?
       */
      value: function has(key) {
        return this.has___(key);
      },
      writable: true,
      configurable: true
    },

    set: {
      /**
       * Associate value with key in this WeakMap, overwriting any
       * previous association if present.
       */
      value: function set(key, value) {
        return this.set___(key, value);
      },
      writable: true,
      configurable: true
    },

    'delete': {
      /**
       * Remove any association for key in this WeakMap, returning
       * whether there was one.
       *
       * <p>Note that the boolean return here does not work like the
       * {@code delete} operator. The {@code delete} operator returns
       * whether the deletion succeeds at bringing about a state in
       * which the deleted property is absent. The {@code delete}
       * operator therefore returns true if the property was already
       * absent, whereas this {@code delete} method returns false if
       * the association was already absent.
       */
      value: function remove(key) {
        return this.delete___(key);
      },
      writable: true,
      configurable: true
    }
  });

  if (typeof HostWeakMap === 'function') {
    (function() {
      // If we got here, then the platform has a WeakMap but we are concerned
      // that it may refuse to store some key types. Therefore, make a map
      // implementation which makes use of both as possible.

      // In this mode we are always using double maps, so we are not proxy-safe.
      // This combination does not occur in any known browser, but we had best
      // be safe.
      if (doubleWeakMapCheckSilentFailure && typeof Proxy !== 'undefined') {
        Proxy = undefined;
      }

      function DoubleWeakMap() {
        if (!(this instanceof OurWeakMap)) {  // approximate test for new ...()
          calledAsFunctionWarning();
        }

        // Preferable, truly weak map.
        var hmap = new HostWeakMap();

        // Our hidden-property-based pseudo-weak-map. Lazily initialized in the
        // 'set' implementation; thus we can avoid performing extra lookups if
        // we know all entries actually stored are entered in 'hmap'.
        var omap = undefined;

        // Hidden-property maps are not compatible with proxies because proxies
        // can observe the hidden name and either accidentally expose it or fail
        // to allow the hidden property to be set. Therefore, we do not allow
        // arbitrary WeakMaps to switch to using hidden properties, but only
        // those which need the ability, and unprivileged code is not allowed
        // to set the flag.
        //
        // (Except in doubleWeakMapCheckSilentFailure mode in which case we
        // disable proxies.)
        var enableSwitching = false;

        function dget(key, opt_default) {
          if (omap) {
            return hmap.has(key) ? hmap.get(key)
                : omap.get___(key, opt_default);
          } else {
            return hmap.get(key, opt_default);
          }
        }

        function dhas(key) {
          return hmap.has(key) || (omap ? omap.has___(key) : false);
        }

        var dset;
        if (doubleWeakMapCheckSilentFailure) {
          dset = function(key, value) {
            hmap.set(key, value);
            if (!hmap.has(key)) {
              if (!omap) { omap = new OurWeakMap(); }
              omap.set(key, value);
            }
            return this;
          };
        } else {
          dset = function(key, value) {
            if (enableSwitching) {
              try {
                hmap.set(key, value);
              } catch (e) {
                if (!omap) { omap = new OurWeakMap(); }
                omap.set___(key, value);
              }
            } else {
              hmap.set(key, value);
            }
            return this;
          };
        }

        function ddelete(key) {
          var result = !!hmap['delete'](key);
          if (omap) { return omap.delete___(key) || result; }
          return result;
        }

        return Object.create(OurWeakMap.prototype, {
          get___:    { value: constFunc(dget) },
          has___:    { value: constFunc(dhas) },
          set___:    { value: constFunc(dset) },
          delete___: { value: constFunc(ddelete) },
          permitHostObjects___: { value: constFunc(function(token) {
            if (token === weakMapPermitHostObjects) {
              enableSwitching = true;
            } else {
              throw new Error('bogus call to permitHostObjects___');
            }
          })}
        });
      }
      DoubleWeakMap.prototype = OurWeakMap.prototype;
      module.exports = DoubleWeakMap;

      // define .constructor to hide OurWeakMap ctor
      Object.defineProperty(WeakMap.prototype, 'constructor', {
        value: WeakMap,
        enumerable: false,  // as default .constructor is
        configurable: true,
        writable: true
      });
    })();
  } else {
    // There is no host WeakMap, so we must use the emulation.

    // Emulated WeakMaps are incompatible with native proxies (because proxies
    // can observe the hidden name), so we must disable Proxy usage (in
    // ArrayLike and Domado, currently).
    if (typeof Proxy !== 'undefined') {
      Proxy = undefined;
    }

    module.exports = OurWeakMap;
  }
})();


/***/ }),

/***/ "mB6w":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "mFR0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "odPn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ouFg":
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),

/***/ "pV5o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),

/***/ "rD3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "svXm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tBbN":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.fit=t():e.fit=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){e.exports=n(57)},function(e,t,n){"use strict";e.exports=n(92)},function(e,t,n){"use strict";function r(e,t,n,r,a,u,i,l){if(o(t),!e){var s;if(void 0===t)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,a,u,i,l],f=0;s=new Error(t.replace(/%s/g,function(){return c[f++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var o=function(e){};e.exports=r},function(e,t,n){"use strict";function r(e){return void 0!==e.ref}function o(e){return void 0!==e.key}var a=n(4),u=n(22),i=(n(6),n(25),Object.prototype.hasOwnProperty),l=n(23),s={key:!0,ref:!0,__self:!0,__source:!0},c=function(e,t,n,r,o,a,u){var i={$$typeof:l,type:e,key:t,ref:n,props:u,_owner:a};return i};c.createElement=function(e,t,n){var a,l={},f=null,p=null,d=null,v=null;if(null!=t){r(t)&&(p=t.ref),o(t)&&(f=""+t.key),d=void 0===t.__self?null:t.__self,v=void 0===t.__source?null:t.__source;for(a in t)i.call(t,a)&&!s.hasOwnProperty(a)&&(l[a]=t[a])}var h=arguments.length-2;if(1===h)l.children=n;else if(h>1){for(var y=Array(h),m=0;m<h;m++)y[m]=arguments[m+2];l.children=y}if(e&&e.defaultProps){var b=e.defaultProps;for(a in b)void 0===l[a]&&(l[a]=b[a])}return c(e,f,p,d,v,u.current,l)},c.createFactory=function(e){var t=c.createElement.bind(null,e);return t.type=e,t},c.cloneAndReplaceKey=function(e,t){var n=c(e.type,t,e.ref,e._self,e._source,e._owner,e.props);return n},c.cloneElement=function(e,t,n){var l,f=a({},e.props),p=e.key,d=e.ref,v=e._self,h=e._source,y=e._owner;if(null!=t){r(t)&&(d=t.ref,y=u.current),o(t)&&(p=""+t.key);var m;e.type&&e.type.defaultProps&&(m=e.type.defaultProps);for(l in t)i.call(t,l)&&!s.hasOwnProperty(l)&&(void 0===t[l]&&void 0!==m?f[l]=m[l]:f[l]=t[l])}var b=arguments.length-2;if(1===b)f.children=n;else if(b>1){for(var g=Array(b),_=0;_<b;_++)g[_]=arguments[_+2];f.children=g}return c(e.type,p,d,v,h,y,f)},c.isValidElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===l},e.exports=c},function(e,t){/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
"use strict";function n(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function r(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;var r=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if("0123456789"!==r.join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(e){o[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}var o=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable;e.exports=r()?Object.assign:function(e,t){for(var r,i,l=n(e),s=1;s<arguments.length;s++){r=Object(arguments[s]);for(var c in r)a.call(r,c)&&(l[c]=r[c]);if(o){i=o(r);for(var f=0;f<i.length;f++)u.call(r,i[f])&&(l[i[f]]=r[i[f]])}}return l}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";var r=n(5),o=r;e.exports=o},function(e,t){"use strict";function n(e){for(var t=arguments.length-1,n="Minified React error #"+e+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+e,r=0;r<t;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);n+=" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";var o=new Error(n);throw o.name="Invariant Violation",o.framesToPop=1,o}e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=Object.keys(e);return t.length?t.sort(function(t,n){return e[n].sortId-e[t].sortId}):t}function a(e){var t="translateY("+p*e+"px)";return{transform:t}}function u(e){var t=Object.keys(e).length;return{height:p*t+"px"}}function i(e){var t=e.attachments,n=e.onAbort,r=e.autoGrow,i=o(t),l=u(t),c="fit-attachment-list"+(r?" fixed":"");return i.length?s.default.createElement("ul",{className:c,style:l},i.map(function(e,r){var o=a(r);return s.default.createElement(f.default,{key:e,style:o,file:t[e],onAbort:n})})):null}Object.defineProperty(t,"__esModule",{value:!0});var l=n(1),s=r(l);n(66);var c=n(26),f=r(c),p=50;t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.name,n=e.onAttach,r=e.text,o=e.isSingle,a="fit-btn-attachment",i=!o;return r&&(a+=" btn-standard btn-white-grad"),u.default.createElement("label",{className:a},r,u.default.createElement("input",{type:"file",name:t,onChange:function(e){return n(e.target.files)},multiple:i}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(69),o.propTypes={name:u.default.PropTypes.string.isRequired,onAttach:u.default.PropTypes.func.isRequired,text:u.default.PropTypes.string,isSingle:u.default.PropTypes.bool},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.error,n=e.icon;if(!t||0===Object.keys(t).length||!t.title&&!t.message)return null;var r=n?" icon ":"";return u.default.createElement("div",{className:"fit-simple-error "+r},t.title&&u.default.createElement("strong",null,t.title),t.message&&u.default.createElement("small",null,t.message))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(75),t.default=o},function(e,t){"use strict";function n(e){switch(e){case"small":return"btn-standard";case"medium":return"btn-lrg-standard lesspad";case"large":return"btn-lrg-standard";case"full-width":return"btn-lrg-standard full-width";default:return"btn-standard"}}Object.defineProperty(t,"__esModule",{value:!0}),t.getSizeClass=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){if(!e.text)return e.children;var t={"data-hint":e.text||"",className:"hint--"+(e.position||"top")};return u.default.createElement("span",t,e.children)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),f=r(c),p=n(10),d=r(p),v=function(e){function t(e){a(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={validationError:!1},n.handleChange=n.handleChange.bind(n),n}return i(t,e),s(t,[{key:"handleChange",value:function(e){var t=this,n=e.target.value;this.setState(function(){var e=t.props.validate&&t.props.validate(n);return{validationError:e}})}},{key:"render",value:function(){var e=this.state.validationError,t=this.props,n=t.id,r=t.label,a=t.prefix,u=t.suffix,i=o(t,["id","label","prefix","suffix"]);return f.default.createElement("div",{className:"fit-input"},f.default.createElement("label",{htmlFor:n},r,f.default.createElement("div",{className:"input-wrapper","data-prefix":a,"data-suffix":u},f.default.createElement("input",l({onChange:this.handleChange,className:e?"with-error":""},i)))),!!e&&f.default.createElement(d.default,{error:e}))}}]),t}(c.Component);t.default=v},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.updateCurrentPage,n=e.currentPage,r=e.totalPages,o=[],a=1;for(a;a<=r;a++)a===n?o.push(i.default.createElement("a",{href:"#",className:"current-page",key:a},a)):o.push(i.default.createElement("a",{href:"#",onClick:function(){return t(a)},key:a},a));return i.default.createElement("ul",null,o)}function a(e){var t=e.updateCurrentPage,n=e.currentPage,r=e.totalPages;return r<=1?null:i.default.createElement("nav",{className:"pagination fit-pagination"},i.default.createElement("div",{className:"pagination-range"},i.default.createElement(o,{updateCurrentPage:t,currentPage:n,totalPages:r})))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);n(74),t.default=a},function(e,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return{title:e,message:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function a(e){var t=e.icon,n=e.width,r=void 0===n?20:n,o=e.height,a=void 0===o?20:o,u=e.color,l=void 0===u?"black":u;if(!t)return null;var c="fit-svg-icon "+t+" "+l;return i.default.createElement("svg",{className:c,viewBox:"0 0 1792 1792",xmlns:"http://www.w3.org/2000/svg",width:r,height:a},i.default.createElement("path",{d:s[t]}))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=o(u);n(77);var l=n(43),s=r(l);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function i(e){var t=e.extensions;return t?f.default.createElement("div",{className:"textarea-extensions"},t):null}function l(e){var t=e.label;return t?f.default.createElement("div",null,t):null}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),f=r(c),p=n(30),d=r(p),v=n(10),h=r(v);n(80);var y=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return function(){return e++}},m=y(),b=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={validationError:!1,value:n.props.value||""},n.id="fit-textarea-"+m(),n.handleChange=n.handleChange.bind(n),n}return u(t,e),s(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.state.value,n=e.value||t,r=n===t?t:n;this.setState({value:r})}},{key:"handleChange",value:function(){var e=this,t=this.textarea.value;this.setState(function(n){var r=e.reachedMaxLength(t)?n.value:t;return e.props.onChange&&e.props.onChange(r),{value:r,validationError:e.props.validate&&e.props.validate(t)}})}},{key:"reachedMaxLength",value:function(e){var t=this.props.maxLength;return!!t&&e.length>t}},{key:"render",value:function(){var e=this,t=this.state,n=t.validationError,r=t.value,o=this.props,a=o.maxLength,u=o.name,s=o.children,c=o.placeholder,p=o.isInvalid,v=o.label,y=o.hideCharCount,m=o.onBlur,b=r.length,g=n||p?"invalid":"",_="fit-textarea"+(v?" has-label":"");return f.default.createElement("div",{className:_},f.default.createElement("textarea",{name:u,className:g,id:this.id,value:r,placeholder:c,onChange:this.handleChange,onBlur:m?m:function(){return!0},ref:function(t){return e.textarea=t}}),f.default.createElement("label",{htmlFor:this.id},f.default.createElement(l,{label:v})),f.default.createElement("footer",null,!y&&f.default.createElement(d.default,{currentCount:b,maxCount:a}),f.default.createElement(i,{extensions:s})),!!n&&f.default.createElement(h.default,{error:n}))}}]),t}(c.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(60),a=r(o);t.default=a.default},function(e,t,n){"use strict";var r={};e.exports=r},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){"use strict";function r(e,t,n){this.props=e,this.context=t,this.refs=s,this.updater=n||l}function o(e,t,n){this.props=e,this.context=t,this.refs=s,this.updater=n||l}function a(){}var u=n(7),i=n(4),l=n(24),s=(n(25),n(19));n(2),n(99);r.prototype.isReactComponent={},r.prototype.setState=function(e,t){"object"!=typeof e&&"function"!=typeof e&&null!=e?u("85"):void 0,this.updater.enqueueSetState(this,e),t&&this.updater.enqueueCallback(this,t,"setState")},r.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this),e&&this.updater.enqueueCallback(this,e,"forceUpdate")};a.prototype=r.prototype,o.prototype=new a,o.prototype.constructor=o,i(o.prototype,r.prototype),o.prototype.isPureReactComponent=!0,e.exports={Component:r,PureComponent:o}},function(e,t){"use strict";var n={current:null};e.exports=n},function(e,t){"use strict";var n="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;e.exports=n},function(e,t,n){"use strict";function r(e,t){}var o=(n(6),{isMounted:function(e){return!1},enqueueCallback:function(e,t){},enqueueForceUpdate:function(e){r(e,"forceUpdate")},enqueueReplaceState:function(e,t){r(e,"replaceState")},enqueueSetState:function(e,t){r(e,"setState")}});e.exports=o},function(e,t,n){"use strict";var r=!1;e.exports=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.onAbort,n=e.file,r=e.style,o=void 0===r?{}:r,a=n.error,i=n.extension,s=n.progress,c=n.fileName,f=n.fileSize,p=n.loaded,d=p===!0?" done":"",v="",h=f;a&&(v=" file-error",h=a);var y="fit-attachment"+d+v;return u.default.createElement("li",{style:o,className:y},u.default.createElement("div",{className:"file-progress"},u.default.createElement(l.default,{progress:s})),u.default.createElement("div",{className:"file-info"},u.default.createElement("strong",null,u.default.createElement("span",{className:"name"},c),u.default.createElement("span",null,i)),u.default.createElement("small",null,h)),u.default.createElement("a",{href:"#!",className:"abort",onClick:function(){return t(n.id)}}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a),i=n(18),l=r(i);n(65),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.src,n=e.size,r=void 0===n?24:n;return t?(t=t.startsWith("http")?'<img src="'+t+'"/>':t,u.default.createElement("span",{className:"fit-avatar s"+r,dangerouslySetInnerHTML:{__html:t}})):null}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(67),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.index,n=e.title,r=e.url,o=e.crumbClass;return r?u.default.createElement("a",{href:r,"data-index":t,className:o},n):u.default.createElement("span",{"data-index":t,className:o},n)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(68);var i=function(e){var t=e.crumbsList,n=e.currentCrumb,r=void 0===n?"1":n;return t.length?u.default.createElement("ul",{className:"fit-breadcrumbs-list"},t.map(function(e,t){var n=t+1,a=n===parseInt(r,10),i=a?"current":null,l=a?null:e.url;return u.default.createElement("li",{key:t},u.default.createElement(o,{index:n,title:e.title,url:l,crumbClass:i}))})):null};i.propTypes={crumbsList:u.default.PropTypes.array.isRequired},t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.text,n=e.theme,r=e.size,a=e.type,i=e.disabled,c=e.inProgress,f=e.className,p=o(e,["text","theme","size","type","disabled","inProgress","className"]),d=(0,s.getSizeClass)(r),v=c?"in-progress":"",h=i?"disabled":"",y=[d,n,v,h,f].filter(function(e){return!!e}).join(" ");return l.default.createElement("button",u({className:y,type:a,disabled:i},p),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i),s=n(11);a.defaultProps={size:"small",text:"",theme:"",type:"button",disabled:!1,inProgress:!1,className:""},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.currentCount,n=void 0===t?0:t,r=e.maxCount,o=void 0===r?0:r;return u.default.createElement("span",{className:"fit-char-count"},u.default.createElement("strong",null,n)," / ",u.default.createElement("span",{className:"max"},o))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);o.propTypes={currentCount:u.default.PropTypes.number,maxCount:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.caption,n=o(e,["caption"]);return l.default.createElement("label",{className:"fit-checkbox fake-check-black check-text"},l.default.createElement("input",u({type:"checkbox"},n)),l.default.createElement("span",{className:"chk-img"}),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);a.propTypes={caption:l.default.PropTypes.any},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){function t(e){var t=s,n=t.checked;n&&(e&&e.preventDefault(),t.checked=!1)}var n=e.group,r=e.children,o=l(),a="collapsable-"+n,i=a+"-"+o,s=void 0;return u.default.createElement("section",{className:"fit-collapsable"},u.default.createElement("input",{type:"radio",name:a,id:i,ref:function(e){return s=e}}),u.default.createElement("label",{htmlFor:i,onClick:t},r[0]()),u.default.createElement("article",null,r[1](t)))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(70);var i=function(e){return function(){return e++}},l=i(1);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),f=r(c),p=n(11),d=function(e){function t(e){a(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={disabled:n.props.disabled||!1,inProgress:n.props.inProgress||!1},n}return i(t,e),s(t,[{key:"render",value:function(){var e=this.state,t=e.disabled,n=e.inProgress,r=this.props,a=r.text,u=void 0===a?"":a,i=r.theme,s=void 0===i?"":i,c=r.size,d=r.href,v=void 0===d?"#":d,h=o(r,["text","theme","size","href"]),y=n?" in-progress":"",m=t?" disabled":"",b=(0,p.getSizeClass)(c),g=b+" "+s+" "+m+" "+y;return f.default.createElement("a",l({href:v,className:g},h),u)}}]),t}(c.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),c=r(s),f=n(13),p=r(f),d=n(15),v=r(d);n(71);var h=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.inputValidation=n.inputValidation.bind(n),n}return u(t,e),l(t,[{key:"inputValidation",value:function(e){return""===e||Number(e)>=0?this.props.validate&&this.props.validate(e):this.props.defaultError||(0,v.default)()}},{key:"render",value:function(){var e=this.props.symbol;return c.default.createElement("div",{className:"fit-currency"},c.default.createElement(p.default,i({},this.props,{validate:this.inputValidation,prefix:e})))}}]),t}(s.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),s=r(l),c=n(14),f=r(c);n(72);var p=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={currentPage:e.currentPage||1,perPage:e.perPage||2},n.updateCurrentPage=n.updateCurrentPage.bind(n),n}return u(t,e),i(t,[{key:"updateCurrentPage",value:function(e){this.setState({currentPage:e})}},{key:"filterPerPage",value:function(e){var t=this.state,n=t.perPage,r=t.currentPage,o=n*r,a=(r-1)*n;return e.slice(a,o)}},{key:"render",value:function(){var e=this.state,t=e.currentPage,n=e.perPage,r=this.props,o=r.tableHeader,a=r.data,u=Math.ceil(a.length/n);return s.default.createElement("table",{className:"easy-table"},s.default.createElement("thead",null,s.default.createElement("tr",null,o.map(function(e,t){return s.default.createElement("th",{key:t},e.title)}))),s.default.createElement("tbody",null,this.filterPerPage(a).map(function(e,t){return s.default.createElement("tr",{key:t},o.map(function(t,n){return s.default.createElement("td",{key:n},"actions"===t.assignTo&&t.actions(e.id),"actions"!==t.assignTo&&e[t.assignTo])}))})),u&&s.default.createElement("tfoot",null,s.default.createElement("tr",null,s.default.createElement("td",{colSpan:o.length},s.default.createElement(f.default,{totalPages:u,currentPage:t,updateCurrentPage:this.updateCurrentPage})))))}}]),t}(l.Component);t.default=p},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){function t(e){e.target.parentElement.remove(),o&&o()}var n=e.theme,r=e.title,o=e.callback,a=e.closeButton,i=e.children;return u.default.createElement("div",{className:"fit-pagealert "+n},a&&u.default.createElement("a",{href:"#",className:"btn-close",onClick:t},"×"),u.default.createElement("i",{className:"icon"}),u.default.createElement("div",{className:"content-wrapper"},u.default.createElement("h3",null,r),u.default.createElement("div",{className:"content"},i)))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(73),o.propTypes={theme:u.default.PropTypes.string.isRequired,title:u.default.PropTypes.string.isRequired,callback:u.default.PropTypes.func,closeButton:u.default.PropTypes.bool},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.caption,n=o(e,["caption"]);return l.default.createElement("label",{className:"fit-radio fake-radio-black radio-text"},l.default.createElement("input",u({type:"radio"},n)),l.default.createElement("span",{className:"radio-img"}),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);a.propTypes={caption:l.default.PropTypes.any},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){for(var t=e.value,n=void 0===t?0:t,r=e.max,o=void 0===r?5:r,u=e.shape,l=void 0===u?"star":u,c=e.width,f=void 0===c?20:c,p=e.height,d=void 0===p?20:p,v=e.color,h=void 0===v?"black":v,y={color:h,width:f,height:d},m=Math.round(2*n)/2,b=[],g=0;g<o;g++){var _="full_"+l;g+.5===m?_="o_half_"+l:g>=Math.floor(m)&&(_="o_"+l),b.push(i.default.createElement(s.default,a({},y,{icon:_})))}return i.default.createElement("div",{className:"fit-rating"},b)}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(1),i=r(u),l=n(16),s=r(l);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=e.label,r=o(e,["children","label"]);return i.default.createElement("label",null,n,i.default.createElement("select",r,t))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=o(e,["children"]);return i.default.createElement("option",n,t)}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),s=r(l),c=n(8),f=r(c),p=n(9),d=r(p),v=n(12),h=r(v),y=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={attachments:n.props.attachments||{}},n}return u(t,e),i(t,[{key:"componentWillReceiveProps",value:function(e){this.setState({attachments:e.attachments||{}})}},{key:"render",value:function(){var e=this.state.attachments,t=this.props,n=t.name,r=t.onAttach,o=t.onAbort,a=t.text,u=t.hint;return s.default.createElement("div",{className:"fit-simple-uploader"},s.default.createElement(h.default,u,s.default.createElement(d.default,{name:n,text:a,onAttach:r})),s.default.createElement(f.default,{attachments:e,onAbort:o,autoGrow:!0}))}}]),t}(l.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=e.caption,r=e.classes,a=o(e,["children","caption","classes"]),i=r?" "+r:"";return l.default.createElement("span",u({className:"fit-status"+i},a),n?n:t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);n(76),t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.refresh=t.clock_o=t.check=t.o_heart=t.full_heart=t.o_half_star=t.o_star=t.full_star=void 0;var o=n(47),a=r(o),u=n(50),i=r(u),l=n(48),s=r(l),c=n(46),f=r(c),p=n(49),d=r(p),v=n(44),h=r(v),y=n(45),m=r(y),b=n(51),g=r(b);t.full_star=a.default,t.o_star=i.default,t.o_half_star=s.default,t.full_heart=f.default,t.o_heart=d.default,t.check=h.default,t.clock_o=m.default,t.refresh=g.default},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1024 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M896 1664q-26 0-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344q0 221-229 450l-623 600q-18 18-44 18z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1250 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zm452-262l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1664 596q0-81-21.5-143t-55-98.5-81.5-59.5-94-31-98-8-112 25.5-110.5 64-86.5 72-60 61.5q-18 22-49 22t-49-22q-24-28-60-61.5t-86.5-72-110.5-64-112-25.5-98 8-94 31-81.5 59.5-55 98.5-21.5 143q0 168 187 355l581 560 580-559q188-188 188-356zm128 0q0 221-229 450l-623 600q-18 18-44 18t-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1201 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zm527-357q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z";
t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z";t.default=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.url,n=void 0===t?"#!":t,r=e.text;return r?u.default.createElement("a",{href:n,className:"fit-tag"},r):null}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(78),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.tags,n=void 0===t?[]:t,r="fit-tag-list";return u.default.createElement("ul",{className:r},n.map(function(e,t){return u.default.createElement("li",{key:t},u.default.createElement(l.default,{text:e.text,url:e.url}))}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a),i=n(52),l=r(i);n(79),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),c=r(s),f=n(17),p=r(f),d=n(8),v=r(d),h=n(9),y=r(h),m=n(12),b=r(m);n(81);var g=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={attachments:e.attachments||{},value:e.value||""},n}return u(t,e),l(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.state.value,n=e.value||t,r=n===t?t:n;this.setState({attachments:e.attachments||{},value:r})}},{key:"render",value:function(){var e=this,t=this.state.attachments,n=this.props,r=n.attachmentName,o=n.onAttach,a=n.onAbort,u=n.hint,l=n.children,s=Object.keys(t).length>0,f=s?" has-attachments":"";return c.default.createElement("div",{className:"fit-textarea-attachment"+f},c.default.createElement(p.default,i({},this.props,{ref:function(t){return t?e.textarea=t.textarea:null}}),l,c.default.createElement(b.default,u,c.default.createElement(y.default,{name:r,onAttach:o}))),c.default.createElement(v.default,{attachments:t,onAbort:a}))}}]),t}(s.Component);t.default=g},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.toggleName,n=o(e,["toggleName"]);return l.default.createElement("span",{className:"toggle-wrapper"},l.default.createElement("label",{htmlFor:"toggle"+t},l.default.createElement("input",u({type:"checkbox",id:"toggle"+t},n)),l.default.createElement("span",{className:"fake-toggle"})))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);n(82),a.propTypes={toggleName:l.default.PropTypes.string.isRequired,checked:l.default.PropTypes.bool,defaultChecked:l.default.PropTypes.bool,onChange:l.default.PropTypes.func},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),s=(r(l),n(89)),c=r(s),f=n(62),p=r(f),d=n(63),v=r(d),h={isActive:!1,inputValue:"",selectedOption:null,activeOptionIndex:0},y=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),r={isActive:n.props.defaultIsActive,inputValue:n.props.defaultInputValue,selectedOption:n.props.defaultSelectedOption,activeOptionIndex:0};return!r.selectedOption||"string"==typeof r.selectedOption&&"number"==typeof r.selectedOption||(r.inputValue=n.props.optionToString(r.selectedOption)),n.controlledOptions=[],n.getOptionProps=n.getOptionProps.bind(n),n.getTextInputProps=n.getTextInputProps.bind(n),n.getMenuButtonProps=n.getMenuButtonProps.bind(n),n.getClearButtonProps=n.getClearButtonProps.bind(n),n.handleInputChange=n.handleInputChange.bind(n),n.handleInputKeyUp=n.handleInputKeyUp.bind(n),n.toggleActive=n.toggleActive.bind(n),n.reset=n.reset.bind(n),n.setActiveFalse=n.setActive.bind(n,!1),n.setActiveTrue=n.setActive.bind(n,!0),n.state=r,n}return u(t,e),i(t,[{key:"componentWillUpdate",value:function(){this.resetControlledOptions()}},{key:"componentDidUpdate",value:function(e,t){(0,v.default)(this.state.selectedOption,t.selectedOption)||this.props.onChange(this.state.selectedOption)}},{key:"resetControlledOptions",value:function(){this.controlledOptions=[]}},{key:"getOptionAtIndex",value:function(e){return this.controlledOptions[e]}},{key:"setActive",value:function(e){this.setState(function(t){return Object.assign({},t,{isActive:e})})}},{key:"toggleActive",value:function(){this.setState(function(e){return Object.assign({},e,{isActive:!e.isActive})})}},{key:"handleInputChange",value:function(e){var t=e.target.value;this.setState(function(e){return Object.assign({},e,{isActive:!0,inputValue:t})})}},{key:"handleInputKeyUp",value:function(e){switch(e.which){case 13:this.handleEnter(e);break;case 38:this.setState(function(e){return Object.assign({},e,{activeOptionIndex:e.activeOptionIndex-1})});break;case 40:this.setState(function(e){return Object.assign({},e,{activeOptionIndex:e.activeOptionIndex+1})})}}},{key:"handleEnter",value:function(e){var t=e.target,n=null,r="";t.value&&(n=this.getOptionAtIndex(this.state.activeOptionIndex),r="string"==typeof n?n:this.props.optionToString(n)),this.setState(function(e){return Object.assign({},e,{isActive:!1,selectedOption:n,inputValue:r})})}},{key:"createOptionMouseEnterHandler",value:function(e){var t=this;return function(){t.setState(function(t){return Object.assign({},t,{activeOptionIndex:e})})}}},{key:"createOptionClickHandler",value:function(e){var t=this;return function(){var n="string"==typeof e?e:t.props.optionToString(e);t.setState(function(t){return Object.assign({},t,{isActive:!1,selectedOption:e,inputValue:n})})}}},{key:"reset",value:function(){this.setState(h)}},{key:"getTextInputProps",value:function(e){var t=this,n={type:"text"},r={onFocus:(0,p.default)(e.onFocus,this.setActiveTrue),onBlur:(0,p.default)(e.onBlur,function(){return setTimeout(t.setActiveFalse,150)}),onChange:(0,p.default)(e.onChange,this.handleInputChange),onKeyUp:(0,p.default)(e.onKeyUp,this.handleInputKeyUp)};return Object.assign({},n,e,r)}},{key:"getOptionProps",value:function(e){var t=e.option,n=this.controlledOptions.length,r={onMouseEnter:(0,p.default)(e.mouseEnter,this.createOptionMouseEnterHandler(n)),onClick:(0,p.default)(e.onClick,this.createOptionClickHandler(t))};if(!t)throw new Error("passing the option property to getOptionProps is required");return delete e.option,this.controlledOptions.push(t),Object.assign({},e,r)}},{key:"getMenuButtonProps",value:function(e){var t={onClick:(0,p.default)(e.onClick,this.toggleActive)};return Object.assign({},e,t)}},{key:"getClearButtonProps",value:function(e){var t={onClick:(0,p.default)(e.onClick,this.reset)};return Object.assign({},e,t)}},{key:"getStateAndHelpers",value:function(){var e=this.state,t=e.isActive,n=e.inputValue,r=e.selectedOption,o=e.activeOptionIndex,a=this.getTextInputProps,u=this.getOptionProps,i=this.getMenuButtonProps,l=this.getClearButtonProps;return{isActive:t,inputValue:n,selectedOption:r,getTextInputProps:a,getMenuButtonProps:i,getClearButtonProps:l,getOptionProps:u,activeOptionIndex:o}}},{key:"render",value:function e(){var t=this.props,e=t.render,n=t.children;if("function"!=typeof e&&"function"!=typeof n)throw new Error("you must provide either a child function or a render property to typeaheadselect");var r=n||e,o=this.getStateAndHelpers();return r(o)}}]),t}(l.Component);y.propTypes={optionToString:c.default.func,onChange:c.default.func,defaultIsActive:c.default.bool,defaultInputValue:c.default.string,defaultSelectedOption:c.default.any},y.defaultProps={optionToString:function(e){return e},onChange:function(e){return e},defaultIsActive:!1,defaultInputValue:""},t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.TypeaheadSelect=t.Status=t.TagList=t.Rating=t.SvgIcon=t.ProgressRound=t.ProgressBar=t.Input=t.ToggleButton=t.TextareaAttachment=t.TextaraAttachment=t.Textarea=t.Breadcrumbs=t.PageAlert=t.Pagination=t.EasyTable=t.SimpleUploader=t.SimpleError=t.Select=t.Option=t.ErrorMessage=t.Radio=t.Checkbox=t.Collapsable=t.Currency=t.Cta=t.ButtonAttachment=t.Button=t.Avatar=t.AttachmentList=void 0;var o=n(1),a=(r(o),n(8)),u=r(a),i=n(27),l=r(i),s=n(29),c=r(s),f=n(9),p=r(f),d=n(33),v=r(d),h=n(34),y=r(h),m=n(54),b=r(m),g=n(15),_=r(g),O=n(55),P=r(O),E=n(32),j=r(E),x=n(31),w=r(x),M=n(14),k=r(M),N=n(37),C=r(N),A=n(40),T=r(A),S=n(39),I=r(S),q=n(10),R=r(q),D=n(41),F=r(D),B=n(36),Y=r(B),U=n(28),z=r(U),V=n(17),W=r(V),G=n(13),L=r(G),K=n(61),H=n(35),$=r(H),J=n(16),Q=r(J),X=n(38),Z=r(X),ee=n(53),te=r(ee),ne=n(42),re=r(ne),oe=n(56),ae=r(oe),ue=b.default;t.AttachmentList=u.default,t.Avatar=l.default,t.Button=c.default,t.ButtonAttachment=p.default,t.Cta=v.default,t.Currency=y.default,t.Collapsable=j.default,t.Checkbox=w.default,t.Radio=C.default,t.ErrorMessage=_.default,t.Option=T.default,t.Select=I.default,t.SimpleError=R.default,t.SimpleUploader=F.default,t.EasyTable=$.default,t.Pagination=k.default,t.PageAlert=Y.default,t.Breadcrumbs=z.default,t.Textarea=W.default,t.TextaraAttachment=ue,t.TextareaAttachment=b.default,t.ToggleButton=P.default,t.Input=L.default,t.ProgressBar=K.ProgressBar,t.ProgressRound=K.ProgressRound,t.SvgIcon=Q.default,t.Rating=Z.default,t.TagList=te.default,t.Status=re.default,t.TypeaheadSelect=ae.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.value,n=e.max,r=void 0===n?1:n,o=t/r*100;return u.default.createElement("div",{className:"fit-progress-bar"},u.default.createElement("span",{className:"fill",style:{width:o+"%"}}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(83),o.propTypes={value:u.default.PropTypes.number,max:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(58),a=r(o);t.default=a.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.progress,n=void 0===t?0:t,r=204,o={strokeDasharray:r,strokeDashoffset:r},a=function(e){var t=r*e/100;return Object.assign({},o,{strokeDashoffset:r-t})},l=a(n);return u.default.createElement("div",{className:"fit-round-progress"},u.default.createElement("div",{className:"back-layer"}),u.default.createElement("svg",{viewBox:"-1 -1 71 71"},u.default.createElement("path",{d:i,style:l})))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(84);var i="m35,2.5c17.955803,0 32.5,14.544199 32.5,32.5c0,17.955803 -14.544197,32.5 -32.5,32.5c-17.955803,0 -32.5,-14.544197 -32.5,-32.5c0,-17.955801 14.544197,-32.5 32.5,-32.5z";o.propTypes={progress:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.ProgressBar=t.ProgressRound=void 0;var o=n(18),a=r(o),u=n(59),i=r(u);t.ProgressRound=a.default,t.ProgressBar=i.default},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return t.forEach(function(e){return e&&e.apply(void 0,n)})}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=function(e,t){if(e===t)return!0;if("undefined"==typeof e||"undefined"==typeof t)return e===t;if(null===e||null===t||"object"!==("undefined"==typeof e?"undefined":n(e))&&"object"!==("undefined"==typeof t?"undefined":n(t)))return e!==e&&t!==t;var r=Array.isArray(e),o=Array.isArray(t);if(r!==o)return!1;if(r&&o){if(e.length!==t.length)return!1;for(var a=0;a<e.length;a++)if(e[a]!==t[a])return!1}var u=Object.keys(e),i=Object.keys(t);if(u.length!==i.length)return!1;for(var l=0;l<u.length;l++)if(u[l]!==i[l]||e[u[l]]!==t[i[l]])return!1;return!0}},function(e,t,n){"use strict";function r(e){return e}function o(e,t,n){function o(e,t){var n=b.hasOwnProperty(t)?b[t]:null;E.hasOwnProperty(t)&&l("OVERRIDE_BASE"===n,"ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",t),e&&l("DEFINE_MANY"===n||"DEFINE_MANY_MERGED"===n,"ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",t)}function a(e,n){if(n){l("function"!=typeof n,"ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."),l(!t(n),"ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");var r=e.prototype,a=r.__reactAutoBindPairs;n.hasOwnProperty(s)&&_.mixins(e,n.mixins);for(var u in n)if(n.hasOwnProperty(u)&&u!==s){var i=n[u],c=r.hasOwnProperty(u);if(o(c,u),_.hasOwnProperty(u))_[u](e,i);else{var f=b.hasOwnProperty(u),v="function"==typeof i,h=v&&!f&&!c&&n.autobind!==!1;if(h)a.push(u,i),r[u]=i;else if(c){var y=b[u];l(f&&("DEFINE_MANY_MERGED"===y||"DEFINE_MANY"===y),"ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",y,u),"DEFINE_MANY_MERGED"===y?r[u]=p(r[u],i):"DEFINE_MANY"===y&&(r[u]=d(r[u],i))}else r[u]=i}}}else;}function c(e,t){if(t)for(var n in t){var r=t[n];if(t.hasOwnProperty(n)){var o=n in _;l(!o,'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',n);var a=n in e;if(a){var u=g.hasOwnProperty(n)?g[n]:null;return l("DEFINE_MANY_MERGED"===u,"ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",n),void(e[n]=p(e[n],r))}e[n]=r}}}function f(e,t){l(e&&t&&"object"==typeof e&&"object"==typeof t,"mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.");for(var n in t)t.hasOwnProperty(n)&&(l(void 0===e[n],"mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",n),e[n]=t[n]);return e}function p(e,t){return function(){var n=e.apply(this,arguments),r=t.apply(this,arguments);if(null==n)return r;if(null==r)return n;var o={};return f(o,n),f(o,r),o}}function d(e,t){return function(){e.apply(this,arguments),t.apply(this,arguments)}}function v(e,t){var n=t.bind(e);return n}function h(e){for(var t=e.__reactAutoBindPairs,n=0;n<t.length;n+=2){var r=t[n],o=t[n+1];e[r]=v(e,o)}}function y(e){var t=r(function(e,r,o){this.__reactAutoBindPairs.length&&h(this),this.props=e,this.context=r,this.refs=i,this.updater=o||n,this.state=null;var a=this.getInitialState?this.getInitialState():null;l("object"==typeof a&&!Array.isArray(a),"%s.getInitialState(): must return an object or null",t.displayName||"ReactCompositeComponent"),this.state=a});t.prototype=new j,t.prototype.constructor=t,t.prototype.__reactAutoBindPairs=[],m.forEach(a.bind(null,t)),a(t,O),a(t,e),a(t,P),t.getDefaultProps&&(t.defaultProps=t.getDefaultProps()),l(t.prototype.render,"createClass(...): Class specification must implement a `render` method.");for(var o in b)t.prototype[o]||(t.prototype[o]=null);return t}var m=[],b={mixins:"DEFINE_MANY",statics:"DEFINE_MANY",propTypes:"DEFINE_MANY",contextTypes:"DEFINE_MANY",childContextTypes:"DEFINE_MANY",getDefaultProps:"DEFINE_MANY_MERGED",getInitialState:"DEFINE_MANY_MERGED",getChildContext:"DEFINE_MANY_MERGED",render:"DEFINE_ONCE",componentWillMount:"DEFINE_MANY",componentDidMount:"DEFINE_MANY",componentWillReceiveProps:"DEFINE_MANY",shouldComponentUpdate:"DEFINE_ONCE",componentWillUpdate:"DEFINE_MANY",componentDidUpdate:"DEFINE_MANY",componentWillUnmount:"DEFINE_MANY",UNSAFE_componentWillMount:"DEFINE_MANY",UNSAFE_componentWillReceiveProps:"DEFINE_MANY",UNSAFE_componentWillUpdate:"DEFINE_MANY",updateComponent:"OVERRIDE_BASE"},g={getDerivedStateFromProps:"DEFINE_MANY_MERGED"},_={displayName:function(e,t){e.displayName=t},mixins:function(e,t){if(t)for(var n=0;n<t.length;n++)a(e,t[n])},childContextTypes:function(e,t){e.childContextTypes=u({},e.childContextTypes,t)},contextTypes:function(e,t){e.contextTypes=u({},e.contextTypes,t)},getDefaultProps:function(e,t){e.getDefaultProps?e.getDefaultProps=p(e.getDefaultProps,t):e.getDefaultProps=t},propTypes:function(e,t){e.propTypes=u({},e.propTypes,t)},statics:function(e,t){c(e,t)},autobind:function(){}},O={componentDidMount:function(){this.__isMounted=!0}},P={componentWillUnmount:function(){this.__isMounted=!1}},E={replaceState:function(e,t){this.updater.enqueueReplaceState(this,e,t)},isMounted:function(){return!!this.__isMounted}},j=function(){};return u(j.prototype,e.prototype,E),y}var a,u=n(4),i=n(19),l=n(2),s="mixins";a={},e.exports=o},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";function r(e,t,n,r,o){}e.exports=r},function(e,t,n){"use strict";var r=n(88);e.exports=function(e){var t=!1;return r(e,t)}},function(e,t,n){"use strict";var r=n(5),o=n(2),a=n(20);e.exports=function(){function e(e,t,n,r,u,i){i!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";var r=n(5),o=n(2),a=n(6),u=n(4),i=n(20),l=n(85);e.exports=function(e,t){function n(e){var t=e&&(N&&e[N]||e[C]);if("function"==typeof t)return t}function s(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function c(e){this.message=e,this.stack=""}function f(e){function n(n,r,a,u,l,s,f){if(u=u||A,s=s||a,f!==i)if(t)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else;return null==r[a]?n?new c(null===r[a]?"The "+l+" `"+s+"` is marked as required "+("in `"+u+"`, but its value is `null`."):"The "+l+" `"+s+"` is marked as required in "+("`"+u+"`, but its value is `undefined`.")):null:e(r,a,u,l,s)}var r=n.bind(null,!1);return r.isRequired=n.bind(null,!0),r}function p(e){function t(t,n,r,o,a,u){var i=t[n],l=x(i);if(l!==e){var s=w(i);return new c("Invalid "+o+" `"+a+"` of type "+("`"+s+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return f(t)}function d(){return f(r.thatReturnsNull)}function v(e){function t(t,n,r,o,a){if("function"!=typeof e)return new c("Property `"+a+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var u=t[n];if(!Array.isArray(u)){var l=x(u);return new c("Invalid "+o+" `"+a+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an array."))}for(var s=0;s<u.length;s++){var f=e(u,s,r,o,a+"["+s+"]",i);if(f instanceof Error)return f}return null}return f(t)}function h(){function t(t,n,r,o,a){var u=t[n];if(!e(u)){var i=x(u);return new c("Invalid "+o+" `"+a+"` of type "+("`"+i+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return f(t)}function y(e){function t(t,n,r,o,a){if(!(t[n]instanceof e)){var u=e.name||A,i=k(t[n]);return new c("Invalid "+o+" `"+a+"` of type "+("`"+i+"` supplied to `"+r+"`, expected ")+("instance of `"+u+"`."))}return null}return f(t)}function m(e){function t(t,n,r,o,a){for(var u=t[n],i=0;i<e.length;i++)if(s(u,e[i]))return null;var l=JSON.stringify(e);return new c("Invalid "+o+" `"+a+"` of value `"+u+"` "+("supplied to `"+r+"`, expected one of "+l+"."))}return Array.isArray(e)?f(t):r.thatReturnsNull}function b(e){function t(t,n,r,o,a){if("function"!=typeof e)return new c("Property `"+a+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var u=t[n],l=x(u);if("object"!==l)return new c("Invalid "+o+" `"+a+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an object."));for(var s in u)if(u.hasOwnProperty(s)){var f=e(u,s,r,o,a+"."+s,i);if(f instanceof Error)return f}return null}return f(t)}function g(e){function t(t,n,r,o,a){for(var u=0;u<e.length;u++){var l=e[u];if(null==l(t,n,r,o,a,i))return null}return new c("Invalid "+o+" `"+a+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return r.thatReturnsNull;for(var n=0;n<e.length;n++){var o=e[n];if("function"!=typeof o)return a(!1,"Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",M(o),n),r.thatReturnsNull}return f(t)}function _(){function e(e,t,n,r,o){return E(e[t])?null:new c("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return f(e)}function O(e){function t(t,n,r,o,a){var u=t[n],l=x(u);if("object"!==l)return new c("Invalid "+o+" `"+a+"` of type `"+l+"` "+("supplied to `"+r+"`, expected `object`."));for(var s in e){var f=e[s];if(f){var p=f(u,s,r,o,a+"."+s,i);if(p)return p}}return null}return f(t)}function P(e){function t(t,n,r,o,a){var l=t[n],s=x(l);if("object"!==s)return new c("Invalid "+o+" `"+a+"` of type `"+s+"` "+("supplied to `"+r+"`, expected `object`."));var f=u({},t[n],e);for(var p in f){var d=e[p];if(!d)return new c("Invalid "+o+" `"+a+"` key `"+p+"` supplied to `"+r+"`.\nBad object: "+JSON.stringify(t[n],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var v=d(l,p,r,o,a+"."+p,i);if(v)return v}return null}return f(t)}function E(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(E);if(null===t||e(t))return!0;var r=n(t);if(!r)return!1;var o,a=r.call(t);if(r!==t.entries){for(;!(o=a.next()).done;)if(!E(o.value))return!1}else for(;!(o=a.next()).done;){var u=o.value;if(u&&!E(u[1]))return!1}return!0;default:return!1}}function j(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function x(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":j(t,e)?"symbol":t}function w(e){if("undefined"==typeof e||null===e)return""+e;var t=x(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function M(e){var t=w(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function k(e){return e.constructor&&e.constructor.name?e.constructor.name:A}var N="function"==typeof Symbol&&Symbol.iterator,C="@@iterator",A="<<anonymous>>",T={array:p("array"),bool:p("boolean"),func:p("function"),number:p("number"),object:p("object"),string:p("string"),symbol:p("symbol"),any:d(),arrayOf:v,element:h(),instanceOf:y,node:_(),objectOf:b,oneOf:m,oneOfType:g,shape:O,exact:P};return c.prototype=Error.prototype,T.checkPropTypes=l,T.PropTypes=T,T}},function(e,t,n){e.exports=n(87)()},function(e,t){"use strict";function n(e){var t=/[=:]/g,n={"=":"=0",":":"=2"},r=(""+e).replace(t,function(e){return n[e]});return"$"+r}function r(e){var t=/(=0|=2)/g,n={"=0":"=","=2":":"},r="."===e[0]&&"$"===e[1]?e.substring(2):e.substring(1);return(""+r).replace(t,function(e){return n[e]})}var o={escape:n,unescape:r};e.exports=o},function(e,t,n){"use strict";var r=n(7),o=(n(2),function(e){var t=this;if(t.instancePool.length){var n=t.instancePool.pop();return t.call(n,e),n}return new t(e)}),a=function(e,t){var n=this;if(n.instancePool.length){var r=n.instancePool.pop();return n.call(r,e,t),r}return new n(e,t)},u=function(e,t,n){var r=this;if(r.instancePool.length){var o=r.instancePool.pop();return r.call(o,e,t,n),o}return new r(e,t,n)},i=function(e,t,n,r){var o=this;if(o.instancePool.length){var a=o.instancePool.pop();return o.call(a,e,t,n,r),a}return new o(e,t,n,r)},l=function(e){var t=this;e instanceof t?void 0:r("25"),e.destructor(),t.instancePool.length<t.poolSize&&t.instancePool.push(e)},s=10,c=o,f=function(e,t){var n=e;return n.instancePool=[],n.getPooled=t||c,n.poolSize||(n.poolSize=s),n.release=l,n},p={addPoolingTo:f,oneArgumentPooler:o,twoArgumentPooler:a,threeArgumentPooler:u,fourArgumentPooler:i};e.exports=p},function(e,t,n){"use strict";var r=n(4),o=n(21),a=n(93),u=n(94),i=n(3),l=n(95),s=n(96),c=n(97),f=n(100),p=i.createElement,d=i.createFactory,v=i.cloneElement,h=r,y=function(e){return e},m={Children:{map:a.map,forEach:a.forEach,count:a.count,toArray:a.toArray,only:f},Component:o.Component,PureComponent:o.PureComponent,createElement:p,cloneElement:v,isValidElement:i.isValidElement,PropTypes:l,createClass:c,createFactory:d,createMixin:y,DOM:u,version:s,__spread:h};e.exports=m},function(e,t,n){"use strict";function r(e){return(""+e).replace(_,"$&/")}function o(e,t){this.func=e,this.context=t,this.count=0}function a(e,t,n){var r=e.func,o=e.context;r.call(o,t,e.count++)}function u(e,t,n){if(null==e)return e;var r=o.getPooled(t,n);m(e,a,r),o.release(r)}function i(e,t,n,r){this.result=e,this.keyPrefix=t,this.func=n,this.context=r,this.count=0}function l(e,t,n){var o=e.result,a=e.keyPrefix,u=e.func,i=e.context,l=u.call(i,t,e.count++);Array.isArray(l)?s(l,o,n,y.thatReturnsArgument):null!=l&&(h.isValidElement(l)&&(l=h.cloneAndReplaceKey(l,a+(!l.key||t&&t.key===l.key?"":r(l.key)+"/")+n)),o.push(l))}function s(e,t,n,o,a){var u="";null!=n&&(u=r(n)+"/");var s=i.getPooled(t,u,o,a);m(e,l,s),i.release(s)}function c(e,t,n){if(null==e)return e;var r=[];return s(e,r,null,t,n),r}function f(e,t,n){return null}function p(e,t){return m(e,f,null)}function d(e){var t=[];return s(e,t,null,y.thatReturnsArgument),t}var v=n(91),h=n(3),y=n(5),m=n(101),b=v.twoArgumentPooler,g=v.fourArgumentPooler,_=/\/+/g;o.prototype.destructor=function(){this.func=null,this.context=null,this.count=0},v.addPoolingTo(o,b),i.prototype.destructor=function(){this.result=null,this.keyPrefix=null,this.func=null,this.context=null,this.count=0},v.addPoolingTo(i,g);var O={forEach:u,map:c,mapIntoWithKeyPrefixInternal:s,count:p,toArray:d};e.exports=O},function(e,t,n){"use strict";var r=n(3),o=r.createFactory,a={a:o("a"),abbr:o("abbr"),address:o("address"),area:o("area"),article:o("article"),aside:o("aside"),audio:o("audio"),b:o("b"),base:o("base"),bdi:o("bdi"),bdo:o("bdo"),big:o("big"),blockquote:o("blockquote"),body:o("body"),br:o("br"),button:o("button"),canvas:o("canvas"),caption:o("caption"),cite:o("cite"),code:o("code"),col:o("col"),colgroup:o("colgroup"),data:o("data"),datalist:o("datalist"),dd:o("dd"),del:o("del"),details:o("details"),dfn:o("dfn"),dialog:o("dialog"),div:o("div"),dl:o("dl"),dt:o("dt"),em:o("em"),embed:o("embed"),fieldset:o("fieldset"),figcaption:o("figcaption"),figure:o("figure"),footer:o("footer"),form:o("form"),h1:o("h1"),h2:o("h2"),h3:o("h3"),h4:o("h4"),h5:o("h5"),h6:o("h6"),head:o("head"),header:o("header"),hgroup:o("hgroup"),hr:o("hr"),html:o("html"),i:o("i"),iframe:o("iframe"),img:o("img"),input:o("input"),ins:o("ins"),kbd:o("kbd"),keygen:o("keygen"),label:o("label"),legend:o("legend"),li:o("li"),link:o("link"),main:o("main"),map:o("map"),mark:o("mark"),menu:o("menu"),menuitem:o("menuitem"),meta:o("meta"),meter:o("meter"),nav:o("nav"),noscript:o("noscript"),object:o("object"),ol:o("ol"),optgroup:o("optgroup"),option:o("option"),output:o("output"),p:o("p"),param:o("param"),picture:o("picture"),pre:o("pre"),progress:o("progress"),q:o("q"),rp:o("rp"),rt:o("rt"),ruby:o("ruby"),s:o("s"),samp:o("samp"),script:o("script"),section:o("section"),select:o("select"),small:o("small"),source:o("source"),span:o("span"),strong:o("strong"),style:o("style"),sub:o("sub"),summary:o("summary"),sup:o("sup"),table:o("table"),tbody:o("tbody"),td:o("td"),textarea:o("textarea"),tfoot:o("tfoot"),th:o("th"),thead:o("thead"),time:o("time"),title:o("title"),tr:o("tr"),track:o("track"),u:o("u"),ul:o("ul"),var:o("var"),video:o("video"),wbr:o("wbr"),circle:o("circle"),clipPath:o("clipPath"),defs:o("defs"),ellipse:o("ellipse"),g:o("g"),image:o("image"),line:o("line"),linearGradient:o("linearGradient"),mask:o("mask"),path:o("path"),pattern:o("pattern"),polygon:o("polygon"),polyline:o("polyline"),radialGradient:o("radialGradient"),rect:o("rect"),stop:o("stop"),svg:o("svg"),text:o("text"),tspan:o("tspan")};e.exports=a},function(e,t,n){"use strict";var r=n(3),o=r.isValidElement,a=n(86);e.exports=a(o)},function(e,t){"use strict";e.exports="15.6.2"},function(e,t,n){"use strict";var r=n(21),o=r.Component,a=n(3),u=a.isValidElement,i=n(24),l=n(64);e.exports=l(o,u,i)},function(e,t){"use strict";function n(e){var t=e&&(r&&e[r]||e[o]);if("function"==typeof t)return t}var r="function"==typeof Symbol&&Symbol.iterator,o="@@iterator";e.exports=n},function(e,t,n){"use strict";var r=function(){};e.exports=r},function(e,t,n){"use strict";function r(e){return a.isValidElement(e)?void 0:o("143"),e}var o=n(7),a=n(3);n(2);e.exports=r},function(e,t,n){"use strict";function r(e,t){return e&&"object"==typeof e&&null!=e.key?s.escape(e.key):t.toString(36)}function o(e,t,n,a){var p=typeof e;if("undefined"!==p&&"boolean"!==p||(e=null),null===e||"string"===p||"number"===p||"object"===p&&e.$$typeof===i)return n(a,e,""===t?c+r(e,0):t),
1;var d,v,h=0,y=""===t?c:t+f;if(Array.isArray(e))for(var m=0;m<e.length;m++)d=e[m],v=y+r(d,m),h+=o(d,v,n,a);else{var b=l(e);if(b){var g,_=b.call(e);if(b!==e.entries)for(var O=0;!(g=_.next()).done;)d=g.value,v=y+r(d,O++),h+=o(d,v,n,a);else for(;!(g=_.next()).done;){var P=g.value;P&&(d=P[1],v=y+s.escape(P[0])+f+r(d,0),h+=o(d,v,n,a))}}else if("object"===p){var E="",j=String(e);u("31","[object Object]"===j?"object with keys {"+Object.keys(e).join(", ")+"}":j,E)}}return h}function a(e,t,n){return null==e?0:o(e,"",t,n)}var u=n(7),i=(n(22),n(23)),l=n(98),s=(n(2),n(90)),c=(n(6),"."),f=":";e.exports=a}])});

/***/ }),

/***/ "too7":
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * get "one" or "other" from translation key item
 * @param  {Any} result
 * @param  {Object} data
 * @return {String}
 */
module.exports = function getOneOther(result, data) {
    if (isOneOther(result, data)) {
        return Number(data.count) === 1 ? result.one : result.other;
    }

    return result;
};

/**
 * Check conditions for a one/other use case
 * @param  {Object|Any} result
 * @param  {Object|Any} data
 * @return {Boolean} The conditions meet a one/other use case
 */
var isOneOther = function isOneOther(result, data) {
    return (typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && result.hasOwnProperty('one') && result.hasOwnProperty('other') && data.hasOwnProperty('count');
};

/***/ }),

/***/ "vUzd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__("W2D2");

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),

/***/ "wqO5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("BEQ0");

var emptyObject = __webpack_require__("TJez");
var _invariant = __webpack_require__("cxPT");

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ "xZFr":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || // eslint-disable-line no-undef
(typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.window === window && window;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "xZmo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y3TV":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "yhus":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ykZ/":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @module @fiverr/i18n/singleton
 * @since 1.2.0
 */

var I18n = __webpack_require__("z5Da");

/**
 * Shortcut to I18n's singleton
 * @type {I18n}
 */
module.exports = I18n.singleton;

/***/ }),

/***/ "ysQM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z2GC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z5Da":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module i18n
 * @since 1.0.0
 */

var get = __webpack_require__("y3TV");
var paraphrase = __webpack_require__("Hhlq");
var merge = __webpack_require__("mB6w");
var _global = __webpack_require__("xZFr");
var freeze = __webpack_require__("TxmA");
var getOneOther = __webpack_require__("too7");
var jsonclone = __webpack_require__("KhmI");

var TRANSLATIONS = typeof Symbol === 'function' ? Symbol() : '_translations';
var MISSING = typeof Symbol === 'function' ? Symbol() : '_missing';
var MEMORY = typeof Symbol === 'function' ? Symbol() : '_memory';

var interpolate = paraphrase(/\${([^{}]*)}/g, /%{([^{}]*)}/g, /{{([^{}]*)}}/g);

/**
 * @class I18n
 * @classdesc an object capable of translating keys and interpolate using given data object
 * @param {Object<Object>}   options.translations JSON compliant object
 * @param {Object<String>}   [options.$scope]     Root string to be use for looking for translation keys
 * @param {Object<Function>} [options.missing]    Method to call when key is not found
 */

var I18n = function () {
    function I18n() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { translations: {}, $scope: undefined, missing: undefined },
            translations = _ref.translations,
            $scope = _ref.$scope,
            missing = _ref.missing;

        _classCallCheck(this, I18n);

        this[TRANSLATIONS] = freeze(jsonclone(translations));
        this[MISSING] = [];
        this[MEMORY] = {};
        this.onmiss(missing);
        this.$scope = $scope;

        this.translate = this.translate.bind(this);
    }

    /**
     @static getDefault
     * @param  {String} key
     * @return {String} A default string for a missing key
     */


    _createClass(I18n, [{
        key: 'add',


        /**
         * Add translation object(s)
         * @param {Object(s)} translations [description]
         * @return {self}
         */
        value: function add() {
            this[MEMORY] = {}; // clear key lookup memory

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            args.unshift({}, this.translations);
            this[TRANSLATIONS] = freeze(merge.apply(undefined, args));

            return this;
        }

        /**
         * translate
         * @param  {String} key    String representing dot notation
         * @param  {Object} [data] Interpolation data
         * @return {String} translated and interpolated
         */

    }, {
        key: 'translate',
        value: function translate(key, data) {
            var _this = this;

            var result = this.find.apply(this, _toConsumableArray([data, this].reduce(function (alternatives, item) {
                var base = get(item, '$scope');

                if (base !== undefined) {
                    alternatives.push([base, key].join('.'));
                }

                return alternatives;
            }, [key])));

            // Handle one,other translation structure
            result = getOneOther(result, data);

            switch (typeof result === 'undefined' ? 'undefined' : _typeof(result)) {
                case 'object':
                case 'number':
                case 'boolean':
                    return result;
                case 'string':
                    if (result) {
                        return interpolate(result, data);
                    }
                    break;
                default:
                    this[MISSING].forEach(function (fn) {
                        return fn(key, _this.$scope, _this.translations);
                    });
                    return I18n.getDefault(key);
            }
        }

        /**
         * find
         * @param  {...[String]} alternatives Different alternatives of strings to find
         * @return {Any} Found match on translations object
         */

    }, {
        key: 'find',
        value: function find() {
            for (var _len2 = arguments.length, alternatives = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                alternatives[_key2] = arguments[_key2];
            }

            var key = alternatives.shift();
            var result = this.resolve(key);
            var done = typeof result !== 'undefined' || alternatives.length === 0;

            return done ? result : this.find.apply(this, alternatives);
        }

        /**
         * Perform key lookup on the translation object and memoise the value
         * @param  {String} key
         * @return {Any}
         */

    }, {
        key: 'resolve',
        value: function resolve(key) {
            return this[MEMORY][key] = this[MEMORY].hasOwnProperty(key) ? this[MEMORY][key] : get(this.translations, key);
        }

        /**
         * Register callback to be called when a translation was missing.
         * Function accepts arguments: {String} missing key
         *                             {String} translation scope
         *                             {Object} The entire translation dictionary
         * @param  {Function} callback
         * @return {self}
         *
         * @example
         * i18n.onmiss((key) => logMissingKeyEvent({key: key.replace(/\W/g, '_'), })
         */

    }, {
        key: 'onmiss',
        value: function onmiss(callback) {
            typeof callback === 'function' && this[MISSING].push(callback);
            return this;
        }

        /**
         * Spawns a scoped child
         * @param  {String}    scope Namespace
         * @return {I18nChild}       I18nChild instance
         */

    }, {
        key: 'spawn',
        value: function spawn(scope) {
            return new I18nChild(this, scope);
        }

        /**
         * Make sure you only have one instance of I18n in your global scope
         * @return {I18n} the same instance every time
         *
         * @example
         * const i18n = I18n.singleton;
         */

    }, {
        key: 'translations',


        /**
         * translations
         * @return {Object} instance translations object
         */
        get: function get() {
            return this[TRANSLATIONS];
        }

        /**
         * t alias to translate
         * @return {Function}
         */

    }, {
        key: 't',
        get: function get() {
            return this.translate;
        }
    }], [{
        key: 'getDefault',
        value: function getDefault() {
            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            return key.split('.').pop().replace(/_/g, ' ');
        }
    }, {
        key: 'singleton',
        get: function get() {
            if (_global.i18n) {
                return _global.i18n;
            }

            var i18n = new I18n();

            try {
                Object.defineProperty(_global, 'i18n', {
                    value: i18n,
                    writable: false,
                    enumerable: false,
                    configurable: false
                });
            } catch (e) {
                _global.i18n = i18n;
            }

            return i18n;
        }
    }]);

    return I18n;
}();

/**
 * @class I18nChild
 * @extends I18n
 * @classdesc A child with the same capabilities and access but which translation keys may be namespcaed
 * @param  {String} [$scope]
 */


var I18nChild = function (_I18n) {
    _inherits(I18nChild, _I18n);

    function I18nChild(parent, $scope) {
        _classCallCheck(this, I18nChild);

        var _this2 = _possibleConstructorReturn(this, (I18nChild.__proto__ || Object.getPrototypeOf(I18nChild)).call(this));

        var scopeChain = [];

        parent.$scope && scopeChain.push(parent.$scope);
        $scope && scopeChain.push($scope);

        _this2.$scope = scopeChain.join('.') || undefined;
        _this2.parent = parent;
        return _this2;
    }

    /**
     * translations
     * @return {Object} parent's translations object
     */


    _createClass(I18nChild, [{
        key: 'add',


        /**
         * Passes the translations to the parent's store under the namespace
         * @param {...Object} args Translation objects
         */
        value: function add() {
            var _this3 = this;

            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            if (this.$scope) {
                var _parent;

                (_parent = this.parent).add.apply(_parent, _toConsumableArray(args.map(function (arg) {
                    var base = {};

                    _this3.$scope.split('.').reduce(function (base, item, index, array) {
                        base[item] = index === array.length - 1 ? arg : {};

                        return base[item];
                    }, base);

                    return base;
                })));
            } else {
                var _parent2;

                (_parent2 = this.parent).add.apply(_parent2, args);
            }

            return this;
        }
    }, {
        key: 'translations',
        get: function get() {
            return this.parent.translations;
        }
    }]);

    return I18nChild;
}(I18n);

module.exports = I18n;

/***/ }),

/***/ "z6RE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.2d5478965146889e5d6e.js